import { faEdit, faEye, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import "../styles/date_popup.css";
import AddClientContactPopUp from "./addClientContact_popup.js";
import AddClientNote from "./addClientNote_popup.js";
import AddClientQuestionnaire from "./addClientQuestionnaire_popup.js";
import AddClient from "./addClient_popup.js";
import AddLetter from "./addLetter";
import AddLetterBank from "./addLetterBank";
import AddLawsuit from "./addLawsuit.js";
import AddSpecialContent from "./addSpecialContent.js";
import AddClientSygnPopup from "./add_client_sygn_popup.js";
import AddClientRecommendation from "./addClientRecommendation.js";
import AddDate from "./add_date.js";
import AddFile from "./add_file.js";
import AddPayment from "./add_payment.js";
import AddTask from "./add_task.js";
import ClientAssignLawyerPopup from "./client_assign_lawyer.js";
import ClientContactPopUp from "./client_contact_popup.js";
import ClientSygnPopup from "./client_sygn_popup.js";
import DatePopUp from "./date_popup.js";
import EditBO from "./editBO.js";
import EditOdpPozw from "./editOdpPozw.js";
import EditClientAdditionalData from "./editClientAdditionalData.js";
import EditDG from "./editDG.js";
import EditDW from "./editDW.js";
import EditDZ from "./editDZ.js";
import EditLawsuitDate from "./editLawsuitDate.js";
import EditLawsuitData from "./editLawsuitData.js";
import EditWezwData from "./editWezwData.js";
import EditPP from "./editPP.js";
import EditPSP from "./editPSP.js";
import EditPU from "./editPU.js";
import EditPW from "./editPW.js";
import EditRep from "./editRep.js";
import EditWPS from "./editWPS.js";
import EditZP from "./editZP.js";
import EditZZ from "./editZZ.js";
import EditBankLawyer from "./editBankLawyer.js";
import AddPrintDate from "./addPrintDate.js";
import EditPelnSub from "./editPelnSub.js";
import EditBankLawOffice from "./editBankLawOffice.js";
import NotePopUp from "./note_popup.js";
import PaymentReport from "./payment_report.js";
import SendClientMail from "./sendClientMail.js";
import SendCourtMail from "./sendCourtMail.js";
import TaskPopUp from "./task_popup.js";
import LeadPopUp from "./lead_popup.js";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
import AddLawZaswDate from "./addLawZaswDate";
import AddLawZaswDate2 from "./addLawZaswDate2";
import AddLawZaswDate3 from "./addLawZaswDate3";
import AddBinderData from "./addBinderData";
import AddCounterClaim from "./addCounterClaim";
import AddPozN from "./addPozN";
import AddPotrCl from "./addPotrCl";
import LawsuitCheckList from "./lawsuitCheckList";
import AddNakZap from "./addNakZap";
import AddOpSP from "./addOpSP";
import LawsuitCheckListView from "./lawsuitCheckListView";
import AddCofCzP from "./addCofCzP";
import AddGetinSusp from "./addGetinSusp";
import EditClientRozCase from "./editClientRozCase";
import AddAmmountA from "./addAmmountA";
import AddTitleA from "./addTitleA";
import AddKomorA from "./addKomorA";
import AddNakDateA from "./addNakDateA";
import AddRodzPostA from "./addRodzPostA";
import AddConEpu from "./addConEpu";
import AddLogEpu from "./addLogEpu";
import AddWnpwuA from "./addWnpwu";
import EditNadPLN from "./editNadPLN";
import EditNadCHF from "./editNadCHF";
import AddSTS from "./addSTS";
import AddSUP from "./addSUP";
import AddSTSK from "./addSTSK";
import AddPou from "./addPou";

const MySwal = withReactContent(Swal2);

const ClientPopUp = (props) => {
  const [showAddSygnPopUp, setShowAddSygnPopUp] = useState(false);
  const [docMode, setDocMode] = useState("cat");
  const [docSort, setDocSord] = useState("down");
  const [showAddPrintDate, setShowAddPrintDate] = useState(false);
  const [showAddClientRecommendation, setShowAddClientRecommendation] =
    useState(false);
  const [showAddLawZaswDate, setShowAddLawZaswDate] = useState(false);
  const [showAddLawZaswDate2, setShowAddLawZaswDate2] = useState(false);
  const [showAddLawZaswDate3, setShowAddLawZaswDate3] = useState(false);
  const [showSygnPopUp, setShowSygnPopUp] = useState(false);
  const [showAssignLawyerPopUp, setShowAssignLawyerPopUp] = useState(false);
  const [expandFilters, setExpandFilters] = useState(false);
  const [tasksForClient, setTasksForClient] = useState([]);
  const [hearingsForClient, setHearingsForClient] = useState([]);
  const [contactsForClient, setContactsForClient] = useState([]);
  const [logUserFilter, setLogUserFilter] = useState("all");
  const [logUsers, setLogUsers] = useState([]);
  const [paymentsForClient, setPaymentsForClient] = useState([]);
  const [filesForClient, setFilesForClient] = useState([]);
  const [filesForClientOri, setFilesForClientOri] = useState([]);
  const [sygnForClient, setSygnForClient] = useState([]);
  const [transactionsData, setTransactionsData] = useState([]);
  const [logsForClient, setLogsForClient] = useState([]);
  const [showTask, setShowTask] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [dateId, setDateId] = useState("");
  const [curr, setCurr] = useState("");
  const [showAddClientContact, setShowAddClientContact] = useState(false);
  const [showSendClientMail, setShowSendClientMail] = useState(false);
  const [showSendCourtMail, setShowSendCourtMail] = useState(false);
  const [showClientContact, setShowClientContact] = useState(false);
  const [contactId, setContactId] = useState("");
  const [expand, setExpand] = useState("");
  const [courtAddress, setCourtAddress] = useState([]);
  const [courtMailAddress, setCourtMailAddress] = useState([]);
  const [showNotePopUp, setShowNotePopUp] = useState(false);
  const [noteContent, setNoteContent] = useState("");
  const [showPaymentReport, setShowPaymentReport] = useState(false);
  const [paymentReportId, setPaymentReportId] = useState("");
  const [showAddClient, setShowAddClient] = useState(false);
  const [showAddClientNote, setShowAddClientNote] = useState(false);
  const [showAddClientQuestionnaire, setShowAddClientQuestionnaire] =
    useState(false);
  const [editOption, setEditOption] = useState("all");
  const [showSpecialContent, setShowSpecialContent] = useState(false);
  const [specialContent, setSpecialContent] = useState("");
  const [showAddTask, setShowAddTask] = useState(false);
  const [showAddDate, setShowAddDate] = useState(false);
  const [showEditLawsuitDate, setShowEditLawsuitDate] = useState(false);
  const [showEditWPS, setShowEditWPS] = useState(false);
  const [showEditNadPLN, setShowEditNadPLN] = useState(false);
  const [showEditNadCHF, setShowEditNadCHF] = useState(false);
  const [showEditRep, setShowEditRep] = useState(false);
  const [showEditPU, setShowEditPU] = useState(false);
  const [showEditPou, setShowEditPou] = useState(false);
  const [showEditZZ, setShowEditZZ] = useState(false);
  const [showEditRozCase, setShowEditRozCase] = useState(false);
  const [showEditZP, setShowEditZP] = useState(false);
  const [showEditDG, setShowEditDG] = useState(false);
  const [showEditDZ, setShowEditDZ] = useState(false);
  const [showEditPW, setShowEditPW] = useState(false);
  const [showEditDW, setShowEditDW] = useState(false);
  const [showEditPP, setShowEditPP] = useState(false);
  const [showEditBO, setShowEditBO] = useState(false);
  const [showEditWezwData, setShowEditWezwData] = useState(false);
  const [showLawsuitData, setShowLawsuitData] = useState(false);
  const [showEditClientAdditionalData, setShowEditClientAdditionalData] =
    useState(false);
  const [editClientAdditionalDataId, setEditClientAdditionalDataId] =
    useState("");
  const [showEditOdpPozw, setShowEditOdpPozw] = useState(false);
  const [showEditBankLawyer, setShowEditBankLawyer] = useState(false);
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [showEditBankLawOffice, setShowEditBankLawOffice] = useState(false);
  const [showAddLetter, setShowAddLetter] = useState(false);
  const [showAddLetterBank, setShowAddLetterBank] = useState(false);
  const [showAddLawsuit, setShowAddLawsuit] = useState(false);
  const [showAddPozN, setShowAddPozN] = useState(false);
  const [showAddPotrCl, setShowAddPotrCl] = useState(false);
  const [showAddCofCzP, setShowAddCofCzP] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showEditPSP, setShowEditPSP] = useState(false);
  const [tabIndex, setTabIndex] = useState(props.tabIndex);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("send");
  const [loading, setLoading] = useState(true);
  const [clientsData, setClientsData] = useState(true);
  const [clientAdditionalData, setClientAdditionalData] = useState([]);
  const [showAddFile, setShowAddFile] = useState(false);
  const [showLeadPopUp, setShowLeadPopUp] = useState(false);
  const [showGetinSusp, setShowGetinSusp] = useState(false);
  const [showBinderData, setShowBinderData] = useState(false);
  const [showCounterclaim, setShowCounterclaim] = useState(false);
  const [leadC, setLeadC] = useState("");
  const [users, setUsers] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [bankLawOffice, setBankLawOffice] = useState([]);
  const [bankLawOfficeAddress, setBankLawOfficeAddress] = useState([]);
  const [showLawsuitChecklist, setShowLawsuitChecklist] = useState(false);
  const [showLawsuitChecklistView, setShowLawsuitChecklistView] =
    useState(false);
  const [showNakZap, setShowNakZap] = useState(false);
  const [showOpSP, setShowOpSP] = useState(false);
  const [lawsuits, setLawsuits] = useState([]);
  const [lawsuitsDetails, setLawsuitsDetails] = useState([]);
  const [lawsuitsProceedings, setLawsuitsProceedings] = useState([]);
  const [lawsuitsDocuments, setLawsuitsDocuments] = useState([]);
  const [lawsuitsDeliveries, setLawsuitsDeliveries] = useState([]);
  const [lawsuitsProceedingsFiles, setLawsuitsProceedingsFiles] = useState([]);
  const [lawsuitsDocumentsFiles, setLawsuitsDocumentsFiles] = useState([]);
  const [lawsuitsDeliveriesFiles, setLawsuitsDeliveriesFiles] = useState([]);
  const [lawsuitsExt, setLawsuitsExt] = useState(props.actualSygn);
  const [lawsuitsExtFiles, setLawsuitsExtFiles] = useState(props.actualSygn);
  const [lawsuitsCatFiles, setLawsuitsCatFiles] = useState("all");
  const [lawsuitsDeliveriesExt, setLawsuitsDeliveriesExt] = useState("");
  const [lawsuitsLoading, setLawsuitsLoading] = useState(true);
  const [sFile, setSFile] = useState("");
  const [showAmmountA, setShowAmmountA] = useState(false);
  const [showTitleA, setShowTitleA] = useState(false);
  const [showKomorA, setShowKomorA] = useState(false);
  const [showNakDateA, setShowNakDateA] = useState(false);
  const [showRodzPostA, setShowRodzPostA] = useState(false);
  const [showConEpuA, setShowConEpuA] = useState(false);
  const [showLogEpuA, setShowLogEpuA] = useState(false);
  const [showWnpwuA, setShowWnpwuA] = useState(false);
  const [showSTS, setShowSTS] = useState(false);
  const [showSTSK, setShowSTSK] = useState(false);
  const [showSUP, setShowSUP] = useState(false);

  var arrT = [];

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const getActualSygnForClient = () => {
    var sygns = sygnForClient.filter((el) => +el.clientId === +props.id);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const closeLeadPopUp = () => {
    setShowLeadPopUp(false);
  };

  const getActualCourtForClient = () => {
    var sygns = sygnForClient.filter((el) => +el.clientId === +props.id);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const handleShowAddClientQuestionnaire = (e) => {
    setShowAddClientQuestionnaire(true);
    setShowAddClient(false);
    setShowPaymentReport(false);
  };

  const closeEditLawsuitDate = (e) => {
    setShowAddPrintDate(false);
    getData();
  };

  const handleShowAddPrintDate = (e) => {
    setShowAddPrintDate(true);
  };

  const closeAddPrintDate = (e) => {
    setShowAddPrintDate(false);
    getData();
  };

  const handleShowAddLawZasw = (e) => {
    setShowAddLawZaswDate(true);
  };

  const handleShowEditPozN = (e) => {
    setShowAddPozN(true);
  };

  const handleShowEditPou = (e) => {
    setShowEditPou(true);
  };

  const handleShowEditPotrCl = (e) => {
    setShowAddPotrCl(true);
  };

  const handleShowEditCofCzP = (e) => {
    setShowAddCofCzP(true);
  };

  const handleShowEditRozCase = (e) => {
    setShowEditRozCase(true);
  };

  const closeAddLawZasw = (e) => {
    setShowAddLawZaswDate(false);
    getData();
  };

  const closeAddPozN = (e) => {
    setShowAddPozN(false);
    getData();
  };

  const closeAddPou = (e) => {
    setShowEditPou(false);
    getData();
  };

  const closeAddPotrCl = (e) => {
    setShowAddPotrCl(false);
    getData();
  };

  const closeAddCofCzP = (e) => {
    setShowAddCofCzP(false);
    getData();
  };

  const handleShowClientRecommendation = (e) => {
    setShowAddClientRecommendation(true);
  };

  const closeAddClientRecommendation = (e) => {
    setShowAddClientRecommendation(false);
    getData();
  };

  const handleShowAddLawZasw2 = (e) => {
    setShowAddLawZaswDate2(true);
  };

  const closeAddLawZasw2 = (e) => {
    setShowAddLawZaswDate2(false);
    getData();
  };

  const handleShowAddLawZasw3 = (e) => {
    setShowAddLawZaswDate3(true);
  };

  const closeAddLawZasw3 = (e) => {
    setShowAddLawZaswDate3(false);
    getData();
  };

  const handleShowBinderData = (e) => {
    setShowBinderData(true);
  };

  const handleShowNakZap = (e) => {
    setShowNakZap(true);
  };

  const closeBinderData = (e) => {
    setShowBinderData(false);
    getData();
  };

  const closeNakZap = (e) => {
    setShowNakZap(false);
    getData();
  };

  const handleShowGetinSusp = (e) => {
    setShowGetinSusp(true);
  };

  const closeGetinSusp = (e) => {
    setShowGetinSusp(false);
    getData();
  };

  const handleShowOpSP = (e) => {
    setShowOpSP(true);
  };

  const closeOpSP = (e) => {
    setShowOpSP(false);
    getData();
  };

  const handleShowCounterClaim = (e) => {
    setShowCounterclaim(true);
  };

  const closeCounterClaim = (e) => {
    setShowCounterclaim(false);
    getData();
  };

  const handleShowEditLawsuitDate = (e) => {
    setShowEditLawsuitDate(true);
  };

  const handleShowEditAdditionalData = (e) => {
    setShowEditClientAdditionalData(true);
  };

  const closeEditAdditionalData = (e) => {
    setShowEditClientAdditionalData(false);
    getData();
  };

  const closeEditRozCase = (e) => {
    setShowEditRozCase(false);
    getData();
  };

  const closeAddPayment = (e) => {
    setShowAddPayment(false);
    getData();
  };

  const handleShowAddPayment = (e) => {
    setShowAddPayment(true);
  };

  const handleShowEditOdpPozw = (e) => {
    setShowEditOdpPozw(true);
  };

  const closeEditOdpPozw = (e) => {
    setShowEditOdpPozw(false);
    getData();
  };

  const closeAddLetter = (e) => {
    setShowAddLetter(false);
    getData();
  };

  const closeAddLetterBank = (e) => {
    setShowAddLetterBank(false);
    getData();
  };

  const closeAddLawsuit = (e) => {
    setShowAddLawsuit(false);
    getData();
  };

  const handleShowAddLetter = (e) => {
    setShowAddLetter(true);
  };

  const handleShowAddLetterBank = (e) => {
    setShowAddLetterBank(true);
  };

  const handleShowAddLawsuit = (e) => {
    if (
      clientsData.wezwPayTime !== undefined &&
      clientsData.wezwPayTime !== null
    ) {
      setShowAddLawsuit(true);
    } else {
      MySwal.fire({
        icon: "error",
        title: "W pierwszej kolejności",
        text: "wygeneruj wezwanie do zapłaty",
      }).then(async (result) => {});
    }
  };

  const closeEditWPS = (e) => {
    setShowEditWPS(false);
    getData();
  };

  const closeEditNadPLN = (e) => {
    setShowEditNadPLN(false);
    getData();
  };

  const closeEditNadCHF = (e) => {
    setShowEditNadCHF(false);
    getData();
  };

  const handleShowEditWPS = (e) => {
    setShowEditWPS(true);
  };

  const handleShowEditNadPLN = (e) => {
    setShowEditNadPLN(true);
  };

  const handleShowEditNadCHF = (e) => {
    setShowEditNadCHF(true);
  };

  const closeEditRep = (e) => {
    setShowEditRep(false);
    getData();
  };

  const handleShowSendClientMail = (e) => {
    setShowSendClientMail(true);
  };

  const handleShowAddChecklist = (e) => {
    setShowLawsuitChecklist(true);
  };

  const handleShowAddChecklistView = (e) => {
    setShowLawsuitChecklistView(true);
  };

  const handleShowSendCourtMail = (e) => {
    setShowSendCourtMail(true);
  };

  const closeSendClientMail = (e) => {
    setShowSendClientMail(false);
    getData();
  };

  const closeSendCourtMail = (e) => {
    setShowSendCourtMail(false);
    getData();
  };

  const handleShowSendFile = (e) => {
    setShowAddFile(true);
  };

  const closeSendFile = (e) => {
    setShowAddFile(false);
    getData();
  };

  const handleShowEditRep = (e) => {
    setShowEditRep(true);
  };

  const closeEditZZ = (e) => {
    setShowEditZZ(false);
    getData();
  };

  const handleShowEditZZ = (e) => {
    setShowEditZZ(true);
  };

  const closeEditDG = (e) => {
    setShowEditDG(false);
    getData();
  };

  const handleShowEditDZ = (e) => {
    setShowEditDZ(true);
  };

  const closeEditDZ = (e) => {
    setShowEditDZ(false);
    getData();
  };

  const handleShowEditDG = (e) => {
    setShowEditDG(true);
  };

  const closeEditZP = (e) => {
    setShowEditZP(false);
    getData();
  };

  const handleShowEditZP = (e) => {
    setShowEditZP(true);
  };

  const closeEditBO = (e) => {
    setShowEditBO(false);
    getData();
  };

  const closeEditWezwData = (e) => {
    setShowEditWezwData(false);
    getData();
  };

  const closeLawsuitData = (e) => {
    setShowLawsuitData(false);
    getData();
  };

  const showLawsuitDataFu = (e) => {
    if (
      clientsData.wezwPayTime !== undefined &&
      clientsData.wezwPayTime !== null
    ) {
      setShowLawsuitData(true);
    } else {
      MySwal.fire({
        icon: "error",
        title: "W pierwszej kolejności",
        text: "wygeneruj wezwanie do zapłaty",
      }).then(async (result) => {});
    }
  };

  const handleShowEditBO = (e) => {
    setShowEditBO(true);
  };

  const closeEditPU = (e) => {
    setShowEditPU(false);
    getData();
  };

  const handleShowEditPU = (e) => {
    setShowEditPU(true);
  };

  const closeEditPW = (e) => {
    setShowEditPW(false);
    getData();
  };

  const handleShowEditPW = (e) => {
    setShowEditPW(true);
  };

  const closeEditDW = (e) => {
    setShowEditDW(false);
    getData();
  };

  const handleShowEditDW = (e) => {
    setShowEditDW(true);
  };

  const closeEditPP = (e) => {
    setShowEditPP(false);
    getData();
  };

  const handleShowEditPP = (e) => {
    setShowEditPP(true);
  };

  const closeEditPSP = (e) => {
    setShowEditPSP(false);
    getData();
  };

  const handleShowEditPSP = (e) => {
    setShowEditPSP(true);
  };

  const closeEditBankLawyer = (e) => {
    setShowEditBankLawyer(false);
    getData();
  };

  const handleShowEditBankLawOffice = (e) => {
    setShowEditBankLawOffice(true);
  };

  const closeEditBankLawOffice = (e) => {
    setShowEditBankLawOffice(false);
    getData();
  };

  const handleShowEditBankLawyer = (e) => {
    setShowEditBankLawyer(true);
  };

  const handleShowEditPelnSub = (e) => {
    setShowEditPelnSub(true);
  };

  const closeEditPelnSub = (e) => {
    setShowEditPelnSub(false);
    getData();
  };

  const closeAddClientQuestionnaire = (e) => {
    setShowAddClientQuestionnaire(false);
    getData();
  };

  const handleSetSpecialContent = (e) => {
    setSpecialContent(e.target.value);
  };

  const showAddTaskPopUp = (e) => {
    setShowAddTask(true);
  };

  const closeAddTaskPopUp = (e) => {
    setShowAddTask(false);
    getData();
  };

  const showAddDatePopUp = (e) => {
    setShowAddDate(true);
  };

  const closeAddDatePopUp = (e) => {
    setShowAddDate(false);
    getData();
  };

  const closeSpecialContent = (e) => {
    setShowSpecialContent(false);
    getData();
  };

  const handleShowAddClientNote = (e) => {
    setShowAddClientNote(true);
    setShowAddClient(false);
    setShowPaymentReport(false);
  };

  const closeAddClientNote = (e) => {
    setShowAddClientNote(false);
    getData();
  };

  const handleShowAddClient = (e) => {
    setEditOption(e.currentTarget.value);
    setShowAddClient(true);
    setShowPaymentReport(false);
    setShowAddClientQuestionnaire(false);
  };

  const closeAddClient = (e) => {
    setShowAddClient(false);
    getData();
  };

  const handleShowPaymentReport = (e) => {
    setPaymentReportId(e.currentTarget.value);
    setShowPaymentReport(true);
    setShowAddClient(false);
    setShowAddClientQuestionnaire(false);
  };

  const closePaymentReport = (e) => {
    setPaymentReportId("");
    setShowPaymentReport(false);
    getData();
  };

  const handleShowAddClientContactPopUp = () => {
    setShowAddClientContact(true);
  };

  const closeAddClientContactPopUp = () => {
    setShowAddClientContact(false);
    getData();
  };

  const handleShowAssignLawyerPopUp = () => {
    setShowAssignLawyerPopUp(true);
  };

  const closeAssignLawyerPopUp = () => {
    setShowAssignLawyerPopUp(false);
    getData();
  };

  const showClientContactPopUp = (e) => {
    setContactId(e.target.value);
    setShowClientContact(true);
  };

  const closeClientContactPopUp = () => {
    setShowClientContact(false);
  };

  const handleShowSygnPopUp = () => {
    setShowSygnPopUp(true);
  };

  const closeSygnPopUp = () => {
    setShowSygnPopUp(false);
    getData();
  };

  const handleShowAddSygnPopUp = () => {
    setShowAddSygnPopUp(true);
  };

  const closeAddSygnPopUp = () => {
    setShowAddSygnPopUp(false);
    getData();
  };

  const getLawyerName = (initials) => {
    var name = users.filter((el) => el.initials === initials);
    return name.length > 0 ? name[0].name : "brak danych";
  };

  const closeTaskPopUp = (e) => {
    setShowTask(!showTask);
    setTaskId("");
    getData();
  };

  const showTaskPopUp = (e) => {
    setTaskId(e.target.value);
    setShowTask(true);
    setShowDate(false);
  };

  const closeDatePopUp = (e) => {
    setShowDate(false);
    setDateId("");
    getData();
  };

  const showDatePopUp = (e) => {
    setDateId(e.target.value);
    setShowDate(true);
    setShowTask(false);
  };

  const checkSpecialClient = async () => {
    if (clientsData.special_client === "NIE") {
      setShowSpecialContent(true);
    } else {
      var body = {
        id: props.id,
        special_client: "NIE",
        why_special: "",
      };

      await fetch("https://apidevkppp.ftpeople.pl/setSpecialClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
      props.logClientAction("Odznaczono klienta szczególnego", props.id);

      MySwal.fire({
        icon: "success",
        title: "Odznaczono",
        text: "klienta szczególnego",
      }).then(async (result) => {
        getData();
      });
    }
  };

  const checkGetinOpt1 = async () => {
    var body = {
      id: props.id,
      value: +clientsData.getin_opt1 === 0 ? "1" : "0",
    };

    await fetch("https://apidevkppp.ftpeople.pl/setGetinOpt1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
    props.logClientAction("Zmieniono wartość: Getin - opcja 1", props.id);

    MySwal.fire({
      icon: "success",
      title: "Zmieniono",
      text: "wartość opcji GETIN",
    }).then(async (result) => {
      getData();
    });
  };

  const download = async (url, filename, type) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("target", "_blank");
    if (type === "portal") {
      link.setAttribute("download", filename);
    } else {
      link.setAttribute("download", filename);
    }

    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const checkGetinOpt2 = async () => {
    var body = {
      id: props.id,
      value: +clientsData.getin_opt2 === 0 ? "1" : "0",
    };

    await fetch("https://apidevkppp.ftpeople.pl/setGetinOpt2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
    props.logClientAction("Zmieniono wartość: Getin - opcja 1", props.id);

    MySwal.fire({
      icon: "success",
      title: "Zmieniono",
      text: "wartość opcji GETIN",
    }).then(async (result) => {
      getData();
    });
  };

  const handleShowNote = (e) => {
    setNoteContent(e.currentTarget.value);
    setShowNotePopUp(true);
  };

  const handleCloseNote = (e) => {
    setNoteContent("");
    setShowNotePopUp(false);
  };

  const changeFileNameK = async (e) => {
    MySwal.fire({
      title: "Wprowadź nazwę pliku",
      input: "text",
      inputPlaceholder: "Nazwa pliku",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wprowadzić nazwę pliku");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body4 = {
          id: e.target.value,
          name: result.value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/setFileName", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body4),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeFileCategory = async (e) => {
    var model = [];

    model["co-op"] = "Dokumenty do współpracy z kancelarią";
    model["credit"] = "Dokumenty kredytowe";
    model["court"] = "Pisma z sądu";
    model["bank"] = "Pisma z banku";
    model["send"] = "Pisma wysłane do sprawy";
    model["other"] = "Inne";
    model["segr"] = "Zeskanowany segregator fizyczny";

    MySwal.fire({
      title: "Wybierz kategorię",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać kategorię");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body4 = {
          id: e.target.value,
          category: result.value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/setFileCategory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body4),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const getCourtAddress = () => {
    if (clientsData.aSygn !== undefined) {
      var sygn = clientsData.aSygn;
      var district = sygn.split(" ")[0].replaceAll(" ", "");

      var address = courtAddress.filter(
        (el) => el.name === clientsData.newCourt
      );

      var ret = "";

      address.map((e) => {
        e.district
          .replaceAll(" ", "")
          .split(",")
          .map((e2) => {
            if (e2 === district) {
              ret = e.address;
            }
          });
      });

      return ret === "" ? "brak danych" : ret;
    }
    return "brak danych";
  };

  const getCourtMailAddress = () => {
    if (clientsData.aSygn !== undefined) {
      var sygn = clientsData.aSygn;
      var district = sygn.split(" ")[0].replaceAll(" ", "");

      var address = courtMailAddress.filter(
        (el) => el.name === clientsData.newCourt
      );

      var ret = address;

      return ret.length === 0 ? "brak danych" : ret;
    }
    return "brak danych";
  };

  const getPesel = (name) => {
    var pesel = "";
    clientAdditionalData.map((el) => {
      if (el.name.replaceAll(" ", "") === name.replaceAll(" ", "")) {
        pesel = el.pesel;
      }
    });
    return pesel;
  };

  const getAddress = (name) => {
    var address = "";
    clientAdditionalData.map((el) => {
      if (el.name.replaceAll(" ", "") === name.replaceAll(" ", "")) {
        address = el.address;
      }
    });
    return address.replaceAll(";", ",");
  };

  const basicData = (
    <>
      <table id="detailClientTable" className="clients_table">
        <>
          <tr>
            <td>Imię i nazwisko klienta</td>
            <td
              style={{ textAlign: "left", padding: "10px 20px", width: "55%" }}
            >
              <div
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <div style={{ width: "90%" }}>
                  {clientsData.petitioner !== undefined ? (
                    <>
                      <table
                        style={{ borderCollapse: "collapse", width: "100%" }}
                      >
                        {clientsData.petitioner.split(",").map((el) => (
                          <>
                            <tr style={{ backgroundColor: "transparent" }}>
                              <td
                                style={{
                                  width: "30%",
                                  backgroundColor: "transparent",
                                  borderWidth: "0px 1px",
                                }}
                              >
                                {el}
                              </td>
                              <td
                                style={{
                                  width: "20%",
                                  backgroundColor: "transparent",
                                  borderWidth: "0px 1px",
                                }}
                              >
                                {getPesel(el)}
                              </td>
                              <td
                                style={{
                                  width: "50%",
                                  backgroundColor: "transparent",
                                  borderWidth: "0px 1px",
                                }}
                              >
                                {getAddress(el)}
                              </td>
                            </tr>
                          </>
                        ))}
                      </table>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ width: "10%" }}>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "2vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditAdditionalData}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>
            </td>
            <td>
              {clientsData.accepted === "yes" ? (
                <>
                  <span id="calendar_check" className="highlight_green"></span>
                </>
              ) : (
                <>
                  <span id="calendar_check" className="highlight_green"></span>
                </>
              )}
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="name"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Adres e-mail</td>
            <td>{clientsData.email}</td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="mail"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Numer telefonu</td>
            <td>{clientsData.phone}</td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="phone"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {+clientsData.team === 2 ? (
            <tr>
              <td>Źródło</td>
              <td>
                {clientsData.source === "" || clientsData.source === undefined
                  ? "brak danych"
                  : clientsData.source}
              </td>
              <td></td>
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>Prawnik</td>
            <td>{getLawyerName(clientsData.client_owner)}</td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="lawyer"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Notatka do sprawy</td>
            <td>
              {clientsData.note === "" || clientsData.note === undefined
                ? "brak danych"
                : clientsData.note.substring(0, 100) + "..."}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowAddClientNote}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value={clientsData.note}
                onClick={handleShowNote}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Data podpisania umowy z kancelarią</td>
            <td>
              {clientsData.service_aggrement_date === "" ||
              clientsData.service_aggrement_date === undefined
                ? "brak danych"
                : clientsData.service_aggrement_date}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {props.uData.allowedClients === "all" ? (
            <>
              <tr>
                <td>Warunki współpracy z kancelarią</td>
                <td>
                  {clientsData.ow === "" || clientsData.ow === undefined ? (
                    "brak danych"
                  ) : (
                    <>
                      OW: {clientsData.ow} PLN | SF:{" "}
                      {(clientsData.sf.replaceAll(",", ".") * 100).toFixed(2)}%
                      liczone od:{" "}
                      {clientsData.sf_type === "benefit"
                        ? "kwoty korzyści"
                        : "kwoty kredytu"}
                    </>
                  )}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="aggr_cond"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          <tr>
            <td>Oryginał umowy i pełnomocnictwa do współpracy</td>
            <td>
              {clientsData.orig_aggr === "" ||
              clientsData.orig_aggr === undefined ? (
                "brak danych"
              ) : (
                <>{clientsData.orig_aggr}</>
              )}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="aggr_ori"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {leadC.length > 0 ? (
            <>
              {" "}
              <tr>
                <td>Konto w procesie sprzedaży</td>
                <td></td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="aggr_ori"
                    onClick={(e) => {
                      setShowLeadPopUp(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}

          {clientsData.special_client === "TAK" ? (
            <tr>
              <td>Przyczyna oznaczenia klienta szczególnego</td>
              <td>{clientsData.why_special.substring(0, 100) + "..."}</td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value={clientsData.why_special}
                  onClick={handleShowNote}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>Zgoda marketingowa</td>
            <td>{clientsData.markAggr === "1" ? "TAK" : "NIE"}</td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="markAggr"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
        </>
      </table>
      <div className="boxAdditionalFunFlex">
        <div
          style={{ fontWeight: "300", fontSize: "0.8vw", width: "20%" }}
          className="checkBox"
        >
          <input
            style={{ width: "7%" }}
            id="checkCal2"
            type="checkbox"
            checked={clientsData.special_client === "NIE" ? false : true}
            onChange={checkSpecialClient}
          />
          Oznacz klienta szczególnego
        </div>
      </div>
    </>
  );

  const basicDataMobile = (
    <>
      <table
        id="detailClientTable"
        className="clients_table"
        style={{ fontSize: "2vw" }}
      >
        <>
          <tr>
            <td>Imię i nazwisko klienta</td>
            <td style={{ textAlign: "left", padding: "5px 6px", width: "55%" }}>
              <div
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <div style={{ width: "90%" }}>
                  {clientsData.petitioner !== undefined ? (
                    <table
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      {clientsData.petitioner.split(",").map((el) => (
                        <>
                          <tr style={{ backgroundColor: "transparent" }}>
                            <td
                              style={{
                                width: "30%",
                                backgroundColor: "transparent",
                                borderWidth: "0px 1px",
                              }}
                            >
                              {el}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                backgroundColor: "transparent",
                                borderWidth: "0px 1px",
                              }}
                            >
                              {getPesel(el)}
                            </td>
                            <td
                              style={{
                                width: "50%",
                                backgroundColor: "transparent",
                                borderWidth: "0px 1px",
                              }}
                            >
                              {getAddress(el)}
                            </td>
                          </tr>
                        </>
                      ))}
                    </table>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ width: "10%" }}>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="name"
                    onClick={handleShowEditAdditionalData}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>
            </td>
            <td>
              {clientsData.accepted === "yes" ? (
                <>
                  <span id="calendar_check" className="highlight_green"></span>
                </>
              ) : (
                <>
                  <span id="calendar_check" className="highlight_green"></span>
                </>
              )}
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="name"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Adres e-mail</td>
            <td>{clientsData.email}</td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="mail"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Numer telefonu</td>
            <td>{clientsData.phone}</td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="phone"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {+clientsData.team === 2 ? (
            <tr>
              <td>Źródło</td>
              <td>
                {clientsData.source === "" || clientsData.source === undefined
                  ? "brak danych"
                  : clientsData.source}
              </td>
              <td></td>
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>Prawnik</td>
            <td>{getLawyerName(clientsData.client_owner)}</td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="lawyer"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Notatka do sprawy</td>
            <td>
              {clientsData.note === "" || clientsData.note === undefined
                ? "brak danych"
                : clientsData.note.substring(0, 100) + "..."}
            </td>
            <td>
              <button
                style={{
                  width: "35%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowAddClientNote}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                style={{
                  width: "35%",
                  marginLeft: "10px",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value={clientsData.note}
                onClick={handleShowNote}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Data podpisania umowy z kancelarią</td>
            <td>
              {clientsData.service_aggrement_date === "" ||
              clientsData.service_aggrement_date === undefined
                ? "brak danych"
                : clientsData.service_aggrement_date}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {props.uData.allowedClients === "all" ? (
            <>
              <tr>
                <td>Warunki współpracy z kancelarią</td>
                <td>
                  {clientsData.ow === "" || clientsData.ow === undefined ? (
                    "brak danych"
                  ) : (
                    <>
                      OW: {clientsData.ow} PLN | SF:{" "}
                      {(clientsData.sf.replaceAll(",", ".") * 100).toFixed(2)}%
                      liczone od:{" "}
                      {clientsData.sf_type === "benefit"
                        ? "kwoty korzyści"
                        : "kwoty kredytu"}
                    </>
                  )}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="aggr_cond"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          <tr>
            <td>Oryginał umowy i pełnomocnictwa do współpracy</td>
            <td>
              {clientsData.orig_aggr === "" ||
              clientsData.orig_aggr === undefined ? (
                "brak danych"
              ) : (
                <>{clientsData.orig_aggr}</>
              )}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="aggr_ori"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {leadC.length > 0 ? (
            <>
              {" "}
              <tr>
                <td>Konto w procesie sprzedaży</td>
                <td></td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="aggr_ori"
                    onClick={(e) => {
                      setShowLeadPopUp(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Zgoda marketingowa</td>
                <td>{clientsData.markAggr === "1" ? "TAK" : "NIE"}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="markAggr"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}

          {clientsData.special_client === "TAK" ? (
            <tr>
              <td>Przyczyna oznaczenia klienta szczególnego</td>
              <td>{clientsData.why_special.substring(0, 100) + "..."}</td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value={clientsData.why_special}
                  onClick={handleShowNote}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
        </>
      </table>
      <div className="boxAdditionalFunFlex">
        <div
          style={{ fontWeight: "300", fontSize: "3vw", width: "70%" }}
          className="checkBox"
        >
          <input
            style={{ width: "6%" }}
            id="checkCal2"
            type="checkbox"
            checked={clientsData.special_client === "NIE" ? false : true}
            onChange={checkSpecialClient}
          />
          Oznacz klienta szczególnego
        </div>
      </div>
    </>
  );

  const downloadFile2 = (e) => {
    var url = e.target.value;
    download(url, "Ugoda " + clientsData.petitioner);
  };

  const caseData = (
    <>
      <div className="clientsFlex">
        <div style={{ width: "48%" }}>
          <table id="detailClientTable" className="clients_table">
            <>
              <tr>
                <td style={{ fontWeight: "900" }}>Status sprawy</td>
                <td style={{ fontWeight: "900", color: "red" }}>
                  {clientsData.status === ""
                    ? "brak danych"
                    : clientsData.status}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="status"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.status ===
              "mamy wezwanie - braki dokumentowe klienta" ? (
                <>
                  <tr>
                    <td>Notatka do statusu</td>
                    <td>
                      {clientsData.status_note === "" ||
                      clientsData.status_note === undefined
                        ? "brak danych"
                        : clientsData.status_note.substring(0, 100) + "..."}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="status"
                        onClick={handleShowAddClient}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value={clientsData.status_note}
                        onClick={handleShowNote}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              <tr>
                <td>Kredyt spłacony</td>
                <td>{clientsData.payed === "1" ? "TAK" : "NIE"}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="payed"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Aktualny sąd</td>
                <td>{clientsData.newCourt}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <button
                    style={{
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddSygnPopUp}
                  >
                    {"Dodaj"}
                  </button>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSygnPopUp}
                  >
                    {"Pokaż"}
                  </button>
                </td>
              </tr>
              <tr>
                <td>Aktualna sygnatura</td>
                <td>{clientsData.newSygn}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <button
                    style={{
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddSygnPopUp}
                  >
                    {"Dodaj"}
                  </button>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSygnPopUp}
                  >
                    {"Pokaż"}
                  </button>
                </td>
              </tr>
              {true ? (
                <tr>
                  <td>Sędzia</td>
                  <td>
                    {clientsData.judge ? clientsData.judge : "brak danych"}
                  </td>
                  <td style={{ verticalAlign: "middle" }}></td>
                </tr>
              ) : (
                ""
              )}
              <tr>
                <td>Bank</td>
                <td>
                  {clientsData.bank === "" ? "brak danych" : clientsData.bank}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Pełnomocnik banku</td>
                <td>
                  {clientsData.lawyer_bank === "" ||
                  clientsData.lawyer_bank === null
                    ? "brak danych"
                    : clientsData.lawyer_bank}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditBankLawyer}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Kancelaria banku</td>
                <td>
                  {bankLawOffice && bankLawOffice.name
                    ? bankLawOffice.name + ", " + bankLawOfficeAddress
                    : clientsData.lawoffice_bank
                    ? clientsData.lawoffice_bank.split(",")[0]
                      ? clientsData.lawoffice_bank.split(",")[0]
                      : "brak danych"
                    : "brak danych"}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditBankLawOffice}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.type !== "antywindykacja" ? (
                <tr>
                  <td>Data nadania pozwu</td>
                  <td>
                    {clientsData.lawsuit_date === ""
                      ? "brak danych"
                      : clientsData.lawsuit_date}
                  </td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="bank"
                      onClick={handleShowEditLawsuitDate}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}

              <tr>
                <td>WPS</td>
                <td>
                  {clientsData.wps === "" || clientsData.wps === undefined
                    ? "brak danych"
                    : numberWithCommas(clientsData.wps) + " PLN"}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditWPS}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              {clientsData.type === "sankcja kredytu darmowego" ? (
                ""
              ) : (
                <>
                  {clientsData.type !== "antywindykacja" ? (
                    <>
                      <tr>
                        <td>Pozew o nadpłatę</td>
                        <td>
                          {clientsData.pozN === "" ||
                          clientsData.pozN === undefined
                            ? "brak danych"
                            : clientsData.pozN}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditPozN}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>Pozew o samo ustalenie</td>
                        <td>
                          {clientsData.pou === "" ||
                          clientsData.pou === undefined
                            ? "brak danych"
                            : clientsData.pou}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditPou}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>

                      <tr>
                        <td>Potrącenie otrzymane bezpośrednio przez klienta</td>
                        <td>
                          {clientsData.potrCl === "" ||
                          clientsData.potrCl === undefined ||
                          clientsData.potrCl === null
                            ? "brak danych"
                            : clientsData.potrCl}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditPotrCl}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>

                      <tr>
                        <td>Cofnięcie częściowe pozwu po potrąceniu</td>
                        <td>
                          {clientsData.cofCzP === "" ||
                          clientsData.cofCzP === undefined ||
                          clientsData.cofCzP === null
                            ? "brak danych"
                            : clientsData.cofCzP}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditCofCzP}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
              <tr>
                <td>Osoba rozliczająca sprawę</td>
                <td>
                  {clientsData.rozCase === "" ||
                  clientsData.rozCase === undefined ||
                  clientsData.rozCase === null
                    ? "brak danych"
                    : clientsData.rozCase}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditRozCase}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          </table>
        </div>
        <div style={{ width: "48%" }}>
          <table id="detailClientTable" className="clients_table">
            <>
              <tr>
                <td>Pełnomocnictwo substytucyjne</td>
                <td>
                  {clientsData.pel_sub === "" || clientsData.pel_sub === null
                    ? "brak danych"
                    : clientsData.pel_sub}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_date"
                    onClick={handleShowEditPelnSub}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              <tr>
                <td>Rodzaj sprawy</td>
                <td>{clientsData.type}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.type !== "antywindykacja" ? (
                <tr>
                  <td>Odpowiedź na pozew</td>
                  <td>
                    {clientsData.odpPozw === null || clientsData.odpPozw === ""
                      ? "brak danych"
                      : clientsData.odpPozw === "BRAK DANYCH"
                      ? clientsData.odpPozw.toLowerCase()
                      : clientsData.odpPozw}
                  </td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowEditOdpPozw}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}
              {clientsData.type !== "antywindykacja" ? (
                <tr>
                  <td>Replika</td>
                  <td>
                    {clientsData.rep === "" || clientsData.rep === undefined
                      ? "brak danych"
                      : clientsData.rep}
                  </td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowEditRep}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}

              <tr>
                <td>Propozycja ugodowa</td>
                <td>
                  {clientsData.ugoda === "" || clientsData.ugoda === undefined
                    ? "brak danych"
                    : clientsData.ugoda}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={handleShowEditPU}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.ugoda === "TAK" ? (
                <tr>
                  <td>Notatka do ugody</td>
                  <td>
                    {clientsData.ugoda_note === ""
                      ? "brak danych"
                      : clientsData.ugoda_note.substring(0, 100) + "..."}
                  </td>
                  <td>
                    {clientsData.ugoda_link.toString().length > 0 ? (
                      <button
                        style={{
                          textDecoration: "none",
                          padding: "2px 10px",
                          backgroundColor: "rgb(165, 190, 164)",
                        }}
                        className="refreshButton"
                        value={clientsData.ugoda_link}
                        onClick={downloadFile2}
                      >
                        załącznik
                      </button>
                    ) : (
                      ""
                    )}
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowEditPU}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={clientsData.ugoda_note}
                      onClick={handleShowNote}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}
              {clientsData.type !== "antywindykacja" ? (
                <>
                  {clientsData.type === "sankcja kredytu darmowego" ? (
                    ""
                  ) : (
                    <>
                      <tr>
                        <td>Zarzut zatrzymania</td>
                        <td>
                          {clientsData.zatrz === "" ||
                          clientsData.zatrz === undefined
                            ? "brak danych"
                            : clientsData.zatrz}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="type"
                            onClick={handleShowEditZZ}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>Zarzut potrącenia</td>
                        <td>
                          {clientsData.zatrz_potr === "" ||
                          clientsData.zatrz_potr === undefined
                            ? "brak danych"
                            : clientsData.zatrz_potr}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="type"
                            onClick={handleShowEditZP}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>
                    </>
                  )}

                  <tr>
                    <td>Działalność gospodarcza</td>
                    <td>
                      {clientsData.dzial_gosp === "" ||
                      clientsData.dzial_gosp === undefined
                        ? "brak danych"
                        : clientsData.dzial_gosp}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowEditDG}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}

              {clientsData.dzial_gosp === "TAK" ? (
                <>
                  <tr>
                    <td>Dodatkowe informacje do DG</td>
                    <td>
                      {clientsData.dzial_gosp_add === "" ||
                      clientsData.dzial_gosp_add === undefined
                        ? "brak danych"
                        : clientsData.dzial_gosp_add}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowEditDG}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              {clientsData.type === "sankcja kredytu darmowego" ? (
                ""
              ) : (
                <tr>
                  <td>Pozew wzajemny</td>
                  <td>
                    {clientsData.counterclaim === "" ||
                    clientsData.counterclaim === undefined ||
                    clientsData.counterclaim === null
                      ? "brak danych"
                      : clientsData.counterclaim}
                  </td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowCounterClaim}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              )}
              {+clientsData.team === 2 ? (
                <tr>
                  <td>Źródło</td>
                  <td>
                    {clientsData.source === "" ||
                    clientsData.source === undefined
                      ? "brak danych"
                      : clientsData.source}
                  </td>
                  <td></td>
                </tr>
              ) : (
                ""
              )}
              {props.clientsData.bank.includes("etin") ? (
                <>
                  <tr>
                    <td colspan="2">
                      Kancelaria przygotowuje oświadczenie o potrąceniu
                    </td>
                    <td>
                      <input
                        style={{ width: "10%", marginLeft: "15px" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={+clientsData.getin_opt1 === 0 ? false : true}
                        onChange={checkGetinOpt1}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      Kancelaria przygotowuje oświadczenie o potrąceniu i
                      zgłasza wierzytelność
                    </td>
                    <td>
                      <input
                        style={{ width: "10%", marginLeft: "15px" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={+clientsData.getin_opt2 === 0 ? false : true}
                        onChange={checkGetinOpt2}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Podjęte postępowanie po zawieszeniu - Getin</td>
                    <td>
                      {clientsData.getin_susp === "" ||
                      clientsData.getin_susp === undefined ||
                      clientsData.getin_susp === null
                        ? "brak danych"
                        : clientsData.getin_susp}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowGetinSusp}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              <tr>
                <td>Segregator fizyczny</td>
                <td>
                  {clientsData.physicalBinder === "" ||
                  clientsData.physicalBinder === undefined ||
                  clientsData.physicalBinder === null
                    ? "brak danych"
                    : clientsData.physicalBinder}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={handleShowBinderData}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              {clientsData.physicalBinder === "TAK" ? (
                <>
                  <tr>
                    <td>Numer kartonu</td>
                    <td>
                      {clientsData.physicalBinderNumber === "" ||
                      clientsData.physicalBinderNumber === undefined ||
                      clientsData.physicalBinderNumber === null
                        ? "brak danych"
                        : clientsData.physicalBinderNumber}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowBinderData}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              {clientsData.type === "antywindykacja" ? (
                <>
                  <tr>
                    <td>Kwota roszczenia</td>
                    <td>
                      {clientsData.ammountA === "" ||
                      clientsData.ammountA === undefined ||
                      clientsData.ammountA === null
                        ? "brak danych"
                        : numberWithCommas(clientsData.ammountA) + " PLN"}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowAmmountA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Rodzaj tytułu egzekucyjnego</td>
                    <td>
                      {clientsData.titleA === "" ||
                      clientsData.titleA === undefined ||
                      clientsData.titleA === null
                        ? "brak danych"
                        : clientsData.titleA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowTitleA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Czy w sprawie jest komornik?</td>
                    <td>
                      {clientsData.komorA === "" ||
                      clientsData.komorA === undefined ||
                      clientsData.komorA === null
                        ? "brak danych"
                        : clientsData.komorA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowKomorA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Data odebrania nakazu/wezwania do złożenia odpowiedzi na
                      pozew
                    </td>
                    <td>
                      {clientsData.nakDateA === "" ||
                      clientsData.nakDateA === undefined ||
                      clientsData.nakDateA === null
                        ? "brak danych"
                        : clientsData.nakDateA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowNakDateA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Rodzaj postępowania</td>
                    <td>
                      {clientsData.rodzPostA === "" ||
                      clientsData.rodzPostA === undefined ||
                      clientsData.rodzPostA === null
                        ? "brak danych"
                        : clientsData.rodzPostA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowRodzPostA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Kontynuacja EPU</td>
                    <td>
                      {clientsData.conEpuA === "" ||
                      clientsData.conEpuA === undefined ||
                      clientsData.conEpuA === null
                        ? "brak danych"
                        : clientsData.conEpuA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowConEpuA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Dane do logowania EPU</td>
                    <td>
                      {clientsData.logEpuA === "" ||
                      clientsData.logEpuA === undefined ||
                      clientsData.logEpuA === null
                        ? "brak danych"
                        : clientsData.logEpuA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowLogEpuA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Wpłaty na poczet wykonywania umowy</td>
                    <td>
                      {clientsData.wnpwuA === "" ||
                      clientsData.wnpwuA === undefined ||
                      clientsData.wnpwuA === null
                        ? "brak danych"
                        : clientsData.wnpwuA}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={() => {
                          setShowWnpwuA(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              {clientsData.type !== "antywindykacja" ? (
                <tr>
                  <td>Nakaz zapłaty</td>
                  <td>
                    {clientsData.nakZap === "" ||
                    clientsData.nakZap === undefined ||
                    clientsData.nakZap === null
                      ? "brak danych"
                      : clientsData.nakZap}
                  </td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowNakZap}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}
              <tr>
                <td>Sędzia - teoria salda (bez KZP)</td>
                <td>
                  {clientsData.sts === "" ||
                  clientsData.sts === undefined ||
                  clientsData.sts === null
                    ? "brak danych"
                    : clientsData.sts}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={() => {
                      setShowSTS(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Sędzia - teoria salda (KZP w pełnej wysokości)</td>
                <td>
                  {clientsData.stsk === "" ||
                  clientsData.stsk === undefined ||
                  clientsData.stsk === null
                    ? "brak danych"
                    : clientsData.stsk}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={() => {
                      setShowSTSK(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Sędzia - uwzględnia potrącenie</td>
                <td>
                  {clientsData.sup === "" ||
                  clientsData.sup === undefined ||
                  clientsData.sup === null
                    ? "brak danych"
                    : clientsData.sup}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={() => {
                      setShowSUP(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              {clientsData.type === "sankcja kredytu darmowego" ? (
                <tr>
                  <td>Opłata sądowa od pozwu</td>
                  <td>
                    {clientsData.opSp === "" ||
                    clientsData.opSp === undefined ||
                    clientsData.opSp === null
                      ? "brak danych"
                      : clientsData.opSp}
                  </td>
                  <td>
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowOpSP}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}
            </>
          </table>
        </div>
      </div>
    </>
  );

  const caseDataMobile = (
    <>
      <div className="clientsFlex">
        <div style={{ width: "100%" }}>
          <table
            id="detailClientTable"
            className="clients_table"
            style={{ fontSize: "2vw" }}
          >
            <>
              <tr>
                <td style={{ fontWeight: "900" }}>Status sprawy</td>
                <td style={{ fontWeight: "900", color: "red" }}>
                  {clientsData.status === ""
                    ? "brak danych"
                    : clientsData.status}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="status"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.status ===
              "mamy wezwanie - braki dokumentowe klienta" ? (
                <>
                  <tr>
                    <td>Notatka do statusu</td>
                    <td>
                      {clientsData.status_note === "" ||
                      clientsData.status_note === undefined
                        ? "brak danych"
                        : clientsData.status_note.substring(0, 100) + "..."}
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="status"
                        onClick={handleShowAddClient}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value={clientsData.status_note}
                        onClick={handleShowNote}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              <tr>
                <td>Kredyt spłacony</td>
                <td>{clientsData.payed === "1" ? "TAK" : "NIE"}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="payed"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Aktualny sąd</td>
                <td>{clientsData.newCourt}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <button
                    style={{
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                      fontSize: "1.5vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddSygnPopUp}
                  >
                    {"Dodaj"}
                  </button>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                      fontSize: "1.5vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSygnPopUp}
                  >
                    {"Pokaż"}
                  </button>
                </td>
              </tr>

              <tr>
                <td>Aktualna sygnatura</td>
                <td>{clientsData.newSygn}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <button
                    style={{
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                      fontSize: "1.5vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddSygnPopUp}
                  >
                    {"Dodaj"}
                  </button>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "35%",
                      backgroundColor: "#a5bea4",
                      color: "white",
                      borderColor: "white",
                      fontSize: "1.5vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSygnPopUp}
                  >
                    {"Pokaż"}
                  </button>
                </td>
              </tr>
              {true ? (
                <tr>
                  <td>Sędzia</td>
                  <td>
                    {clientsData.judge ? clientsData.judge : "brak danych"}
                  </td>
                  <td style={{ verticalAlign: "middle" }}></td>
                </tr>
              ) : (
                ""
              )}
              <tr>
                <td>Bank</td>
                <td>
                  {clientsData.bank === "" ? "brak danych" : clientsData.bank}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Pełnomocnik banku</td>
                <td>
                  {clientsData.lawyer_bank === "" ||
                  clientsData.lawyer_bank === null
                    ? "brak danych"
                    : clientsData.lawyer_bank}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditBankLawyer}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Kancelaria banku</td>
                <td>
                  {bankLawOffice
                    ? bankLawOffice.name + ", " + bankLawOfficeAddress
                    : clientsData.lawoffice_bank
                    ? clientsData.lawoffice_bank.split(",")[0]
                    : "brak danych"}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditBankLawOffice}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.type === "antywindykacja" ? (
                <tr>
                  <td>Data nadania pozwu</td>
                  <td>
                    {clientsData.lawsuit_date === ""
                      ? "brak danych"
                      : clientsData.lawsuit_date}
                  </td>
                  <td>
                    <button
                      style={{
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="bank"
                      onClick={handleShowEditLawsuitDate}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}

              <tr>
                <td>WPS</td>
                <td>
                  {clientsData.wps === "" || clientsData.wps === undefined
                    ? "brak danych"
                    : numberWithCommas(clientsData.wps) + " PLN"}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditWPS}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              {clientsData.type === "sankcja kredytu darmowego" ? (
                ""
              ) : (
                <>
                  {clientsData.type !== "antywindykacja" ? (
                    <>
                      <tr>
                        <td>Pozew o nadpłatę</td>
                        <td>
                          {clientsData.pozN === "" ||
                          clientsData.pozN === undefined
                            ? "brak danych"
                            : clientsData.pozN}
                        </td>
                        <td>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "3vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditPozN}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td>Pozew o samo ustalenie</td>
                        <td>
                          {clientsData.pou === "" ||
                          clientsData.pou === undefined
                            ? "brak danych"
                            : clientsData.pou}
                        </td>
                        <td>
                          <button
                            style={{
                              marginLeft: "10px",
                              width: "10%",
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "1vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditPou}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>

                      <tr>
                        <td>Potrącenie otrzymane bezpośrednio przez klienta</td>
                        <td>
                          {clientsData.potrCl === "" ||
                          clientsData.potrCl === undefined ||
                          clientsData.potrCl === null
                            ? "brak danych"
                            : clientsData.potrCl}
                        </td>
                        <td>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "3vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditPotrCl}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>

                      <tr>
                        <td>Cofnięcie częściowe pozwu po potrąceniu</td>
                        <td>
                          {clientsData.cofCzP === "" ||
                          clientsData.cofCzP === undefined ||
                          clientsData.cofCzP === null
                            ? "brak danych"
                            : clientsData.cofCzP}
                        </td>
                        <td>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              color: "#a5bea4",
                              border: "none",
                              fontSize: "3vw",
                            }}
                            id="clientsButton"
                            className="paymentMenuButton"
                            value="bank"
                            onClick={handleShowEditCofCzP}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        </td>
                      </tr>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
              <tr>
                <td>Osoba rozliczająca sprawę</td>
                <td>
                  {clientsData.rozCase === "" ||
                  clientsData.rozCase === undefined ||
                  clientsData.rozCase === null
                    ? "brak danych"
                    : clientsData.rozCase}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="bank"
                    onClick={handleShowEditRozCase}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Pełnomocnictwo substytucyjne</td>
                <td>
                  {clientsData.pel_sub === "" || clientsData.pel_sub === null
                    ? "brak danych"
                    : clientsData.pel_sub}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_date"
                    onClick={handleShowEditPelnSub}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              <tr>
                <td>Rodzaj sprawy</td>
                <td>{clientsData.type}</td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={handleShowAddClient}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.type !== "antywindykacja" ? (
                <tr>
                  <td>Odpowiedź na pozew</td>
                  <td>
                    {clientsData.odpPozw === null || clientsData.odpPozw === ""
                      ? "brak danych"
                      : clientsData.odpPozw === "BRAK DANYCH"
                      ? clientsData.odpPozw.toLowerCase()
                      : clientsData.odpPozw}
                  </td>
                  <td>
                    <button
                      style={{
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowEditOdpPozw}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}
              {clientsData.type !== "antywindykacja" ? (
                <tr>
                  <td>Replika</td>
                  <td>
                    {clientsData.rep === "" || clientsData.rep === undefined
                      ? "brak danych"
                      : clientsData.rep}
                  </td>
                  <td>
                    <button
                      style={{
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowEditRep}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}

              <tr>
                <td>Propozycja ugodowa</td>
                <td>
                  {clientsData.ugoda === "" || clientsData.ugoda === undefined
                    ? "brak danych"
                    : clientsData.ugoda}
                </td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={handleShowEditPU}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              {clientsData.ugoda === "TAK" ? (
                <tr>
                  <td>Notatka do ugody</td>
                  <td>
                    {clientsData.ugoda_note === ""
                      ? "brak danych"
                      : clientsData.ugoda_note.substring(0, 100) + "..."}
                  </td>
                  <td style={{ paddingTop: "10px" }}>
                    {clientsData.ugoda_link.toString().length > 0 ? (
                      <a
                        style={{
                          textDecoration: "none",
                          padding: "2px 10px",
                          backgroundColor: "rgb(165, 190, 164)",
                          fontSize: "2vw",
                        }}
                        target="_blank"
                        className="refreshButton"
                        href={clientsData.ugoda_link}
                      >
                        pokaż załącznik
                      </a>
                    ) : (
                      ""
                    )}
                    <button
                      style={{
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowEditPU}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      style={{
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={clientsData.ugoda_note}
                      onClick={handleShowNote}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  </td>
                </tr>
              ) : (
                ""
              )}
              {clientsData.type !== "antywindykacja" ? (
                <>
                  <tr>
                    <td>Zarzut zatrzymania</td>
                    <td>
                      {clientsData.zatrz === "" ||
                      clientsData.zatrz === undefined
                        ? "brak danych"
                        : clientsData.zatrz}
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowEditZZ}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Zarzut potrącenia</td>
                    <td>
                      {clientsData.zatrz_potr === "" ||
                      clientsData.zatrz_potr === undefined
                        ? "brak danych"
                        : clientsData.zatrz_potr}
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowEditZP}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <td>Działalność gospodarcza</td>
                    <td>
                      {clientsData.dzial_gosp === "" ||
                      clientsData.dzial_gosp === undefined
                        ? "brak danych"
                        : clientsData.dzial_gosp}
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowEditDG}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              <tr>
                <td>Sędzia - teoria salda</td>
                <td>
                  {clientsData.sts === "" ||
                  clientsData.sts === undefined ||
                  clientsData.sts === null
                    ? "brak danych"
                    : clientsData.sts}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={() => {
                      setShowSTS(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Sędzia - teoria salda (KZP w pełnej wysokości)</td>
                <td>
                  {clientsData.stsk === "" ||
                  clientsData.stsk === undefined ||
                  clientsData.stsk === null
                    ? "brak danych"
                    : clientsData.stsk}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="type"
                    onClick={() => {
                      setShowSTSK(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>

              {clientsData.dzial_gosp === "TAK" ? (
                <>
                  <tr>
                    <td>Dodatkowe informacje do DG</td>
                    <td>
                      {clientsData.dzial_gosp_add === "" ||
                      clientsData.dzial_gosp_add === undefined
                        ? "brak danych"
                        : clientsData.dzial_gosp_add}
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowEditDG}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              {clientsData.type === "sankcja kredytu darmowego" ? (
                ""
              ) : (
                <tr>
                  <td>Pozew wzajemny</td>
                  <td>
                    {clientsData.counterclaim === "" ||
                    clientsData.counterclaim === undefined ||
                    clientsData.counterclaim === null
                      ? "brak danych"
                      : clientsData.counterclaim}
                  </td>
                  <td>
                    <button
                      style={{
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "3vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="type"
                      onClick={handleShowCounterClaim}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              )}
              {+clientsData.team === 2 ? (
                <tr>
                  <td>Źródło</td>
                  <td>
                    {clientsData.source === "" ||
                    clientsData.source === undefined
                      ? "brak danych"
                      : clientsData.source}
                  </td>
                  <td></td>
                </tr>
              ) : (
                ""
              )}
              {props.clientsData.bank.includes("etin") ? (
                <>
                  <tr>
                    <td colspan="2">
                      Kancelaria przygotowuje oświadczenie o potrąceniu
                    </td>
                    <td>
                      <input
                        style={{ width: "10%", marginLeft: "15px" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={+clientsData.getin_opt1 === 0 ? false : true}
                        onChange={checkGetinOpt1}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      Kancelaria przygotowuje oświadczenie o potrąceniu i
                      zgłasza wierzytelność
                    </td>
                    <td>
                      <input
                        style={{ width: "10%", marginLeft: "15px" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={+clientsData.getin_opt2 === 0 ? false : true}
                        onChange={checkGetinOpt2}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Podjęte postępowanie po zawieszeniu - Getin</td>
                    <td>
                      {clientsData.getin_susp === "" ||
                      clientsData.getin_susp === undefined ||
                      clientsData.getin_susp === null
                        ? "brak danych"
                        : clientsData.getin_susp}
                    </td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "3vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="type"
                        onClick={handleShowGetinSusp}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
            </>
          </table>
        </div>
      </div>
    </>
  );

  const lawsuitData = (
    <>
      <table id="detailClientTable" className="clients_table">
        <>
          <tr>
            <td>Aktualny sąd</td>
            <td>{clientsData.newCourt}</td>
            <td style={{ verticalAlign: "middle" }}>
              <button
                style={{
                  width: "35%",
                  backgroundColor: "#a5bea4",
                  color: "white",
                  borderColor: "white",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowAddSygnPopUp}
              >
                {"Dodaj"}
              </button>
              <button
                style={{
                  marginLeft: "10px",
                  width: "35%",
                  backgroundColor: "#a5bea4",
                  color: "white",
                  borderColor: "white",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowSygnPopUp}
              >
                {"Pokaż"}
              </button>
            </td>
          </tr>
          <tr>
            <td>Notatka do sprawy</td>
            <td>
              {clientsData.note === "" || clientsData.note === undefined
                ? "brak danych"
                : clientsData.note.substring(0, 100) + "..."}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowAddClientNote}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value={clientsData.note}
                onClick={handleShowNote}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </td>
          </tr>
          {clientsData.type === "sankcja kredytu darmowego" ? (
            ""
          ) : (
            <tr>
              <td>Wniosek o zabezpieczenie</td>
              <td>
                {clientsData.application_for_protection === ""
                  ? "brak danych"
                  : clientsData.application_for_protection}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowAddClient}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Checklista do pozwu</td>
              <td style={{ textAlign: "center", padding: "5px 10px" }}>
                {clientsData.checklist ? "TAK" : "NIE"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowAddChecklist}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowAddChecklistView}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data otrzymania zaświadczenia od klienta</td>
              <td>
                {clientsData.data_zasw === ""
                  ? "brak danych"
                  : clientsData.data_zasw}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditDZ}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Sporządzający wezwanie do zapłaty</td>
              <td>
                {clientsData.praw_wezw === ""
                  ? "brak danych"
                  : clientsData.praw_wezw}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditPW}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data wezwania do zapłaty</td>
              <td>
                {clientsData.data_wezw === ""
                  ? "brak danych"
                  : clientsData.data_wezw}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditDW}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Osoba odpowiedzialna za pozew</td>
              <td>
                {clientsData.praw_pozew === ""
                  ? "brak danych"
                  : clientsData.praw_pozew}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditPP}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Osoba sprawdzająca pozew</td>
              <td>
                {clientsData.praw_spr_pozew === ""
                  ? "brak danych"
                  : clientsData.praw_spr_pozew}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditPSP}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>Bank</td>
            <td>
              {clientsData.bank === "" ? "brak danych" : clientsData.bank}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Podmiot z umowy kredytowej</td>
            <td>
              {clientsData.bank_old === ""
                ? "brak danych"
                : clientsData.bank_old}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowEditBO}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Data umowy kredytowej</td>
            <td>
              {clientsData.credit_date === ""
                ? "brak danych"
                : clientsData.credit_date}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="credit_date"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Numer umowy kredytowej</td>
            <td>
              {clientsData.credit_aggr_num === ""
                ? "brak danych"
                : clientsData.credit_aggr_num}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="credit_date"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Kwota kredytu</td>
            <td>
              {clientsData.credit_value === "" ||
              clientsData.credit_value === undefined
                ? "brak danych"
                : numberWithCommas(
                    clientsData.credit_value.split(" ")[0].replaceAll(" ", "")
                  ) +
                  " " +
                  clientsData.credit_value.split(" ")[1]}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="credit_value"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {clientsData.wezwPlnValue !== undefined &&
          clientsData.wezwPlnValue !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              <tr>
                <td>Wezwanie - kwota w PLN</td>
                <td>{clientsData.wezwPlnValue} PLN</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.type === "sankcja kredytu darmowego" ? (
            ""
          ) : (
            <>
              {clientsData.wezwChfValue !== undefined &&
              clientsData.wezwChfValue !== null &&
              clientsData.type !== "antywindykacja" ? (
                <>
                  {" "}
                  <tr>
                    <td>Wezwanie - kwota w CHF</td>
                    <td>{clientsData.wezwChfValue} CHF</td>
                    <td>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="credit_value"
                        onClick={(e) => setShowEditWezwData(true)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
            </>
          )}
          {clientsData.wezwLastPayDate !== undefined &&
          clientsData.wezwLastPayDate !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              {" "}
              <tr>
                <td>Wezwanie - ostatnia wpłata przypada na dzień</td>
                <td>{clientsData.wezwLastPayDate}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.wezwPayTime !== undefined &&
          clientsData.wezwPayTime !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              {" "}
              <tr>
                <td>Wezwanie - termin płatności</td>
                <td>{clientsData.wezwPayTime}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data doręczenia wezwania</td>
              <td>
                {clientsData.dateDeliverWezw !== undefined &&
                clientsData.dateDeliverWezw !== null
                  ? clientsData.dateDeliverWezw.length > 0
                    ? clientsData.dateDeliverWezw
                    : "brak danych"
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={showLawsuitDataFu}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data wymagalności</td>
              <td>
                {clientsData.dateWym !== undefined &&
                clientsData.dateWym !== null
                  ? clientsData.dateWym.length > 0
                    ? clientsData.dateWym
                    : "brak danych"
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={showLawsuitDataFu}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Rzeczywiście wypłacona kwota kredytu</td>
              <td>
                {clientsData.realCreditValue !== undefined &&
                clientsData.realCreditValue !== null
                  ? +clientsData.realCreditValue.replaceAll(",", ".") > 0
                    ? numberWithCommas(clientsData.realCreditValue) + " PLN"
                    : "0 PLN"
                  : "0 PLN"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={showLawsuitDataFu}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Potwierdzenie nadania wezwania</td>
              <td>
                {clientsData.sendDate !== undefined &&
                clientsData.sendDate !== null
                  ? clientsData.sendDate
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={showLawsuitDataFu}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data wydruku potwierdzenia doręczenia</td>
              <td>
                {clientsData.printDate !== undefined &&
                clientsData.printDate !== null
                  ? clientsData.printDate
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={handleShowAddPrintDate}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <>
              <tr>
                <td>Data zaświadczenia 1</td>
                <td>
                  {clientsData.lawZaswDate !== undefined &&
                  clientsData.lawZaswDate !== null
                    ? clientsData.lawZaswDate
                    : "brak danych"}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={handleShowAddLawZasw}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Data zaświadczenia 2</td>
                <td>
                  {clientsData.lawZaswDate2 !== undefined &&
                  clientsData.lawZaswDate2 !== null
                    ? clientsData.lawZaswDate2
                    : "brak danych"}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={handleShowAddLawZasw2}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
              <tr>
                <td>Data zaświadczenia 3</td>
                <td>
                  {clientsData.lawZaswDate3 !== undefined &&
                  clientsData.lawZaswDate3 !== null
                    ? clientsData.lawZaswDate3
                    : "brak danych"}
                </td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={handleShowAddLawZasw3}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>{" "}
            </>
          ) : (
            ""
          )}
          <tr>
            <td>KWOTA NADPŁATY W PLN</td>
            <td>
              {!clientsData.nadPLN ||
              clientsData.nadPLN === "" ||
              clientsData.nadPLN === undefined
                ? "brak danych"
                : numberWithCommas(clientsData.nadPLN) + " PLN"}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowEditNadPLN}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>KWOTA NADPŁATY W CHF</td>
            <td>
              {!clientsData.nadCHF ||
              clientsData.nadCHF === "" ||
              clientsData.nadCHF === undefined
                ? "brak danych"
                : numberWithCommas(clientsData.nadCHF) + " CHF"}
            </td>
            <td>
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowEditNadCHF}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {clientsData.type === "antywindykacja" ? (
            <tr>
              <td>Kwota roszczenia</td>
              <td>
                {clientsData.ammountA === "" ||
                clientsData.ammountA === undefined ||
                clientsData.ammountA === null
                  ? "brak danych"
                  : numberWithCommas(clientsData.ammountA) + " PLN"}
              </td>
              <td>
                <button
                  style={{
                    marginLeft: "10px",
                    width: "10%",
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "1vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="type"
                  onClick={() => {
                    setShowAmmountA(true);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.kpSkd !== undefined &&
          clientsData.kpSKd !== null &&
          clientsData.type === "sankcja kredytu darmowego" ? (
            <>
              {" "}
              <tr>
                <td>Kwota prowizji</td>
                <td>{clientsData.kpSkd}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}

          {clientsData.izrSkd !== undefined &&
          clientsData.izrSkd !== null &&
          clientsData.type === "sankcja kredytu darmowego" ? (
            <>
              {" "}
              <tr>
                <td>Ilość zapłaconych rat</td>
                <td>{clientsData.izrSkd}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}

          {clientsData.irSkd !== undefined &&
          clientsData.irSkd !== null &&
          clientsData.type === "sankcja kredytu darmowego" ? (
            <>
              {" "}
              <tr>
                <td>Ilość rat</td>
                <td>{clientsData.irSkd}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}

          {clientsData.koSkd !== undefined &&
          clientsData.koSkd !== null &&
          clientsData.type === "sankcja kredytu darmowego" ? (
            <>
              {" "}
              <tr>
                <td>Kwota odsetek</td>
                <td>{clientsData.koSkd}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}

          {clientsData.kupSkd !== undefined &&
          clientsData.kupSkd !== null &&
          clientsData.type === "sankcja kredytu darmowego" ? (
            <>
              {" "}
              <tr>
                <td>Kwota uiszczonej prowizji</td>
                <td>{clientsData.kupSkd}</td>
                <td>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
        </>
      </table>
      <div className="boxAdditionalFunFlex">
        {clientsData.type !== "antywindykacja" ? (
          <button
            id="specialClients"
            className="paymentMenuButton"
            onClick={handleShowAddClientQuestionnaire}
          >
            Ankieta do sprawy
          </button>
        ) : (
          ""
        )}
      </div>
    </>
  );

  const lawsuitDataMobile = (
    <>
      <table
        id="detailClientTable"
        className="clients_table"
        style={{ fontSize: "2vw" }}
      >
        <>
          <tr>
            <td>Aktualny sąd</td>
            <td>{clientsData.newCourt}</td>
            <td style={{ verticalAlign: "middle" }}>
              <button
                style={{
                  width: "35%",
                  backgroundColor: "#a5bea4",
                  color: "white",
                  borderColor: "white",
                  fontSize: "1.5vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowAddSygnPopUp}
              >
                {"Dodaj"}
              </button>
              <button
                style={{
                  marginLeft: "10px",
                  width: "35%",
                  backgroundColor: "#a5bea4",
                  color: "white",
                  borderColor: "white",
                  fontSize: "1.5vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowSygnPopUp}
              >
                {"Pokaż"}
              </button>
            </td>
          </tr>
          <tr>
            <td>Notatka do sprawy</td>
            <td>
              {clientsData.note === "" || clientsData.note === undefined
                ? "brak danych"
                : clientsData.note.substring(0, 100) + "..."}
            </td>
            <td>
              <button
                style={{
                  width: "35%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                onClick={handleShowAddClientNote}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
              <button
                style={{
                  width: "35%",
                  marginLeft: "10px",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value={clientsData.note}
                onClick={handleShowNote}
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Wniosek o zabezpieczenie</td>
            <td>
              {clientsData.application_for_protection === ""
                ? "brak danych"
                : clientsData.application_for_protection}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sec_wn"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>KWOTA NADPŁATY W PLN</td>
            <td>
              {!clientsData.nadPLN ||
              clientsData.nadPLN === "" ||
              clientsData.nadPLN === undefined
                ? "brak danych"
                : numberWithCommas(clientsData.nadPLN) + " PLN"}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowEditNadPLN}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>KWOTA NADPŁATY W CHF</td>
            <td>
              {!clientsData.nadCHF ||
              clientsData.nadCHF === "" ||
              clientsData.nadCHF === undefined
                ? "brak danych"
                : numberWithCommas(clientsData.nadCHF) + " PLN"}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowEditNadCHF}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Checklista do pozwu</td>
              <td style={{ textAlign: "left", padding: "5px 10px" }}>
                {clientsData.checklist
                  ? JSON.parse(
                      clientsData.checklist
                        .replaceAll(/\\n/g, "\\n")
                        .replaceAll(/\\'/g, "\\'")
                        .replaceAll(/\\"/g, '\\"')
                        .replaceAll(/\\&/g, "\\&")
                        .replaceAll(/\\r/g, "\\r")
                        .replaceAll(/\\t/g, "\\t")
                        .replaceAll(/\\b/g, "\\b")
                        .replaceAll(/\\f/g, "\\f")
                        .replaceAll(/\n/g, "\\\\n")
                        .replaceAll(/\r/g, "\\\\r")
                        .replaceAll(/\t/g, "\\\\t")
                    ).map((el, index) => (
                      <>
                        {index + 1}. {el.question} :{" "}
                        {el.result === true
                          ? "PRAWDA"
                          : el.result === false
                          ? "FAŁSZ"
                          : el.result === ""
                          ? "nie uzupełniono"
                          : el.result}{" "}
                        {el.note ? <>({el.note})</> : ""}
                        <br />
                      </>
                    ))
                  : "nie uzupełniono"}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowAddChecklist}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data otrzymania zaświadczenia od klienta</td>
              <td>
                {clientsData.data_zasw === ""
                  ? "brak danych"
                  : clientsData.data_zasw}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditDZ}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Sporządzający wezwanie do zapłaty</td>
              <td>
                {clientsData.praw_wezw === ""
                  ? "brak danych"
                  : clientsData.praw_wezw}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditPW}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data wezwania do zapłaty</td>
              <td>
                {clientsData.data_wezw === ""
                  ? "brak danych"
                  : clientsData.data_wezw}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditDW}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Osoba odpowiedzialna za pozew</td>
              <td>
                {clientsData.praw_pozew === ""
                  ? "brak danych"
                  : clientsData.praw_pozew}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditPP}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Osoba sprawdzająca pozew</td>
              <td>
                {clientsData.praw_spr_pozew === ""
                  ? "brak danych"
                  : clientsData.praw_spr_pozew}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="sec_wn"
                  onClick={handleShowEditPSP}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>Bank</td>
            <td>
              {clientsData.bank === "" ? "brak danych" : clientsData.bank}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Podmiot z umowy kredytowej</td>
            <td>
              {clientsData.bank_old === ""
                ? "brak danych"
                : clientsData.bank_old}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="bank"
                onClick={handleShowEditBO}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Data umowy kredytowej</td>
            <td>
              {clientsData.credit_date === ""
                ? "brak danych"
                : clientsData.credit_date}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="credit_date"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Numer umowy kredytowej</td>
            <td>
              {clientsData.credit_aggr_num === ""
                ? "brak danych"
                : clientsData.credit_aggr_num}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="credit_date"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          <tr>
            <td>Kwota kredytu</td>
            <td>
              {clientsData.credit_value === "" ||
              clientsData.credit_value === undefined
                ? "brak danych"
                : numberWithCommas(
                    clientsData.credit_value.split(" ")[0].replaceAll(" ", "")
                  ) +
                  " " +
                  clientsData.credit_value.split(" ")[1]}
            </td>
            <td>
              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "3vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="credit_value"
                onClick={handleShowAddClient}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </td>
          </tr>
          {clientsData.wezwPlnValue !== undefined &&
          clientsData.wezwPlnValue !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              {" "}
              <tr>
                <td>Wezwanie - kwota w PLN</td>
                <td>{clientsData.wezwPlnValue} PLN</td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.wezwChfValue !== undefined &&
          clientsData.wezwChfValue !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              {" "}
              <tr>
                <td>Wezwanie - kwota w CHF</td>
                <td>{clientsData.wezwChfValue} CHF</td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.wezwLastPayDate !== undefined &&
          clientsData.wezwLastPayDate !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              {" "}
              <tr>
                <td>Wezwanie - ostatnia wpłata przypada na dzień</td>
                <td>{clientsData.wezwLastPayDate}</td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.wezwPayTime !== undefined &&
          clientsData.wezwPayTime !== null &&
          clientsData.type !== "antywindykacja" ? (
            <>
              {" "}
              <tr>
                <td>Wezwanie - termin płatności</td>
                <td>{clientsData.wezwPayTime}</td>
                <td>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "3vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="credit_value"
                    onClick={(e) => setShowEditWezwData(true)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </td>
              </tr>
            </>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data doręczenia wezwania</td>
              <td>
                {clientsData.dateDeliverWezw !== undefined &&
                clientsData.dateDeliverWezw !== null
                  ? clientsData.dateDeliverWezw.length > 0
                    ? clientsData.dateDeliverWezw
                    : "brak danych"
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={(e) => setShowLawsuitData(true)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Data wymagalności</td>
              <td>
                {clientsData.dateWym !== undefined &&
                clientsData.dateWym !== null
                  ? clientsData.dateWym.length > 0
                    ? clientsData.dateWym
                    : "brak danych"
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={(e) => setShowLawsuitData(true)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Rzeczywiście wypłacona kwota kredytu</td>
              <td>
                {clientsData.realCreditValue !== undefined &&
                clientsData.realCreditValue !== null
                  ? +clientsData.realCreditValue > 0
                    ? numberWithCommas(clientsData.realCreditValue) + " PLN"
                    : "0 PLN"
                  : "0 PLN"}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={(e) => setShowLawsuitData(true)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
          {clientsData.type !== "antywindykacja" ? (
            <tr>
              <td>Potwierdzenie nadania wezwania</td>
              <td>
                {clientsData.sendDate !== undefined &&
                clientsData.sendDate !== null
                  ? clientsData.sendDate
                  : "brak danych"}
              </td>
              <td>
                <button
                  style={{
                    backgroundColor: "transparent",
                    color: "#a5bea4",
                    border: "none",
                    fontSize: "3vw",
                  }}
                  id="clientsButton"
                  className="paymentMenuButton"
                  value="credit_value"
                  onClick={showLawsuitDataFu}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              </td>
            </tr>
          ) : (
            ""
          )}
        </>
      </table>
      <div className="boxAdditionalFunFlex">
        <button
          id="specialClients"
          className="paymentMenuButton"
          onClick={handleShowAddClientQuestionnaire}
          style={{ fontSize: "3vw", width: "70%" }}
        >
          Ankieta do sprawy
        </button>
      </div>
    </>
  );

  const tasksData = (
    <>
      {tasksForClient.length === 0 ? (
        <>Brak zadań dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Zadanie
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Prawnik
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data wprowadzenia
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data wykonania
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                ></th>
              </tr>
              {tasksForClient
                .sort((a, b) => new Date(b.final_date) - new Date(a.final_date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.task}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.responsible}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.start_date}
                      </td>
                      <td
                        style={{
                          fmaxWidth: "15%",
                          ontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.final_date}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.status}
                      </td>
                      <td style={{ width: "30%", paddingLeft: "15px" }}>
                        <button
                          style={{
                            width: "55%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showTaskPopUp}
                        >
                          {"Pokaż zadanie"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const tasksDataMobile = (
    <>
      {tasksForClient.length === 0 ? (
        <>Brak zadań dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px", fontSize: "2vw" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Zadanie
                </th>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Data wykonania
                </th>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Status
                </th>
                <th
                  style={{
                    height: "3vh",
                  }}
                ></th>
              </tr>
              {tasksForClient
                .sort((a, b) => new Date(b.final_date) - new Date(a.final_date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          height: "3vh",
                        }}
                      >
                        {el.task}
                      </td>
                      <td
                        style={{
                          fmaxWidth: "15%",
                          height: "3vh",
                        }}
                      >
                        {el.final_date}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          height: "3vh",
                        }}
                      >
                        {el.status}
                      </td>
                      <td style={{ width: "30%", paddingLeft: "15px" }}>
                        <button
                          style={{
                            width: "90%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                            fontSize: "2vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showTaskPopUp}
                        >
                          {"Pokaż zadanie"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const hearingsData = (
    <>
      {hearingsForClient.length === 0 ? (
        <>Brak rozpraw dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Prawnik
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Sygnatura
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data rozprawy
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Wynik
                </th>
                <th></th>
              </tr>
              {hearingsForClient
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.lawyer}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.sygn}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.date} {el.time}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.result}
                      </td>
                      <td style={{ width: "30%", paddingLeft: "15px" }}>
                        <button
                          style={{
                            width: "55%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showDatePopUp}
                        >
                          {"Szczegóły rozprawy"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const hearingsDataMobile = (
    <>
      {hearingsForClient.length === 0 ? (
        <>Brak rozpraw dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px", fontSize: "2vw" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Prawnik
                </th>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Sygnatura
                </th>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Data rozprawy
                </th>
                <th
                  style={{
                    height: "3vh",
                  }}
                >
                  Wynik
                </th>
                <th></th>
              </tr>
              {hearingsForClient
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "15%",
                          height: "3vh",
                        }}
                      >
                        {el.lawyer}
                      </td>
                      <td
                        style={{
                          width: "15%",
                          height: "3vh",
                        }}
                      >
                        {el.sygn}
                      </td>
                      <td
                        style={{
                          width: "15%",
                          height: "3vh",
                        }}
                      >
                        {el.date} {el.time}
                      </td>
                      <td
                        style={{
                          wWidth: "25%",
                          height: "3vh",
                        }}
                      >
                        {el.result}
                      </td>
                      <td style={{ width: "30%", paddingLeft: "15px" }}>
                        <button
                          style={{
                            width: "55%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                            fontSize: "1.5vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showDatePopUp}
                        >
                          {"Szczegóły"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const clientsContactData = (
    <>
      {contactsForClient.length === 0 ? (
        <>Brak kontaktów z klientem dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data kontaktu
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Rodzaj kontaktu
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Treść
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Użytkownik
                </th>
                <th></th>
              </tr>
              {contactsForClient
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate()) +
                          " " +
                          new Date(el.date).getHours() +
                          ":" +
                          new Date(el.date).getMinutes()}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.type}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          padding: "5px 10px",
                        }}
                      >
                        {el.content.substring(0, 100)}...
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          padding: "5px 10px",
                        }}
                      >
                        {el.user}
                      </td>
                      <td style={{ width: "30%", paddingLeft: "15px" }}>
                        <button
                          style={{
                            width: "55%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showClientContactPopUp}
                        >
                          {"Szczegóły kontaktu"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const clientsContactDataMobile = (
    <>
      {contactsForClient.length === 0 ? (
        <>Brak kontaktów z klientem dla tej sprawy</>
      ) : (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data kontaktu
                </th>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Rodzaj kontaktu
                </th>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Treść
                </th>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Użytkownik
                </th>
                <th></th>
              </tr>
              {contactsForClient
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate()) +
                          " " +
                          new Date(el.date).getHours() +
                          ":" +
                          new Date(el.date).getMinutes()}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.type}
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          padding: "5px 10px",
                        }}
                      >
                        {el.content.substring(0, 100)}...
                      </td>
                      <td
                        style={{
                          maxWidth: "15%",
                          fontSize: "2vw",
                          height: "3vh",
                          padding: "5px 10px",
                        }}
                      >
                        {el.user}
                      </td>
                      <td style={{ width: "30%", padding: "5px" }}>
                        <button
                          style={{
                            width: "100%",
                            backgroundColor: "#a5bea4",
                            color: "white",
                            borderColor: "white",
                            fontSize: "1.5vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.id}
                          onClick={showClientContactPopUp}
                        >
                          {"Szczegóły kontaktu"}
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const getPaymentsSum = () => {
    var sum = 0;
    paymentsForClient.map((el) => {
      sum = sum + +el.to_settlement;
    });

    return sum.toFixed(2);
  };

  const getInstallmentSum = () => {
    var sum = 0;
    paymentsForClient.map((el) => {
      sum = sum + +el.installment.replace(",", ".");
    });

    return sum.toFixed(2);
  };

  const getTransactionsForPayment = (id) => {
    var trArr = transactionsData.filter((el) => el.payId === id);

    return trArr;
  };

  const handleExpandPayment = (e) => {
    if (e.target.value === expand) {
      setExpand("");
    } else {
      setExpand(e.target.value);
    }
  };

  const getRecValue = () => {
    var val = 0;
    recommendations.map((el) => {
      val = val + +el.value;
    });

    return val;
  };

  const deleteRec = async (e) => {
    var bodyX = {
      id: e.target.value,
    };

    fetch("https://apidevkppp.ftpeople.pl/deleteRecommendation", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(bodyX),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "polecenie",
        }).then(async (result) => {
          getData();
        });
      });
  };

  const paymentsData = (
    <>
      <div className="paymentClientInfoBox">
        <p>
          Suma zobowiązań: <strong>{getPaymentsSum()} zł</strong>
        </p>
        <p>
          Łączna ilość rat: <strong>{getInstallmentSum()}</strong>
        </p>
      </div>
      {paymentsForClient.map((el) => (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Identyfikator
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data pierwszej płatności
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Ilość rat do zapłaty
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Kwota wpłacona
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Ilość rat wpłaconych
                </th>

                <th></th>
              </tr>
              <tr>
                <td style={{ width: "30%", fontSize: "1vw" }}>
                  <strong>{el.identifier}</strong>
                </td>
                <td style={{ width: "30%" }}>{el.first_payment_date}</td>
                <td style={{ width: "8%" }}>{el.installment}</td>
                <td style={{ width: "8%" }}>{el.pay_sum}</td>
                <td style={{ width: "8%" }}>
                  {getTransactionsForPayment(el.identifier).length}
                </td>

                <td style={{ width: "8%", cursor: "pointer" }}>
                  {getTransactionsForPayment(el.identifier).length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            marginLeft: "10px",
                            width: "10%",
                            backgroundColor: "transparent",
                            color: "#a5bea4",
                            border: "none",
                            fontSize: "1vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.identifier}
                          onClick={handleShowPaymentReport}
                        >
                          <FontAwesomeIcon value={el.identifier} icon={faEye} />
                        </button>
                        <strong>
                          <button
                            style={{
                              color: "white",
                              backgroundColor: "#a5bea4",
                              border: "none",
                              fontWeight: "900",
                            }}
                            value={el.identifier}
                            onClick={handleExpandPayment}
                          >
                            {"↓"}
                          </button>
                        </strong>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            marginLeft: "10px",
                            width: "10%",
                            backgroundColor: "transparent",
                            color: "#a5bea4",
                            border: "none",
                            fontSize: "1vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.identifier}
                          onClick={handleShowPaymentReport}
                        >
                          <FontAwesomeIcon value={el.identifier} icon={faEye} />
                        </button>
                        <strong>
                          <button
                            style={{
                              color: "white",
                              backgroundColor: "transparent",
                              border: "none",
                              fontWeight: "900",
                            }}
                            value={el.identifier}
                            onClick={handleExpandPayment}
                          >
                            .
                          </button>
                        </strong>
                      </div>
                    </>
                  )}
                </td>
              </tr>
            </>
          </table>
          <div
            id={expand === el.identifier ? "showTr" : ""}
            className="paymentsToExpand"
          >
            {getTransactionsForPayment(el.identifier).length > 0 ? (
              <>
                <table
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                  id="detailClientTable"
                  className="clients_table"
                >
                  <>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        Identyfikator
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        Data transakcji
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        Kwota
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        Tytuł przelewu
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        Nadawca
                      </th>
                    </tr>
                    {getTransactionsForPayment(el.identifier).map((el2) => (
                      <>
                        <tr>
                          <td style={{ width: "15%" }}>{el2.tr_id}</td>
                          <td style={{ width: "10%" }}>{el2.date}</td>
                          <td style={{ width: "10%" }}>{el2.bill}</td>
                          <td style={{ width: "35%" }}>{el2.title}</td>
                          <td style={{ width: "30%" }}>{el2.client}</td>
                        </tr>
                      </>
                    ))}
                  </>
                </table>
              </>
            ) : (
              ""
            )}
          </div>
        </>
      ))}
      <div>
        <button
          className="paymentMenuButton"
          onClick={handleShowClientRecommendation}
        >
          Dodaj polecenie
        </button>
      </div>
      {recommendations.length > 0 ? (
        <>
          <div>
            <table
              style={{
                width: "50%",
                marginTop: "20px",
                marginBottom: "20px",
              }}
              id="detailClientTable"
              className="clients_table"
            >
              <>
                <tr>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Identyfikator
                  </th>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Klient
                  </th>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Wartość
                  </th>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Akcja
                  </th>
                </tr>
                {recommendations.map((el2) => (
                  <>
                    <tr>
                      <td style={{ width: "5%" }}>{el2.id}</td>
                      <td style={{ width: "20%", lineBreak: "anywhere" }}>
                        {el2.name}
                      </td>
                      <td style={{ width: "20%" }}>{el2.value} PLN</td>
                      <td style={{ width: "20%" }}>
                        <button
                          className="paymentMenuButton"
                          onClick={deleteRec}
                          value={el2.id}
                        >
                          USUŃ
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
              </>
            </table>
            <div>
              <p>Wartość poleceń: {getRecValue()} PLN</p>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  const paymentsDataMobile = (
    <>
      <div className="paymentClientInfoBox">
        <p style={{ fontSize: "3vw" }}>
          Suma zobowiązań: <strong>{getPaymentsSum()} zł</strong>
        </p>
        <p style={{ fontSize: "3vw" }}>
          Łączna ilość rat: <strong>{getInstallmentSum()}</strong>
        </p>
      </div>
      {paymentsForClient.map((el) => (
        <>
          <table
            style={{ marginTop: "20px", marginBottom: "20px", fontSize: "2vw" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    height: "3vh",
                    fontSize: "2vw",
                  }}
                >
                  Identyfikator
                </th>
                <th
                  style={{
                    height: "3vh",
                    fontSize: "2vw",
                  }}
                >
                  Kwota wpłacona
                </th>
                <th
                  style={{
                    height: "3vh",
                    fontSize: "2vw",
                  }}
                >
                  Ilość rat wpłaconych
                </th>

                <th></th>
              </tr>
              <tr>
                <td style={{ width: "30%" }}>
                  <strong>{el.identifier}</strong>
                </td>
                <td style={{ width: "8%" }}>{el.pay_sum}</td>
                <td style={{ width: "8%" }}>
                  {getTransactionsForPayment(el.identifier).length}
                </td>

                <td style={{ width: "8%", cursor: "pointer" }}>
                  {getTransactionsForPayment(el.identifier).length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            marginLeft: "10px",
                            width: "10%",
                            backgroundColor: "transparent",
                            color: "#a5bea4",
                            border: "none",
                            fontSize: "3vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.identifier}
                          onClick={handleShowPaymentReport}
                        >
                          <FontAwesomeIcon value={el.identifier} icon={faEye} />
                        </button>
                        <strong>
                          <button
                            style={{
                              color: "white",
                              backgroundColor: "#a5bea4",
                              border: "none",
                              fontWeight: "900",
                            }}
                            value={el.identifier}
                            onClick={handleExpandPayment}
                          >
                            {"↓"}
                          </button>
                        </strong>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            marginLeft: "10px",
                            width: "10%",
                            backgroundColor: "transparent",
                            color: "#a5bea4",
                            border: "none",
                            fontSize: "1vw",
                          }}
                          id="clientsButton"
                          className="paymentMenuButton"
                          value={el.identifier}
                          onClick={handleShowPaymentReport}
                        >
                          <FontAwesomeIcon value={el.identifier} icon={faEye} />
                        </button>
                        <strong>
                          <button
                            style={{
                              color: "white",
                              backgroundColor: "transparent",
                              border: "none",
                              fontWeight: "900",
                            }}
                            value={el.identifier}
                            onClick={handleExpandPayment}
                          >
                            .
                          </button>
                        </strong>
                      </div>
                    </>
                  )}
                </td>
              </tr>
            </>
          </table>
          <div
            id={expand === el.identifier ? "showTr" : ""}
            className="paymentsToExpand"
          >
            {getTransactionsForPayment(el.identifier).length > 0 ? (
              <>
                <table
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    marginBottom: "20px",
                    fontSize: "2vw",
                  }}
                  id="detailClientTable"
                  className="clients_table"
                >
                  <>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          height: "3vh",
                          paddingRight: "15px",
                          fontSize: "2vw",
                        }}
                      >
                        Identyfikator
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          height: "3vh",
                          paddingRight: "15px",
                          fontSize: "2vw",
                        }}
                      >
                        Data transakcji
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          height: "3vh",
                          paddingRight: "15px",
                          fontSize: "2vw",
                        }}
                      >
                        Kwota
                      </th>
                      <th
                        style={{
                          backgroundColor: "rgb(187, 186, 186)",
                          height: "3vh",
                          paddingRight: "15px",
                          fontSize: "2vw",
                        }}
                      >
                        Nadawca
                      </th>
                    </tr>
                    {getTransactionsForPayment(el.identifier).map((el2) => (
                      <>
                        <tr>
                          <td style={{ width: "15%" }}>{el2.tr_id}</td>
                          <td style={{ width: "10%" }}>{el2.date}</td>
                          <td style={{ width: "10%" }}>{el2.bill}</td>
                          <td style={{ width: "30%" }}>{el2.client}</td>
                        </tr>
                      </>
                    ))}
                  </>
                </table>
              </>
            ) : (
              ""
            )}
          </div>
        </>
      ))}
      {recommendations.length > 0 ? (
        <>
          <div>
            <table
              style={{
                width: "50%",
                marginTop: "20px",
                marginBottom: "20px",
              }}
              id="detailClientTable"
              className="clients_table"
            >
              <>
                <tr>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Identyfikator
                  </th>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Klient
                  </th>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Wartość
                  </th>
                  <th
                    style={{
                      backgroundColor: "rgb(187, 186, 186)",
                      fontSize: "0.8vw",
                      height: "3vh",
                      paddingRight: "15px",
                    }}
                  >
                    Akcja
                  </th>
                </tr>
                {recommendations.map((el2) => (
                  <>
                    <tr>
                      <td style={{ width: "5%" }}>{el2.id}</td>
                      <td style={{ width: "20%", lineBreak: "anywhere" }}>
                        {el2.name}
                      </td>
                      <td style={{ width: "20%" }}>{el2.value} PLN</td>
                      <td style={{ width: "20%" }}>
                        <button
                          className="paymentMenuButton"
                          onClick={deleteRec}
                          value={el2.id}
                        >
                          USUŃ
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
              </>
            </table>
            <div>
              <p>Wartość poleceń: {getRecValue()} PLN</p>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  const getSFValue = () => {
    var sf = 0;
    var value = 0;
    if (curr === 0) {
      return 0;
    }
    if (clientsData.credit_value === undefined) {
      sf = 0;
    } else {
      if (
        clientsData.credit_value.split(" ")[1] === "CHF" ||
        clientsData.credit_value.split(" ")[1] === "EUR" ||
        clientsData.credit_value.split(" ")[1] === "USD"
      ) {
        value =
          +clientsData.credit_value.split(" ")[0].replaceAll(",", ".") * curr;
        if (clientsData.sf_type === "credit") {
          sf = (+clientsData.sf.replaceAll(",", ".") * value).toFixed(0);
        } else {
          sf = (+clientsData.sf.replaceAll(",", ".") * clientsData.wps).toFixed(
            0
          );
        }
      } else {
        value = +clientsData.credit_value.split(" ")[0].replaceAll(",", ".");
        if (clientsData.sf_type === "credit") {
          sf = (+clientsData.sf.replaceAll(",", ".") * value).toFixed(0);
        } else {
          sf = (+clientsData.sf.replaceAll(",", ".") * clientsData.wps).toFixed(
            0
          );
        }
      }
    }

    return sf;
  };

  const getKZPValue = () => {
    var sf = 0;
    var value = 0;

    if (clientsData.wps === "" || clientsData.wps === undefined) {
      sf = "brak WPS";
    } else {
      value = +clientsData.wps;
      if (value <= 50000) {
        sf = 3600;
      } else if (value > 50000 && value <= 200000) {
        sf = 5400 + 4100;
      } else if (value > 200000) {
        sf = 10800 + 8100;
      }
    }

    return sf;
  };

  const income = (
    <>
      <p style={{ textTransform: "uppercase" }}>
        Success Fee: {numberWithCommas(getSFValue())} PLN
      </p>
      <p style={{ textTransform: "uppercase" }}>
        KZP:{" "}
        {getKZPValue() === "brak WPS"
          ? numberWithCommas(getKZPValue())
          : numberWithCommas(getKZPValue()) + " PLN"}
      </p>
      <br />
      {getSFValue() === 0 ? (
        <>
          <span style={{ color: "red" }}>
            Nie udało się pobrać kursu waluty na dzień wypłaty kredytu
          </span>
          <br />
        </>
      ) : (
        ""
      )}
      {clientsData.ow === "" ? (
        <>
          <span style={{ color: "red" }}>
            Nie uzupełniono szczegółów współpracy z kancelarią
          </span>
        </>
      ) : (
        ""
      )}
      <br />
      <p style={{ fontWeight: "600", textTransform: "uppercase" }}>
        Łącznie prognozowany przychód:{" "}
        {numberWithCommas(
          +getSFValue() + (getKZPValue() === "brak WPS" ? 0 : getKZPValue())
        )}{" "}
        PLN
      </p>
    </>
  );

  const logData = (
    <>
      {logsForClient.length === 0 ? (
        <>Brak logów dla tej sprawy</>
      ) : (
        <>
          <div style={{ marginBottom: "3vh", width: "30%" }}>
            <select
              style={{ height: "3vh" }}
              type="text"
              id="court"
              name="court"
              value={logUserFilter}
              onChange={(e) => setLogUserFilter(e.target.value)}
            >
              <option key={0} value="all">
                Wszyscy
              </option>
              {logUsers.map((el) => (
                <>
                  <option key={el} value={el}>
                    {el}
                  </option>
                </>
              ))}
            </select>
          </div>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Prawnik
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Akcja
                </th>
                <th
                  style={{
                    fontSize: "0.8vw",
                    height: "3vh",
                    paddingRight: "15px",
                  }}
                >
                  Data
                </th>
              </tr>
              {logsForClient
                .filter((el) =>
                  logUserFilter === "all" ? true : el.lawyer === logUserFilter
                )
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.lawyer}
                      </td>
                      <td
                        style={{
                          maxWidth: "80%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.value}
                      </td>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "0.8vw",
                          height: "3vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate())}{" "}
                        {(new Date(el.date).getHours() < 10
                          ? "0" + new Date(el.date).getHours()
                          : new Date(el.date).getHours()) +
                          ":" +
                          (new Date(el.date).getMinutes() < 10
                            ? "0" + new Date(el.date).getMinutes()
                            : new Date(el.date).getMinutes())}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const logDataMobile = (
    <>
      {logsForClient.length === 0 ? (
        <>Brak logów dla tej sprawy</>
      ) : (
        <>
          <div style={{ marginBottom: "3vh", width: "100%" }}>
            <select
              style={{ height: "3vh" }}
              type="text"
              id="court"
              name="court"
              value={logUserFilter}
              onChange={(e) => setLogUserFilter(e.target.value)}
            >
              <option key={0} value="all">
                Wszyscy
              </option>
              {logUsers.map((el) => (
                <>
                  <option key={el} value={el}>
                    {el}
                  </option>
                </>
              ))}
            </select>
          </div>
          <table
            style={{ marginTop: "20px", marginBottom: "20px" }}
            id="detailClientTable"
            className="clients_table"
          >
            <>
              <tr>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "2vh",
                    paddingRight: "15px",
                  }}
                >
                  Prawnik
                </th>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "2vh",
                    paddingRight: "15px",
                  }}
                >
                  Akcja
                </th>
                <th
                  style={{
                    fontSize: "2vw",
                    height: "2vh",
                    paddingRight: "15px",
                  }}
                >
                  Data
                </th>
              </tr>
              {logsForClient
                .filter((el) =>
                  logUserFilter === "all" ? true : el.lawyer === logUserFilter
                )
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((el) => (
                  <>
                    <tr>
                      <td
                        style={{
                          maxWidth: "10%",
                          fontSize: "2vw",
                          height: "2vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.lawyer}
                      </td>
                      <td
                        style={{
                          maxWidth: "70%",
                          fontSize: "2vw",
                          height: "2vh",
                          paddingRight: "15px",
                        }}
                      >
                        {el.value}
                      </td>
                      <td
                        style={{
                          maxWidth: "20%",
                          fontSize: "1.5vw",
                          height: "2vh",
                          paddingRight: "15px",
                        }}
                      >
                        {new Date(el.date).getFullYear() +
                          "-" +
                          (new Date(el.date).getMonth() + 1 < 10
                            ? "0" + (new Date(el.date).getMonth() + 1)
                            : new Date(el.date).getMonth() + 1) +
                          "-" +
                          (new Date(el.date).getDate() < 10
                            ? "0" + new Date(el.date).getDate()
                            : new Date(el.date).getDate())}{" "}
                        {(new Date(el.date).getHours() < 10
                          ? "0" + new Date(el.date).getHours()
                          : new Date(el.date).getHours()) +
                          ":" +
                          (new Date(el.date).getMinutes() < 10
                            ? "0" + new Date(el.date).getMinutes()
                            : new Date(el.date).getMinutes())}
                      </td>
                    </tr>
                  </>
                ))}
            </>
          </table>
        </>
      )}
    </>
  );

  const getName = (index) => {
    var value = uploadFilesNamesArray
      .filter((el) => el.id === index)[0]
      .name.split(".")[0];

    return value;
  };

  const getNameChanged = (index) => {
    var value = uploadFilesNamesArrayChanged
      .filter((el) => el.id === index)[0]
      .name.split(".")[0];

    return value;
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const sendFiles = async (e) => {
    var length = uploadFilesArray.length;
    var progr = 0;
    if (length > 0) {
      uploadFilesArray.map(async (file) => {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("type", fileType);
        formData.append("clientId", props.id);
        formData.append("taskId", "");
        formData.append("user", props.user);

        await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            return response.text();
          })
          .then((responseJson) => {
            ++progr;
            MySwal.fire({
              icon: "success",
              title: "Wysłano plik: " + progr + "/" + length,
              text: "",
            }).then(async (result) => {
              if (progr === length) {
                MySwal.fire({
                  icon: "success",
                  title: "Dodano",
                  text: "pliki",
                }).then((result) => {
                  props.logClientAction("Dodano pliki do sprawy", props.id);
                  setUploadFiles([]);
                  setUploadFilesArray([]);
                  getData();
                });
              }
            });
          });
      });
    } else {
      MySwal.fire({
        icon: "success",
        title: "Dodano",
        text: "pliki",
      }).then((result) => {
        props.logClientAction("Dodano pliki do sprawy", props.id);
        setUploadFiles([]);
        setUploadFilesArray([]);
        getData();
      });
    }
  };

  const documents = (
    <>
      <input multiple={true} type="file" onChange={changeFiles} />
      <div style={{ marginTop: "0", marginBottom: "5vh" }} className="inputBox">
        <div className="inputCol_2">
          <label>Kategoria plików</label>
          <select
            style={{ height: "3vh" }}
            type="text"
            id="court"
            name="court"
            value={fileType}
            onChange={(e) => setFileType(e.target.value)}
          >
            <option key={0} value="co-op">
              Dokumenty do współpracy z kancelarią
            </option>
            <option key={1} value="credit">
              Dokumenty kredytowe
            </option>
            <option key={2} value="court">
              Pisma z sądu
            </option>
            <option key={2} value="bank">
              Pisma z banku
            </option>
            <option key={3} value="send">
              Pisma wysłane do sprawy
            </option>
            <option key={4} value="other">
              Inne
            </option>
            <option key={5} value="segr">
              Zeskanowany segregator fizyczny
            </option>
          </select>
        </div>
      </div>
      {uploadFilesArray.length > 0 ? (
        <>
          <table
            style={{ width: "80%" }}
            id="detailClientTable"
            className="clients_table"
          >
            <tr>
              <th>Nazwa pliku</th>
              <th>Plik</th>
              <th></th>
            </tr>
            {uploadFilesArray.length > 0
              ? uploadFilesArray.map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "50%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <div style={{ display: "flex", gap: "10px" }}>
                          <input
                            id={"fn" + index}
                            name={"fn" + index}
                            style={{ height: "2vh", marginTop: "0" }}
                            type="text"
                            value={inputs[index]}
                            onChange={(e) =>
                              setInputs((prev) => {
                                return { ...prev, [index]: e.target.value };
                              })
                            }
                          />
                          <button
                            className="refreshButton"
                            value={index}
                            onClick={changeFileName}
                          >
                            zmień
                          </button>
                        </div>
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "40%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {el.name}
                      </td>
                      <td
                        style={{
                          textAlign: "left",
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={index}
                          onClick={deleteTempFile}
                        >
                          usuń
                        </button>
                      </td>
                    </tr>
                  </>
                ))
              : ""}
          </table>
          <div style={{ marginTop: "2vh" }}>
            <button
              style={{ width: "15%" }}
              className="refreshButton"
              onClick={sendFiles}
            >
              Wyślij
            </button>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  const handleExpandFiltersClick = (e) => {
    setExpandFilters(!expandFilters);
  };

  const deleteFileAccept = (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć dokument?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFile(e);
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteFile = async (e) => {
    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "plik",
    }).then((result) => {
      props.logClientAction("Usunięto plik", props.id);
      getData();
    });
  };

  const downloadAll = () => {
    setLoading(true);

    const zip = new JSZip();

    var count = 0;

    filesForClient.forEach(function (file) {
      var filename = file.name + "." + file.link.split(".").pop();
      // loading a file and add it in a zip file
      JSZipUtils.getBinaryContent(file.link, function (err, data) {
        if (err) {
          throw err; // or handle the error
        }
        zip.file(filename, data, { binary: true });
        count++;
        if (count == filesForClient.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, clientsData.petitioner + ".zip");
          });
        }
      });
    });
    getData();
  };

  const downloadFile = (e) => {
    var file = filesForClient.filter((el) => el.id === +e.target.value)[0];
    download(file.link, file.name, file.type);
  };

  const downloadFilePiProc = (e) => {
    var file = lawsuitsProceedingsFiles.filter(
      (el) => +el.docId === +e.target.value
    )[0];

    if (!file) {
      file = lawsuitsDocumentsFiles.filter(
        (el) => +el.docId === +e.target.value
      )[0];
    }

    download(
      file.link,
      filesForClient.filter((ek) => ek.link === file.link)[0].name,
      filesForClient.filter((ek) => ek.link === file.link)[0].type
    );
  };

  const downloadFilePiDev = (e) => {
    var file = lawsuitsDeliveriesFiles.filter(
      (el) => +el.docId === +e.target.value
    )[0];
    download(
      file.link,
      filesForClient.filter((ek) => ek.link === file.link)[0].name,
      filesForClient.filter((ek) => ek.link === file.link)[0].type
    );
  };

  const handleSearchFile = (e) => {
    if (e.target.value === "") {
      setFilesForClient(filesForClientOri);
    } else {
      setSFile(e.target.value);
      setLawsuitsExtFiles("all");
      setFilesForClient(
        filesForClientOri.filter((el) =>
          el.name
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSortDocs = () => {
    if (docSort === "up") {
      setDocSord("down");
      setFilesForClient(
        filesForClient.sort(function (a, b) {
          return new Date(b.dateSort) - new Date(a.dateSort);
        })
      );
    }
    if (docSort === "down") {
      setDocSord("up");
      setFilesForClient(
        filesForClient.sort(function (a, b) {
          return new Date(a.dateSort) - new Date(b.dateSort);
        })
      );
    }
  };

  const saveContent = (e) => {
    var rec = filesForClientOri.filter((el) => +el.id === +e.target.value)[0];
    var link = document.createElement("a");
    if (rec.type === "portal") {
      link.download = rec.name + ".pdf";
    } else {
      link.download = rec.name;
    }

    link.href = rec.link;
    link.click();
  };

  const documentsView2 = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "2vh",
        }}
      >
        <input
          style={{ width: "30%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"WYSZUKAJ PLIKI"}
          value={sFile}
          onChange={handleSearchFile}
        />
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("cat")}
        >
          WIDOK KATEGORII
        </button>
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={() => {
            setLawsuitsExtFiles(props.actualSygn);
            setLawsuitsCatFiles("all");
            setFilesForClient(filesForClientOri);
            setSFile("");
          }}
        >
          WYCZYŚĆ WIDOK
        </button>
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>
        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
      </div>
      {filesForClient.length > 0 ? (
        <>
          {filesForClient.filter((el) => +el.clientId === +props.id).length >
          0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                PLIKI
              </p>
              <table
                style={{ width: "80%" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th>Dodatkowe</th>
                </tr>
                {filesForClient
                  .filter((el) => +el.clientId === +props.id)
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                            lineBreak: "anywhere",
                          }}
                        >
                          {file.name}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.user}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {new Date(file.date).getFullYear() +
                            "-" +
                            (new Date(file.date).getMonth() + 1 < 10
                              ? "0" + (new Date(file.date).getMonth() + 1)
                              : new Date(file.date).getMonth() + 1) +
                            "-" +
                            (new Date(file.date).getDate() < 10
                              ? "0" + new Date(file.date).getDate()
                              : new Date(file.date).getDate())}{" "}
                          {(new Date(file.date).getHours() < 10
                            ? "0" + new Date(file.date).getHours()
                            : new Date(file.date).getHours()) +
                            ":" +
                            (new Date(file.date).getMinutes() < 10
                              ? "0" + new Date(file.date).getMinutes()
                              : new Date(file.date).getMinutes())}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={saveContent}
                              >
                                pokaż
                              </button>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.type === "portal" ? (
                            <></>
                          ) : (
                            <>
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const documentsView = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "2vh",
        }}
      >
        <input
          style={{ width: "20%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"WYSZUKAJ PLIKI"}
          value={sFile}
          onChange={handleSearchFile}
        />

        <select
          style={{ width: "25%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"wyszukaj pliki"}
          value={lawsuitsCatFiles}
          onChange={(e) => {
            setLawsuitsCatFiles(e.target.value);
            if (e.target.value === "portal") {
              setLawsuitsExtFiles("all");
            } else if (
              e.target.value.includes("PLIKI Z PORTALU INFORMACYJNEGO")
            ) {
              var res = e.target.value.split(" - ")[1];
              setLawsuitsExtFiles(res);
            } else {
              setLawsuitsExtFiles("");
            }
          }}
        >
          <option key={"WSZYSTKIE KATEGORIE"} value={"all"}>
            WSZYSTKIE KATEGORIE
          </option>
          <option key={"DOKUMENTY Z PORTALU INFORMACYJNEGO"} value={"portal"}>
            DOKUMENTY Z PORTALU INFORMACYJNEGO
          </option>
          <option
            key={"DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ"}
            value={"DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ"}
          >
            DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ
          </option>
          <option
            key={"PLIKI W PROCESIE ZAKŁADANIA SPRAWY"}
            value={"PLIKI W PROCESIE ZAKŁADANIA SPRAWY"}
          >
            PLIKI W PROCESIE ZAKŁADANIA SPRAWY
          </option>
          <option key={"PISMA AUTOMATYCZNE"} value={"PISMA AUTOMATYCZNE"}>
            PISMA AUTOMATYCZNE
          </option>
          <option key={"DOKUMENTY KREDYTOWE"} value={"DOKUMENTY KREDYTOWE"}>
            DOKUMENTY KREDYTOWE
          </option>
          <option key={"PISMA Z SĄDU"} value={"PISMA Z SĄDU"}>
            PISMA Z SĄDU
          </option>
          <option key={"PISMA Z BANKU"} value={"PISMA Z BANKU"}>
            PISMA Z BANKU
          </option>
          <option
            key={"PISMA WYSŁANE DO SPRAWY"}
            value={"PISMA WYSŁANE DO SPRAWY"}
          >
            PISMA WYSŁANE DO SPRAWY
          </option>
          <option key={"DOKUMENTY W ZADANIACH"} value={"DOKUMENTY W ZADANIACH"}>
            DOKUMENTY W ZADANIACH
          </option>
          <option key={"INNE"} value={"INNE"}>
            INNE
          </option>
          <option key={"ZAŁĄCZNIKI W MAILACH"} value={"ZAŁĄCZNIKI W MAILACH"}>
            ZAŁĄCZNIKI W MAILACH
          </option>
          <option
            key={"ZESKANOWANY SEGREGATOR FIZYCZNY"}
            value={"ZESKANOWANY SEGREGATOR FIZYCZNY"}
          >
            ZESKANOWANY SEGREGATOR FIZYCZNY
          </option>
          {lawsuitsDetails.map((l) => (
            <>
              <option
                key={`PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}`}
                value={`PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}`}
              >
                {`PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}`}
              </option>
            </>
          ))}
        </select>

        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("all")}
        >
          WIDOK BEZ KATEGORII
        </button>

        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={() => {
            setLawsuitsExtFiles(props.actualSygn);
            setLawsuitsCatFiles("all");
            setFilesForClient(filesForClientOri);
            setSFile("");
          }}
        >
          WYCZYŚĆ WIDOK
        </button>

        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>

        <button
          style={{ fontSize: "1vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
      </div>

      {filesForClient.length > 0 ? (
        <>
          {lawsuitsCatFiles === "DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {props.uData.allowedClients === "all" ? (
                <>
                  {filesForClient.filter(
                    (el) => el.type === "co-op" && +el.clientId === +props.id
                  ).length > 0 ? (
                    <>
                      <p
                        style={{ textTransform: "uppercase", fontSize: "2vw" }}
                      >
                        DOKUMENTY DO WSPÓŁPRACY Z kancelarią
                      </p>
                      <table
                        style={{ width: "80%" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Użytkownik</th>
                          <th>Data</th>
                          <th>Pokaż</th>
                          <th></th>
                        </tr>
                        {filesForClient
                          .filter(
                            (el) =>
                              el.type === "co-op" && +el.clientId === +props.id
                          )
                          .map((file) => (
                            <>
                              <tr>
                                <td
                                  style={{
                                    width: "30%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                    lineBreak: "anywhere",
                                  }}
                                >
                                  {file.name}
                                </td>
                                <td
                                  style={{
                                    width: "20%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                  }}
                                >
                                  {file.user}
                                </td>
                                <td
                                  style={{
                                    width: "20%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                  }}
                                >
                                  {new Date(file.date).getFullYear() +
                                    "-" +
                                    (new Date(file.date).getMonth() + 1 < 10
                                      ? "0" +
                                        (new Date(file.date).getMonth() + 1)
                                      : new Date(file.date).getMonth() + 1) +
                                    "-" +
                                    (new Date(file.date).getDate() < 10
                                      ? "0" + new Date(file.date).getDate()
                                      : new Date(file.date).getDate())}{" "}
                                  {(new Date(file.date).getHours() < 10
                                    ? "0" + new Date(file.date).getHours()
                                    : new Date(file.date).getHours()) +
                                    ":" +
                                    (new Date(file.date).getMinutes() < 10
                                      ? "0" + new Date(file.date).getMinutes()
                                      : new Date(file.date).getMinutes())}
                                </td>
                                <td
                                  style={{
                                    width: "10%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                  }}
                                >
                                  {file.link.includes(
                                    "apidevkppp.ftpeople.pl"
                                  ) && file.type !== "portal" ? (
                                    <>
                                      <button
                                        className="refreshButton"
                                        value={file.id}
                                        onClick={downloadFile}
                                      >
                                        pokaż
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="refreshButton"
                                        value={file.id}
                                        onClick={saveContent}
                                      >
                                        pokaż
                                      </button>
                                    </>
                                  )}
                                </td>
                                <td
                                  style={{
                                    width: "20%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                  }}
                                >
                                  <button
                                    style={{ fontSize: "0.8vw" }}
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={deleteFileAccept}
                                  >
                                    usuń
                                  </button>
                                  <button
                                    style={{
                                      marginLeft: "10px",
                                      fontSize: "0.8vw",
                                    }}
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={changeFileNameK}
                                  >
                                    zmień nazwę
                                  </button>
                                  <button
                                    style={{
                                      marginLeft: "10px",
                                      fontSize: "0.8vw",
                                      marginTop: "10px",
                                    }}
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={changeFileCategory}
                                  >
                                    zmień kategorię
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))}
                      </table>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
          {lawsuitsCatFiles === "PLIKI W PROCESIE ZAKŁADANIA SPRAWY" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "add" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    PLIKI W PROCESIE ZAKŁADANIA SPRAWY
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "add" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA AUTOMATYCZNE" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "auto" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    PISMA AUTOMATYCZNE
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "auto" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                                style={{ fontSize: "0.8vw" }}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "DOKUMENTY KREDYTOWE" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "credit" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    DOKUMENTY kredytowe
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) =>
                          el.type === "credit" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                                style={{ fontSize: "0.8vw" }}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA Z SĄDU" || lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "court" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    PISMA Z Sądu
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) =>
                          el.type === "court" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA Z BANKU" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "bank" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    pisma z banku
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "bank" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA WYSŁANE DO SPRAWY" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "send" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    pisma wysłane do sprawy
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "send" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "DOKUMENTY W ZADANIACH" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "task" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    dokumenty w zadaniach
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "task" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "INNE" || lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "other" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    Inne
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) =>
                          el.type === "other" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "ZESKANOWANY SEGREGATOR FIZYCZNY" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "segr" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    Zeskanowany segregator fizyczny
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "segr" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "0.8vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "ZAŁĄCZNIKI W MAILACH" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "mail" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
                    ZAŁĄCZNIKI W MAILACH
                  </p>
                  <table
                    style={{ width: "80%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Użytkownik</th>
                      <th>Data</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "mail" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.user}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {new Date(file.date).getFullYear() +
                                "-" +
                                (new Date(file.date).getMonth() + 1 < 10
                                  ? "0" + (new Date(file.date).getMonth() + 1)
                                  : new Date(file.date).getMonth() + 1) +
                                "-" +
                                (new Date(file.date).getDate() < 10
                                  ? "0" + new Date(file.date).getDate()
                                  : new Date(file.date).getDate())}{" "}
                              {(new Date(file.date).getHours() < 10
                                ? "0" + new Date(file.date).getHours()
                                : new Date(file.date).getHours()) +
                                ":" +
                                (new Date(file.date).getMinutes() < 10
                                  ? "0" + new Date(file.date).getMinutes()
                                  : new Date(file.date).getMinutes())}
                            </td>
                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                                style={{ fontSize: "0.8vw" }}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "0.8vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsDetails.map((l) => (
            <>
              {lawsuitsCatFiles ===
                `PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}` ||
              lawsuitsCatFiles === "portal" ||
              lawsuitsCatFiles === "all" ? (
                <>
                  {filesForClient.filter(
                    (el) =>
                      el.type === "portal" &&
                      +el.clientId === +props.id &&
                      (lawsuitsDocumentsFiles.filter(
                        (ex) =>
                          ex.lawsuitId === l.data.id && ex.link === el.link
                      ).length > 0 ||
                        lawsuitsDeliveriesFiles.filter(
                          (ex) =>
                            ex.lawsuitId === l.data.id && ex.link === el.link
                        ).length > 0 ||
                        lawsuitsProceedingsFiles.filter(
                          (ex) =>
                            ex.lawsuitId === l.data.id && ex.link === el.link
                        ).length > 0)
                  ).length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            textTransform: "uppercase",
                            fontSize: "2vw",
                          }}
                        >
                          PLIKI Z PORTALU INFORMACYJNEGO - {l.data.signature}
                        </p>
                        <div style={{ width: "20%" }}>
                          <button
                            className="refreshButton"
                            onClick={(e) => {
                              if (lawsuitsExtFiles === l.data.signature) {
                                setLawsuitsExtFiles("");
                              } else {
                                setLawsuitsExtFiles(l.data.signature);
                              }
                            }}
                          >
                            {lawsuitsExtFiles === l.data.signature ||
                            lawsuitsExtFiles === "all"
                              ? "zwiń"
                              : "pokaż"}
                          </button>
                        </div>
                      </div>
                      {lawsuitsExtFiles === l.data.signature ||
                      lawsuitsExtFiles === "all" ? (
                        <>
                          <table
                            style={{ width: "80%" }}
                            id="detailClientTable"
                            className="clients_table"
                          >
                            <tr>
                              <th>Nazwa pliku</th>
                              <th>Użytkownik</th>
                              <th>Data</th>
                              <th>Pokaż</th>
                              <th>Dodatkowe</th>
                            </tr>
                            {filesForClient
                              .filter(
                                (el) =>
                                  el.type === "portal" &&
                                  +el.clientId === +props.id &&
                                  (lawsuitsDocumentsFiles.filter(
                                    (ex) =>
                                      ex.lawsuitId === l.data.id &&
                                      ex.link === el.link
                                  ).length > 0 ||
                                    lawsuitsDeliveriesFiles.filter(
                                      (ex) =>
                                        ex.lawsuitId === l.data.id &&
                                        ex.link === el.link
                                    ).length > 0 ||
                                    lawsuitsProceedingsFiles.filter(
                                      (ex) =>
                                        ex.lawsuitId === l.data.id &&
                                        ex.link === el.link
                                    ).length > 0)
                              )
                              .map((file) => (
                                <>
                                  <tr>
                                    <td
                                      style={{
                                        width: "30%",
                                        padding: "5px 20px",
                                        height: "3vh",
                                        lineBreak: "anywhere",
                                      }}
                                    >
                                      {file.name}
                                    </td>
                                    <td
                                      style={{
                                        width: "20%",
                                        padding: "5px 20px",
                                        height: "3vh",
                                      }}
                                    >
                                      {file.user}
                                    </td>
                                    <td
                                      style={{
                                        width: "20%",
                                        padding: "5px 20px",
                                        height: "3vh",
                                      }}
                                    >
                                      {new Date(file.date).getFullYear() +
                                        "-" +
                                        (new Date(file.date).getMonth() + 1 < 10
                                          ? "0" +
                                            (new Date(file.date).getMonth() + 1)
                                          : new Date(file.date).getMonth() +
                                            1) +
                                        "-" +
                                        (new Date(file.date).getDate() < 10
                                          ? "0" + new Date(file.date).getDate()
                                          : new Date(file.date).getDate())}{" "}
                                      {(new Date(file.date).getHours() < 10
                                        ? "0" + new Date(file.date).getHours()
                                        : new Date(file.date).getHours()) +
                                        ":" +
                                        (new Date(file.date).getMinutes() < 10
                                          ? "0" +
                                            new Date(file.date).getMinutes()
                                          : new Date(file.date).getMinutes())}
                                    </td>
                                    <td
                                      style={{
                                        width: "10%",
                                        padding: "5px 20px",
                                        height: "3vh",
                                      }}
                                    >
                                      {file.info !== "1" ? (
                                        <>
                                          {file.link.includes(
                                            "apidevkppp.ftpeople.pl"
                                          ) ? (
                                            <>
                                              <button
                                                className="refreshButton"
                                                value={file.id}
                                                onClick={downloadFile}
                                              >
                                                pokaż
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                className="refreshButton"
                                                value={file.id}
                                                onClick={saveContent}
                                              >
                                                pokaż
                                              </button>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      style={
                                        file.info !== "1"
                                          ? {
                                              width: "20%",
                                              padding: "5px 20px",
                                              height: "3vh",
                                            }
                                          : {
                                              width: "20%",
                                              padding: "5px 5px",
                                              height: "3vh",
                                            }
                                      }
                                    >
                                      {file.type === "portal" ? (
                                        <>
                                          {file.info === "1" ? (
                                            <span style={{ fontSize: ".7vw" }}>
                                              Sądy nie publikują dokumentów
                                              przychodzących, ale umieszczają
                                              informację o pojawieniu się
                                              takiego dokumentu w aktach sprawy.
                                              W niektórych przypadkach wysłania
                                              przez sąd np. odpisów, dokument na
                                              liście również może być pozbawiony
                                              załącznika.
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            style={{ fontSize: "0.8vw" }}
                                            className="refreshButton"
                                            value={file.id}
                                            onClick={deleteFileAccept}
                                          >
                                            usuń
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "0.8vw",
                                            }}
                                            className="refreshButton"
                                            value={file.id}
                                            onClick={changeFileNameK}
                                          >
                                            zmień nazwę
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "0.8vw",
                                              marginTop: "10px",
                                            }}
                                            className="refreshButton"
                                            value={file.id}
                                            onClick={changeFileCategory}
                                          >
                                            zmień kategorię
                                          </button>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ))}
                          </table>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const documentsViewMobile = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "10vh",
          flexWrap: "wrap",
        }}
      >
        <input
          style={{ width: "40%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"WYSZUKAJ PLIKI"}
          value={sFile}
          onChange={handleSearchFile}
        />

        <select
          style={{ width: "50%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"wyszukaj pliki"}
          value={lawsuitsCatFiles}
          onChange={(e) => {
            setLawsuitsCatFiles(e.target.value);
            if (e.target.value === "portal") {
              setLawsuitsExtFiles("all");
            } else if (
              e.target.value.includes("PLIKI Z PORTALU INFORMACYJNEGO")
            ) {
              var res = e.target.value.split(" - ")[1];
              setLawsuitsExtFiles(res);
            } else {
              setLawsuitsExtFiles("");
            }
          }}
        >
          <option key={"WSZYSTKIE KATEGORIE"} value={"all"}>
            WSZYSTKIE KATEGORIE
          </option>
          <option key={"DOKUMENTY Z PORTALU INFORMACYJNEGO"} value={"portal"}>
            DOKUMENTY Z PORTALU INFORMACYJNEGO
          </option>
          <option
            key={"DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ"}
            value={"DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ"}
          >
            DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ
          </option>
          <option
            key={"PLIKI W PROCESIE ZAKŁADANIA SPRAWY"}
            value={"PLIKI W PROCESIE ZAKŁADANIA SPRAWY"}
          >
            PLIKI W PROCESIE ZAKŁADANIA SPRAWY
          </option>
          <option key={"PISMA AUTOMATYCZNE"} value={"PISMA AUTOMATYCZNE"}>
            PISMA AUTOMATYCZNE
          </option>
          <option key={"DOKUMENTY KREDYTOWE"} value={"DOKUMENTY KREDYTOWE"}>
            DOKUMENTY KREDYTOWE
          </option>
          <option key={"PISMA Z SĄDU"} value={"PISMA Z SĄDU"}>
            PISMA Z SĄDU
          </option>
          <option key={"PISMA Z BANKU"} value={"PISMA Z BANKU"}>
            PISMA Z BANKU
          </option>
          <option
            key={"PISMA WYSŁANE DO SPRAWY"}
            value={"PISMA WYSŁANE DO SPRAWY"}
          >
            PISMA WYSŁANE DO SPRAWY
          </option>
          <option key={"DOKUMENTY W ZADANIACH"} value={"DOKUMENTY W ZADANIACH"}>
            DOKUMENTY W ZADANIACH
          </option>
          <option key={"INNE"} value={"INNE"}>
            INNE
          </option>
          <option key={"ZAŁĄCZNIKI W MAILACH"} value={"ZAŁĄCZNIKI W MAILACH"}>
            ZAŁĄCZNIKI W MAILACH
          </option>
          <option
            key={"ZESKANOWANY SEGREGATOR FIZYCZNY"}
            value={"ZESKANOWANY SEGREGATOR FIZYCZNY"}
          >
            ZESKANOWANY SEGREGATOR FIZYCZNY
          </option>
          {lawsuitsDetails.map((l) => (
            <>
              <option
                key={`PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}`}
                value={`PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}`}
              >
                {`PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}`}
              </option>
            </>
          ))}
        </select>

        <button
          style={{ fontSize: "3vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("all")}
        >
          WIDOK BEZ KATEGORII
        </button>

        <button
          style={{ fontSize: "3vw" }}
          className="refreshButton"
          value={""}
          onClick={() => {
            setLawsuitsExtFiles(props.actualSygn);
            setLawsuitsCatFiles("all");
            setFilesForClient(filesForClientOri);
            setSFile("");
          }}
        >
          WYCZYŚĆ WIDOK
        </button>

        <button
          style={{ fontSize: "3vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>

        <button
          style={{ fontSize: "3vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
      </div>

      {filesForClient.length > 0 ? (
        <>
          {lawsuitsCatFiles === "DOKUMENTY DO WSPÓŁPRACY Z KANCELARIĄ" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {props.uData.allowedClients === "all" ? (
                <>
                  {filesForClient.filter(
                    (el) => el.type === "co-op" && +el.clientId === +props.id
                  ).length > 0 ? (
                    <>
                      <p
                        style={{ textTransform: "uppercase", fontSize: "3vw" }}
                      >
                        DOKUMENTY DO WSPÓŁPRACY Z kancelarią
                      </p>
                      <table
                        style={{ width: "100%", fontSize: "2vw" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Pokaż</th>
                          <th></th>
                        </tr>
                        {filesForClient
                          .filter(
                            (el) =>
                              el.type === "co-op" && +el.clientId === +props.id
                          )
                          .map((file) => (
                            <>
                              <tr>
                                <td
                                  style={{
                                    width: "30%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                    lineBreak: "anywhere",
                                  }}
                                >
                                  {file.name}
                                </td>

                                <td
                                  style={{
                                    width: "10%",
                                    padding: "5px 20px",
                                    height: "3vh",
                                  }}
                                >
                                  {file.link.includes(
                                    "apidevkppp.ftpeople.pl"
                                  ) && file.type !== "portal" ? (
                                    <>
                                      <button
                                        className="refreshButton"
                                        value={file.id}
                                        onClick={downloadFile}
                                        style={{ fontSize: "2vw" }}
                                      >
                                        pokaż
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        className="refreshButton"
                                        value={file.id}
                                        onClick={saveContent}
                                        style={{ fontSize: "2vw" }}
                                      >
                                        pokaż
                                      </button>
                                    </>
                                  )}
                                </td>
                                <td
                                  style={{
                                    padding: "5px 20px",
                                    height: "3vh",
                                  }}
                                >
                                  <button
                                    style={{ fontSize: "2vw" }}
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={deleteFileAccept}
                                  >
                                    usuń
                                  </button>
                                  <button
                                    style={{
                                      marginLeft: "10px",
                                      fontSize: "2vw",
                                    }}
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={changeFileNameK}
                                  >
                                    zmień nazwę
                                  </button>
                                  <button
                                    style={{
                                      marginLeft: "10px",
                                      fontSize: "2vw",
                                      marginTop: "10px",
                                    }}
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={changeFileCategory}
                                  >
                                    zmień kategorię
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))}
                      </table>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
          {lawsuitsCatFiles === "PLIKI W PROCESIE ZAKŁADANIA SPRAWY" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "add" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    PLIKI W PROCESIE ZAKŁADANIA SPRAWY
                  </p>
                  <table
                    style={{ width: "100%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "add" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA AUTOMATYCZNE" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "auto" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    PISMA AUTOMATYCZNE
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "auto" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                                style={{ fontSize: "2vw" }}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "DOKUMENTY KREDYTOWE" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "credit" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    DOKUMENTY kredytowe
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) =>
                          el.type === "credit" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                                style={{ fontSize: "2vw" }}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA Z SĄDU" || lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "court" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    PISMA Z Sądu
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) =>
                          el.type === "court" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA Z BANKU" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "bank" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    pisma z banku
                  </p>
                  <table
                    style={{ width: "100%" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "bank" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "PISMA WYSŁANE DO SPRAWY" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "send" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    pisma wysłane do sprawy
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "send" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "DOKUMENTY W ZADANIACH" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "task" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    dokumenty w zadaniach
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "task" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "INNE" || lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "other" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    Inne
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) =>
                          el.type === "other" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "ZESKANOWANY SEGREGATOR FIZYCZNY" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "segr" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    Zeskanowany segregator fizyczny
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "segr" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsCatFiles === "ZAŁĄCZNIKI W MAILACH" ||
          lawsuitsCatFiles === "all" ? (
            <>
              {filesForClient.filter(
                (el) => el.type === "mail" && +el.clientId === +props.id
              ).length > 0 ? (
                <>
                  <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                    ZAŁĄCZNIKI W MAILACH
                  </p>
                  <table
                    style={{ width: "100%", fontSize: "2vw" }}
                    id="detailClientTable"
                    className="clients_table"
                  >
                    <tr>
                      <th>Nazwa pliku</th>
                      <th>Pokaż</th>
                      <th></th>
                    </tr>
                    {filesForClient
                      .filter(
                        (el) => el.type === "mail" && +el.clientId === +props.id
                      )
                      .map((file) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "30%",
                                padding: "5px 20px",
                                height: "3vh",
                                lineBreak: "anywhere",
                              }}
                            >
                              {file.name}
                            </td>

                            <td
                              style={{
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              {file.link.includes("apidevkppp.ftpeople.pl") ? (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={downloadFile}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    className="refreshButton"
                                    value={file.id}
                                    onClick={saveContent}
                                    style={{ fontSize: "2vw" }}
                                  >
                                    pokaż
                                  </button>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                width: "20%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                                style={{ fontSize: "2vw" }}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}

          {lawsuitsDetails.map((l) => (
            <>
              {lawsuitsCatFiles ===
                `PLIKI Z PORTALU INFORMACYJNEGO - ${l.data.signature}` ||
              lawsuitsCatFiles === "portal" ||
              lawsuitsCatFiles === "all" ? (
                <>
                  {filesForClient.filter(
                    (el) =>
                      el.type === "portal" &&
                      +el.clientId === +props.id &&
                      (lawsuitsDocumentsFiles.filter(
                        (ex) =>
                          ex.lawsuitId === l.data.id && ex.link === el.link
                      ).length > 0 ||
                        lawsuitsDeliveriesFiles.filter(
                          (ex) =>
                            ex.lawsuitId === l.data.id && ex.link === el.link
                        ).length > 0 ||
                        lawsuitsProceedingsFiles.filter(
                          (ex) =>
                            ex.lawsuitId === l.data.id && ex.link === el.link
                        ).length > 0)
                  ).length > 0 ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            textTransform: "uppercase",
                            fontSize: "3vw",
                          }}
                        >
                          PLIKI Z PORTALU INFORMACYJNEGO - {l.data.signature}
                        </p>
                        <div style={{ width: "20%" }}>
                          <button
                            className="refreshButton"
                            style={{ fontSize: "2vw" }}
                            onClick={(e) => {
                              if (lawsuitsExtFiles === l.data.signature) {
                                setLawsuitsExtFiles("");
                              } else {
                                setLawsuitsExtFiles(l.data.signature);
                              }
                            }}
                          >
                            {lawsuitsExtFiles === l.data.signature ||
                            lawsuitsExtFiles === "all"
                              ? "zwiń"
                              : "pokaż"}
                          </button>
                        </div>
                      </div>
                      {lawsuitsExtFiles === l.data.signature ||
                      lawsuitsExtFiles === "all" ? (
                        <>
                          <table
                            style={{ width: "100%", fontSize: "2vw" }}
                            id="detailClientTable"
                            className="clients_table"
                          >
                            <tr>
                              <th>Nazwa pliku</th>
                              <th>Pokaż</th>
                              <th>Dodatkowe</th>
                            </tr>
                            {filesForClient
                              .filter(
                                (el) =>
                                  el.type === "portal" &&
                                  +el.clientId === +props.id &&
                                  (lawsuitsDocumentsFiles.filter(
                                    (ex) =>
                                      ex.lawsuitId === l.data.id &&
                                      ex.link === el.link
                                  ).length > 0 ||
                                    lawsuitsDeliveriesFiles.filter(
                                      (ex) =>
                                        ex.lawsuitId === l.data.id &&
                                        ex.link === el.link
                                    ).length > 0 ||
                                    lawsuitsProceedingsFiles.filter(
                                      (ex) =>
                                        ex.lawsuitId === l.data.id &&
                                        ex.link === el.link
                                    ).length > 0)
                              )
                              .map((file) => (
                                <>
                                  <tr>
                                    <td
                                      style={{
                                        width: "30%",
                                        padding: "5px 20px",
                                        height: "3vh",
                                        lineBreak: "anywhere",
                                      }}
                                    >
                                      {file.name}
                                    </td>

                                    <td
                                      style={{
                                        width: "10%",
                                        padding: "5px 20px",
                                        height: "3vh",
                                      }}
                                    >
                                      {file.info !== "1" ? (
                                        <>
                                          {file.link.includes(
                                            "apidevkppp.ftpeople.pl"
                                          ) ? (
                                            <>
                                              <button
                                                className="refreshButton"
                                                value={file.id}
                                                onClick={downloadFile}
                                                style={{ fontSize: "2vw" }}
                                              >
                                                pokaż
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                className="refreshButton"
                                                value={file.id}
                                                onClick={saveContent}
                                                style={{ fontSize: "2vw" }}
                                              >
                                                pokaż
                                              </button>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      style={
                                        file.info !== "1"
                                          ? {
                                              width: "20%",
                                              padding: "5px 20px",
                                              height: "3vh",
                                            }
                                          : {
                                              width: "20%",
                                              padding: "5px 5px",
                                              height: "3vh",
                                            }
                                      }
                                    >
                                      {file.type === "portal" ? (
                                        <>
                                          {file.info === "1" ? (
                                            <span style={{ fontSize: "2vw" }}>
                                              Sądy nie publikują dokumentów
                                              przychodzących, ale umieszczają
                                              informację o pojawieniu się
                                              takiego dokumentu w aktach sprawy.
                                              W niektórych przypadkach wysłania
                                              przez sąd np. odpisów, dokument na
                                              liście również może być pozbawiony
                                              załącznika.
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            style={{ fontSize: "2vw" }}
                                            className="refreshButton"
                                            value={file.id}
                                            onClick={deleteFileAccept}
                                          >
                                            usuń
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "2vw",
                                            }}
                                            className="refreshButton"
                                            value={file.id}
                                            onClick={changeFileNameK}
                                          >
                                            zmień nazwę
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                              fontSize: "2vw",
                                              marginTop: "10px",
                                            }}
                                            className="refreshButton"
                                            value={file.id}
                                            onClick={changeFileCategory}
                                          >
                                            zmień kategorię
                                          </button>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ))}
                          </table>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const documentsViewMobile2 = (
    <>
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "3vh",
          alignItems: "center",
          marginBottom: "5vh",
          flexWrap: "wrap",
        }}
      >
        <input
          style={{ width: "40%", height: "3vh", marginTop: "0" }}
          type="text"
          placeholder={"WYSZUKAJ PLIKI"}
          value={sFile}
          onChange={handleSearchFile}
        />
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={() => setDocMode("cat")}
        >
          WIDOK KATEGORII
        </button>
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={() => {
            setLawsuitsExtFiles(props.actualSygn);
            setLawsuitsCatFiles("all");
            setFilesForClient(filesForClientOri);
            setSFile("");
          }}
        >
          WYCZYŚĆ WIDOK
        </button>
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={handleSortDocs}
        >
          {docSort === "up" ? "SORTUJ ↑" : "SORTUJ ↓"}
        </button>
        <button
          style={{ fontSize: "2vw" }}
          className="refreshButton"
          value={""}
          onClick={downloadAll}
        >
          POBIERZ WSZYSTKIE
        </button>
      </div>
      {filesForClient.length > 0 ? (
        <>
          {filesForClient.filter((el) => +el.clientId === +props.id).length >
          0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "3vw" }}>
                PLIKI
              </p>
              <table
                style={{ width: "100%", fontSize: "2vw" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Pokaż</th>
                  <th>Dodatkowe</th>
                </tr>
                {filesForClient
                  .filter((el) => +el.clientId === +props.id)
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                            lineBreak: "anywhere",
                          }}
                        >
                          {file.name}
                        </td>

                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                                style={{ fontSize: "2vw" }}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={saveContent}
                                style={{ fontSize: "2vw" }}
                              >
                                pokaż
                              </button>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.type === "portal" ? (
                            <></>
                          ) : (
                            <>
                              <button
                                style={{ fontSize: "2vw" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFileAccept}
                              >
                                usuń
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>
                              <button
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "2vw",
                                  marginTop: "10px",
                                }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileCategory}
                              >
                                zmień kategorię
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        "brak plików"
      )}
    </>
  );

  const acceptCase = async (e) => {
    var body = {
      id: props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/acceptClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Zaakceptowano",
      text: "sprawę",
    }).then((result) => {
      props.logClientAction("Zaakceptowano sprawę", props.id);
      if (props.place === "list") {
        props.close();
      } else {
        getData();
      }
    });
  };

  const fetchTasksData = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasksForClient(data);
      })
      .catch((error) => {});
  };

  const fetchLawsuitData1 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsData1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var dat = JSON.parse(
            el.value
              .replaceAll(/\\n/g, "\\n")
              .replaceAll(/\\'/g, "\\'")
              .replaceAll(/\\"/g, '\\"')
              .replaceAll(/\\&/g, "\\&")
              .replaceAll(/\\r/g, "\\r")
              .replaceAll(/\\t/g, "\\t")
              .replaceAll(/\\b/g, "\\b")
              .replaceAll(/\\f/g, "\\f")
              .replaceAll(/\n/g, "\\\\n")
              .replaceAll(/\r/g, "\\\\r")
              .replaceAll(/\t/g, "\\\\t")
          );
          arr.push({ data: dat, link: el.link });
        });
        if (
          arr.filter((el) => el.data.signature === props.actualSygn).length ===
          0
        ) {
          setLawsuitsExt(arr[0].data.signature);
        }

        setLawsuitsDetails(arr);
        fetchLawsuitData2();
      })
      .catch((error) => {});
  };

  const fetchLawsuitData2 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsData2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var dat = [];
          try {
            dat = {
              value: JSON.parse(
                el.value
                  .replaceAll(/\\n/g, "\\n")
                  .replaceAll(/\\'/g, "\\'")
                  .replaceAll(/\\"/g, '\\"')
                  .replaceAll(/\\&/g, "\\&")
                  .replaceAll(/\\r/g, "\\r")
                  .replaceAll(/\\t/g, "\\t")
                  .replaceAll(/\\b/g, "\\b")
                  .replaceAll(/\\f/g, "\\f")
                  .replaceAll(/\n/g, "\\\\n")
                  .replaceAll(/\r/g, "\\\\r")
                  .replaceAll(/\t/g, "\\\\t")
              ),
              lawsuitId: el.lawsuitId,
            };
          } catch (err) {}

          arr.push(dat);
        });

        setLawsuitsProceedings(arr);
        fetchLawsuitData3();
      })
      .catch((error) => {});
  };

  const fetchLawsuitData3 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsData3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var dat = {
            value: JSON.parse(
              el.value
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            ),
            lawsuitId: el.lawsuitId,
          };
          arr.push(dat);
        });
        setLawsuitsDocuments(arr);
        fetchLawsuitData4();
      })
      .catch((error) => {});
  };

  const fetchLawsuitData4 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsData4", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var dat = {
            value: JSON.parse(
              el.value
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            ),
            lawsuitId: el.lawsuitId,
          };
          arr.push(dat);
        });

        var arr2 = [];
        arr.map((el) => {
          arr2.push(el.lawsuitId);
        });

        var arr3 = [];

        arr2.map((ep) => {
          if (arr3.filter((e) => e === ep).length === 0) {
            arr3.push(ep);
          }
        });

        var arr4 = [];
        arr3.map((o) => {
          var arr5 = [];
          arr
            .filter((i) => i.lawsuitId === o)
            .map((l) => {
              arr5.push(l.value);
            });
          var dat = {
            value: arr5,
            lawsuitId: o,
          };
          arr4.push(dat);
        });

        setLawsuitsDeliveries(arr4);
        fetchLawsuitFiles1();
      })
      .catch((error) => {});
  };

  const fetchLawsuitFiles1 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsFilesDocs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawsuitsDocumentsFiles(data);
        fetchLawsuitFiles2();
      })
      .catch((error) => {});
  };

  const fetchLawsuitFiles2 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsFilesDeliveries", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawsuitsDeliveriesFiles(data);
        fetchLawsuitFiles3();
      })
      .catch((error) => {});
  };

  const fetchLawsuitFiles3 = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsFilesProceedings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawsuitsProceedingsFiles(data);
        setLawsuitsLoading(false);
      })
      .catch((error) => {});
  };

  const fetchHearingsData = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearingsForClient(data);
      })
      .catch((error) => {});
  };

  const fetchClientContactsData = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsContactsClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setContactsForClient(data);
      })
      .catch((error) => {});
  };

  const fetchClientLogsData = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsLogsClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var users = [];
        data.map((el) => {
          if (users.filter((e) => e === el.lawyer).length === 0) {
            users.push(el.lawyer);
          }
        });
        setLogUsers(users);
        setLogsForClient(data);
      })
      .catch((error) => {});
  };

  const fetchTransactionsForPaymentsData = async (identifier) => {
    var body = {
      identifier: identifier,
    };

    await fetch(
      "https://apidevkppp.ftpeople.pl/getTransactionsAssignedPaymentId",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        arrT = arrT.concat(data);
      })
      .catch((error) => {});
  };

  const fetchClientPaymentsData = async () => {
    arrT = [];
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsPaymentsClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var arr = data;

        setPaymentsForClient(arr);
        arr.map((el) => {
          fetchTransactionsForPaymentsData(el.identifier);
        });
      })
      .catch((error) => {});
  };

  const fetchClientFiles = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFilesClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        setFilesForClient(
          data.sort(function (a, b) {
            return new Date(b.dateSort) - new Date(a.dateSort);
          })
        );
        setFilesForClientOri(
          data.sort(function (a, b) {
            return new Date(b.dateSort) - new Date(a.dateSort);
          })
        );
      })
      .catch((error) => {});
  };

  const fetchClientSygn = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSygnClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSygnForClient(data);
        var s = [];
        data.map((eq) => {
          if (
            s
              .filter((q) => q.sygn !== "")
              .filter(
                (p) =>
                  p.sygn.replaceAll(" ", "").toLowerCase() ===
                  eq.sygn.replaceAll(" ", "").toLowerCase()
              ).length === 0
          ) {
            s.push(eq);
          }
        });
        if (true) {
          //getLawsuits(s);
        }
      })
      .catch((error) => {});
  };

  const fetchClientData = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setClientsData(data[0]);
        if (data[0].lawoffice_bank && data[0].lawoffice_bank !== null) {
          if (data[0].lawoffice_bank.split("\n").length > 0) {
            await fetchBankLawOffice(data[0].lawoffice_bank.split("\n")[0]);
          } else {
            await fetchBankLawOffice(data[0].lawoffice_bank);
          }
        }

        if (
          data[0].additionalData !== null &&
          data[0].additionalData !== undefined &&
          data[0].additionalData !== ""
        ) {
          var arr = data[0].additionalData.split("|");
          arr.pop();
          var arr2 = [];
          arr.map((el) => {
            var x = el.split(",");
            arr2.push({ name: x[0], pesel: x[1], address: x[2] });
          });
          setClientAdditionalData(arr2);
          getAddData();
        } else {
          getAddData();
        }

        var credit_date =
          data[0].credit_date !== "undefined" || data[0].credit_date !== ""
            ? data[0].credit_date
            : "";
        var new_credit_date = "";

        if (new Date(credit_date).getDay() === 0) {
          new_credit_date = new Date(
            new Date(credit_date).setDate(new Date(credit_date).getDate() + 1)
          );
        }
        if (new Date(credit_date).getDay() === 6) {
          new_credit_date = new Date(
            new Date(credit_date).setDate(new Date(credit_date).getDate() + 2)
          );
        }

        if (new_credit_date !== "") {
          credit_date =
            new_credit_date.getFullYear() +
            "-" +
            (new_credit_date.getMonth() + 1 > 9
              ? new_credit_date.getMonth() + 1
              : "0" + (new_credit_date.getMonth() + 1)) +
            "-" +
            (new_credit_date.getDate() > 9
              ? new_credit_date.getDate()
              : "0" + new_credit_date.getMonth());
        }

        if (credit_date === "") {
          setCurr(0);
          return;
        } else {
          var currency = "";
          var url = "";
          if (data[0].credit_value !== "") {
            currency = data[0].credit_value.split(" ")[1].toLowerCase();
          }
          if (currency === "eur") {
            url = `https://api.nbp.pl/api/exchangerates/rates/a/eur/${credit_date}`;
          } else if (currency === "chf") {
            url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${credit_date}`;
          } else if (currency === "usd") {
            url = `https://api.nbp.pl/api/exchangerates/rates/a/usd/${credit_date}`;
          } else if (currency === "pln") {
            setCurr(1);
            return;
          }
          await fetch(url)
            .then((response) => response.json())
            .then((data) => {
              setCurr(data.rates[0].mid);
            })
            .catch((error) => {
              setCurr(0);
            });
        }
      })
      .catch((error) => {});
  };

  const getAddData = async () => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);

    await fetchTasksData();
    await fetchHearingsData();
    await fetchClientContactsData();
    await fetchClientPaymentsData();
    await fetchClientLogsData();
    await fetchClientFiles();
    await fetchClientSygn();

    await fetchCourtAddress();
    await fetchCourtMailAddress();
    await fetchLead();
    await fetchRecommendations();
    await fetchUsers();
    await fetchLawsuitData1();
    setTransactionsData(arrT);
  };

  const fetchCourtAddress = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getCourtAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(
              el.addressNew
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            );
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            district: el.district,
            name: el.name,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        setCourtAddress(arr);
      })
      .catch((error) => {});
  };

  const fetchBankLawOffice = async (name) => {
    var body = {
      name: name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBankLawOfficeName", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBankLawOffice(data[0]);
        var addr = "";
        if (data.length > 0) {
          addr =
            (JSON.parse(
              data[0].addressNew
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            ).street.includes("ul")
              ? JSON.parse(
                  data[0].addressNew
                    .replaceAll(/\\n/g, "\\n")
                    .replaceAll(/\\'/g, "\\'")
                    .replaceAll(/\\"/g, '\\"')
                    .replaceAll(/\\&/g, "\\&")
                    .replaceAll(/\\r/g, "\\r")
                    .replaceAll(/\\t/g, "\\t")
                    .replaceAll(/\\b/g, "\\b")
                    .replaceAll(/\\f/g, "\\f")
                    .replace(/\n/g, "\\\\n")
                    .replace(/\r/g, "\\\\r")
                    .replace(/\t/g, "\\\\t")
                ).street
              : "ul. " +
                JSON.parse(
                  data[0].addressNew
                    .replaceAll(/\\n/g, "\\n")
                    .replaceAll(/\\'/g, "\\'")
                    .replaceAll(/\\"/g, '\\"')
                    .replaceAll(/\\&/g, "\\&")
                    .replaceAll(/\\r/g, "\\r")
                    .replaceAll(/\\t/g, "\\t")
                    .replaceAll(/\\b/g, "\\b")
                    .replaceAll(/\\f/g, "\\f")
                    .replace(/\n/g, "\\\\n")
                    .replace(/\r/g, "\\\\r")
                    .replace(/\t/g, "\\\\t")
                ).street) +
            " " +
            JSON.parse(
              data[0].addressNew
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            ).number +
            ", " +
            JSON.parse(
              data[0].addressNew
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            ).postCode +
            " " +
            JSON.parse(
              data[0].addressNew
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replace(/\n/g, "\\\\n")
                .replace(/\r/g, "\\\\r")
                .replace(/\t/g, "\\\\t")
            ).city;
          setBankLawOfficeAddress(addr);
        }
      })
      .catch((error) => {});
  };

  const fetchCourtMailAddress = async () => {
    var body = {
      clientId: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getCourtMailAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCourtMailAddress(data);
      })
      .catch((error) => {});
  };

  const fetchLead = async () => {
    var body = {
      leadId: props.clientsData.leadId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeadC(data);
      })
      .catch((error) => {});
  };

  const fetchRecommendations = async () => {
    var body = {
      clientId: props.clientsData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getRecommendationsClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setRecommendations(data);
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {
      clientId: props.clientsData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    setLoading(false);

    setPaymentsForClient([]);
    setTransactionsData([]);
    setClientsData([]);
    setSygnForClient([]);
    setFilesForClient([]);
    setLogsForClient([]);
    setTasksForClient([]);
    setHearingsForClient([]);
    setContactsForClient([]);
    setCourtAddress([]);
    setCourtMailAddress([]);

    await fetchClientData();
  };

  useEffect(() => {
    getData();

    props.logClientAction("Otwarto kartę sprawy", props.id);
  }, []);

  const checkEditOption = (option) => {
    if (editOption === "all") {
      return true;
    } else if (option === editOption) {
      return true;
    } else {
      return false;
    }
  };

  const deleteClient = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć sprawę?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteClientAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const archivizeClient = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz archiwizować sprawę?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        archivizeClientAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const archivizeClientAccept = async () => {
    var body = {
      id: props.id,
      value: clientsData.arch === "0" ? "1" : "0",
    };

    await fetch("https://apidevkppp.ftpeople.pl/setClientArch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire(
          clientsData.arch === "0" ? "Zarchiwizowano" : "Przywrócono",
          "sprawę",
          "success"
        ).then((result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const switchClient = () => {
    MySwal.fire({
      title: `Czy na pewno chcesz przenieść sprawę do zespołu 
        ${+clientsData.team === 1 ? "2" : "1"}?`,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        switchClientAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const switchClientAccept = async () => {
    var body = {
      id: props.id,
      value: +clientsData.team === 1 ? "2" : "1",
    };

    await fetch("https://apidevkppp.ftpeople.pl/changeClientTeam", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire("Zmieniono", "zespół", "success").then((result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const deleteClientAccept = async () => {
    var body = {
      id: props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "sprawę", "success").then((result) => {
      props.close();
    });
  };
  const portal = (
    <>
      {lawsuitsLoading ? (
        "ŁADUJE DANE..."
      ) : (
        <>
          {lawsuitsDetails.map((ls) => (
            <>
              <div
                style={{ display: "flex", gap: "20px", marginBottom: "15px" }}
              >
                <div style={{ width: "80%", fontWeight: "600" }}>
                  {ls.data.signature}
                </div>
                <div style={{ width: "20%" }}>
                  <button
                    className="refreshButton"
                    onClick={(e) => {
                      if (lawsuitsExt === ls.data.signature) {
                        setLawsuitsExt("");
                      } else {
                        setLawsuitsExt(ls.data.signature);
                      }
                    }}
                  >
                    {lawsuitsExt === ls.data.signature ? "zwiń" : "pokaż"}
                  </button>
                </div>
              </div>
              {ls.data.signature === lawsuitsExt ? (
                <div style={{ marginBottom: "15px" }}>
                  <table
                    id="detailClientTable"
                    className="clients_table"
                    style={{ fontSize: ".8vw" }}
                  >
                    <>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>Sąd</td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {ls.data.court}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Departament
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {ls.data.department}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Sędzia
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {ls.data.judge}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Temat
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {ls.data.subject}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Uczestnicy
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {ls.data.parties}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Wartość sporu
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {ls.data.value
                            ? numberWithCommas(ls.data.value) + " PLN"
                            : "nie uzupełniono"}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Data utworzenia
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {new Date(ls.data.createdDate).getFullYear() +
                            "-" +
                            (new Date(ls.data.createdDate).getMonth() + 1 < 10
                              ? "0" +
                                (new Date(ls.data.createdDate).getMonth() + 1)
                              : new Date(ls.data.createdDate).getMonth() + 1) +
                            "-" +
                            (new Date(ls.data.createdDate).getDate() < 10
                              ? "0" + new Date(ls.data.createdDate).getDate()
                              : new Date(ls.data.createdDate).getDate())}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: "900", width: "20%" }}>
                          Data ostatniej modyfikacji
                        </td>
                        <td
                          style={{
                            width: "80%",
                          }}
                        >
                          {new Date(ls.data.modificationDate).getFullYear() +
                            "-" +
                            (new Date(ls.data.modificationDate).getMonth() + 1 <
                            10
                              ? "0" +
                                (new Date(ls.data.modificationDate).getMonth() +
                                  1)
                              : new Date(ls.data.modificationDate).getMonth() +
                                1) +
                            "-" +
                            (new Date(ls.data.modificationDate).getDate() < 10
                              ? "0" +
                                new Date(ls.data.modificationDate).getDate()
                              : new Date(ls.data.modificationDate).getDate())}
                        </td>
                      </tr>
                    </>
                  </table>
                </div>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      )}
    </>
  );

  const handleOpenPdfInNewTab = (base64Pdf) => {
    try {
      var pdfData = `data:application/pdf;base64,${base64Pdf}`;

      var w = window.open("");

      if (w) {
        w.document.write(
          `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
        );
      } else {
        throw new Error("Failed to open a new tab.");
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      // } finally {
      //   if (w) w.document.close();
      // }
    }
  };

  const downloadDoc = async (docId, link) => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url: "https://" + link + "/api/documents/download/" + docId + "/pdf",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET2";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            handleOpenPdfInNewTab(data);
          })
          .catch((error) => {});
      });
  };

  const portal2 = (
    <>
      {lawsuitsLoading ? (
        "ŁADUJE DANE..."
      ) : (
        <>
          {lawsuitsDetails.map((ls) => (
            <>
              <div
                style={{ display: "flex", gap: "20px", marginBottom: "15px" }}
              >
                <div style={{ width: "80%", fontWeight: "600" }}>
                  {ls.data.signature}
                </div>
                <div style={{ width: "20%" }}>
                  <button
                    className="refreshButton"
                    onClick={(e) => {
                      if (lawsuitsExt === ls.data.signature) {
                        setLawsuitsExt("");
                      } else {
                        setLawsuitsExt(ls.data.signature);
                      }
                    }}
                  >
                    {lawsuitsExt === ls.data.signature ? "zwiń" : "pokaż"}
                  </button>
                </div>
              </div>

              {ls.data.signature === lawsuitsExt ? (
                <>
                  {!lawsuitsDocuments.filter(
                    (ep) => +ep.lawsuitId === +ls.data.id
                  )[0] ? (
                    <p>brak dokumentów w MS</p>
                  ) : (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <table
                          id="detailClientTable"
                          className="clients_table"
                          style={{ fontSize: ".8vw" }}
                        >
                          <tr>
                            <th>Nazwa</th>
                            <th>Data publikacji</th>
                            <th>Akcja</th>
                          </tr>
                          {lawsuitsDocuments.filter(
                            (ep) => +ep.lawsuitId === +ls.data.id
                          )[0]
                            ? lawsuitsDocuments
                                .filter(
                                  (ep) => +ep.lawsuitId === +ls.data.id
                                )[0]
                                .value.map((doc) => (
                                  <>
                                    <tr>
                                      <td>{doc.documentName}</td>
                                      <td>
                                        {doc.publicationDate
                                          ? new Date(
                                              doc.publicationDate
                                            ).getFullYear() +
                                            "-" +
                                            (new Date(
                                              doc.publicationDate
                                            ).getMonth() +
                                              1 <
                                            10
                                              ? "0" +
                                                (new Date(
                                                  doc.publicationDate
                                                ).getMonth() +
                                                  1)
                                              : new Date(
                                                  doc.publicationDate
                                                ).getMonth() + 1) +
                                            "-" +
                                            (new Date(
                                              doc.publicationDate
                                            ).getDate() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.publicationDate
                                                ).getDate()
                                              : new Date(
                                                  doc.publicationDate
                                                ).getDate())
                                          : "nie uzupełniono"}
                                      </td>
                                      <td>
                                        {" "}
                                        <button
                                          className="refreshButton"
                                          onClick={(e) => {
                                            downloadDoc(doc.id, ls.link);
                                          }}
                                        >
                                          {"pobierz"}
                                        </button>
                                      </td>
                                    </tr>
                                  </>
                                ))
                            : "brak dokumentów w sprawie"}
                        </table>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      )}
    </>
  );

  const portal3 = (
    <>
      <div style={{ width: "30%", marginBottom: "20px" }}>
        <label>Sygnatura akt</label>
        <select
          value={lawsuitsExt}
          onChange={(e) => {
            setLawsuitsExt(e.target.value);
          }}
        >
          {lawsuitsDetails.map((ls) => (
            <option key={ls.data.id} value={ls.data.signature}>
              {ls.data.signature}
            </option>
          ))}
        </select>
      </div>
      {lawsuitsLoading ? (
        "ŁADUJE DANE..."
      ) : (
        <>
          {lawsuitsDetails.map((ls) => (
            <>
              {ls.data.signature === lawsuitsExt ? (
                <>
                  {!lawsuitsProceedings.filter(
                    (ep) => +ep.lawsuitId === +ls.data.id
                  )[0] ? (
                    <p>brak czynności w MS</p>
                  ) : (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <table
                          id="detailClientTable"
                          className="clients_table"
                          style={{ fontSize: ".8vw" }}
                        >
                          <tr>
                            <th>Nazwa</th>
                            <th>Data</th>
                            <th>Nadawca</th>
                            <th>Uwagi</th>
                            <th>Nazwa dokumentu</th>
                            <th>Dokument</th>
                          </tr>
                          {lawsuitsProceedings.filter(
                            (ep) => +ep.lawsuitId === +ls.data.id
                          )[0]
                            ? lawsuitsProceedings
                                .filter(
                                  (ep) => +ep.lawsuitId === +ls.data.id
                                )[0]
                                .value.sort(function (a, b) {
                                  return new Date(b.date) - new Date(a.date);
                                })
                                .map((doc) => (
                                  <>
                                    <tr>
                                      <td style={{ width: "15%" }}>
                                        {doc.name}
                                      </td>
                                      <td style={{ width: "8%" }}>
                                        {doc.date
                                          ? new Date(doc.date).getFullYear() +
                                            "-" +
                                            (new Date(doc.date).getMonth() + 1 <
                                            10
                                              ? "0" +
                                                (new Date(doc.date).getMonth() +
                                                  1)
                                              : new Date(doc.date).getMonth() +
                                                1) +
                                            "-" +
                                            (new Date(doc.date).getDate() < 10
                                              ? "0" +
                                                new Date(doc.date).getDate()
                                              : new Date(doc.date).getDate())
                                          : "nie uzupełniono"}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.sender}
                                      </td>
                                      <td
                                        style={{ width: "40%", padding: "5px" }}
                                      >
                                        {doc.comments
                                          ? doc.comments
                                              .replaceAll("\\r", " ")
                                              .replaceAll("\\n", " ")
                                          : ""}
                                      </td>
                                      <td
                                        style={{
                                          width: "20%",
                                          lineBreak: "anywhere",
                                        }}
                                      >
                                        {doc.documentName}
                                      </td>
                                      <td>
                                        {doc.documentId ? (
                                          <button
                                            className="refreshButton"
                                            value={doc.documentId}
                                            onClick={downloadFilePiProc}
                                          >
                                            pokaż
                                          </button>
                                        ) : (
                                          "brak pliku do pobrania"
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                ))
                            : ""}
                        </table>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      )}
    </>
  );

  const portal3Mobile = (
    <>
      <div style={{ width: "80%", marginBottom: "20px" }}>
        <label>Sygnatura akt</label>
        <select
          value={lawsuitsExt}
          onChange={(e) => {
            setLawsuitsExt(e.target.value);
          }}
        >
          {lawsuitsDetails.map((ls) => (
            <option key={ls.data.id} value={ls.data.signature}>
              {ls.data.signature}
            </option>
          ))}
        </select>
      </div>
      {lawsuitsLoading ? (
        "ŁADUJE DANE..."
      ) : (
        <>
          {lawsuitsDetails.map((ls) => (
            <>
              {ls.data.signature === lawsuitsExt ? (
                <>
                  {!lawsuitsProceedings.filter(
                    (ep) => +ep.lawsuitId === +ls.data.id
                  )[0] ? (
                    <p>brak czynności w MS</p>
                  ) : (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <table
                          id="detailClientTable"
                          className="clients_table"
                          style={{ fontSize: "2vw" }}
                        >
                          <tr>
                            <th>Nazwa</th>
                            <th>Data</th>
                            <th>Nadawca</th>
                            <th>Dokument</th>
                          </tr>
                          {lawsuitsProceedings.filter(
                            (ep) => +ep.lawsuitId === +ls.data.id
                          )[0]
                            ? lawsuitsProceedings
                                .filter(
                                  (ep) => +ep.lawsuitId === +ls.data.id
                                )[0]
                                .value.sort(function (a, b) {
                                  return new Date(b.date) - new Date(a.date);
                                })
                                .map((doc) => (
                                  <>
                                    <tr>
                                      <td>{doc.name}</td>
                                      <td>
                                        {doc.date
                                          ? new Date(doc.date).getFullYear() +
                                            "-" +
                                            (new Date(doc.date).getMonth() + 1 <
                                            10
                                              ? "0" +
                                                (new Date(doc.date).getMonth() +
                                                  1)
                                              : new Date(doc.date).getMonth() +
                                                1) +
                                            "-" +
                                            (new Date(doc.date).getDate() < 10
                                              ? "0" +
                                                new Date(doc.date).getDate()
                                              : new Date(doc.date).getDate())
                                          : "nie uzupełniono"}
                                      </td>
                                      <td>{doc.sender}</td>

                                      <td>
                                        {doc.documentId ? (
                                          <button
                                            className="refreshButton"
                                            value={doc.documentId}
                                            onClick={downloadFilePiProc}
                                          >
                                            pokaż
                                          </button>
                                        ) : (
                                          "brak pliku do pobrania"
                                        )}
                                      </td>
                                    </tr>
                                  </>
                                ))
                            : ""}
                        </table>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      )}
    </>
  );

  const downloadDeliveries = (docId, link) => {
    var url = "https://apidevkppp.ftpeople.pl/authToken";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var token = data.id_token;

        var body = {
          token: token,
          url:
            "https://" +
            link +
            "/api/deliveries/" +
            docId +
            "/documents?page=0&size=50&sort=id,asc",
        };

        var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET";
        await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            data.map((dat) => {
              var url = "https://apidevkppp.ftpeople.pl/authToken";
              fetch(url, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((response) => response.json())
                .then(async (data) => {
                  var token = data.id_token;

                  var body = {
                    token: token,
                    url:
                      "https://" +
                      link +
                      "/api/documents/download/" +
                      dat.id +
                      "/pdf",
                  };

                  var url = "https://apidevkppp.ftpeople.pl/getAPIMSDataGET2";
                  await fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      handleOpenPdfInNewTab(data);
                    })
                    .catch((error) => {});
                });
            });
          })
          .catch((error) => {});
      });
  };

  const portal4 = (
    <>
      <div style={{ width: "30%", marginBottom: "20px" }}>
        <label>Sygnatura akt</label>
        <select
          value={lawsuitsExt}
          onChange={(e) => {
            setLawsuitsExt(e.target.value);
            setLawsuitsDeliveriesExt("");
          }}
        >
          {lawsuitsDetails.map((ls) => (
            <option key={ls.data.id} value={ls.data.signature}>
              {ls.data.signature}
            </option>
          ))}
        </select>
      </div>
      {lawsuitsLoading ? (
        "ŁADUJE DANE..."
      ) : (
        <>
          {lawsuitsDetails.map((ls) => (
            <>
              {ls.data.signature === lawsuitsExt ? (
                <>
                  {!lawsuitsDeliveries.filter(
                    (ep) => +ep.lawsuitId === +ls.data.id
                  )[0] ? (
                    <p>brak doręczeń w MS</p>
                  ) : (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <table
                          id="detailClientTable"
                          className="clients_table"
                          style={{ fontSize: ".8vw" }}
                        >
                          <tr>
                            <th>Identyfikator</th>
                            <th>Sąd</th>
                            <th>Wydział</th>
                            <th>Sygnatura</th>
                            <th>Data umieszczenia w PI</th>
                            <th>Data doręczenia</th>
                            <th>Status</th>
                            <th>Adresat</th>
                            <th>Ilość załączników</th>
                            <th>Załączniki</th>
                          </tr>
                          {lawsuitsDeliveries.filter(
                            (ep) => +ep.lawsuitId === +ls.data.id
                          )[0]
                            ? lawsuitsDeliveries
                                .filter(
                                  (ep) => +ep.lawsuitId === +ls.data.id
                                )[0]
                                .value.sort(function (a, b) {
                                  return (
                                    new Date(b.deliveryDate) -
                                    new Date(a.deliveryDate)
                                  );
                                })
                                .map((doc) => (
                                  <>
                                    <tr>
                                      <td style={{ width: "10%" }}>
                                        {doc.identifier}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.court}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.department}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.signature}
                                      </td>
                                      <td>
                                        {doc.publicationDate
                                          ? new Date(
                                              doc.publicationDate
                                            ).getFullYear() +
                                            "-" +
                                            (new Date(
                                              doc.publicationDate
                                            ).getMonth() +
                                              1 <
                                            10
                                              ? "0" +
                                                (new Date(
                                                  doc.publicationDate
                                                ).getMonth() +
                                                  1)
                                              : new Date(
                                                  doc.publicationDate
                                                ).getMonth() + 1) +
                                            "-" +
                                            (new Date(
                                              doc.publicationDate
                                            ).getDate() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.publicationDate
                                                ).getDate()
                                              : new Date(
                                                  doc.publicationDate
                                                ).getDate()) +
                                            " " +
                                            (new Date(
                                              doc.publicationDate
                                            ).getHours() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.publicationDate
                                                ).getHours()
                                              : new Date(
                                                  doc.publicationDate
                                                ).getHours()) +
                                            ":" +
                                            (new Date(
                                              doc.publicationDate
                                            ).getMinutes() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.publicationDate
                                                ).getMinutes()
                                              : new Date(
                                                  doc.publicationDate
                                                ).getMinutes())
                                          : "nie uzupełniono"}
                                      </td>
                                      <td>
                                        {doc.deliveryDate
                                          ? new Date(
                                              doc.deliveryDate
                                            ).getFullYear() +
                                            "-" +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getMonth() +
                                              1 <
                                            10
                                              ? "0" +
                                                (new Date(
                                                  doc.deliveryDate
                                                ).getMonth() +
                                                  1)
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getMonth() + 1) +
                                            "-" +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getDate() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.deliveryDate
                                                ).getDate()
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getDate()) +
                                            " " +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getHours() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.deliveryDate
                                                ).getHours()
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getHours()) +
                                            ":" +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getMinutes() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.deliveryDate
                                                ).getMinutes()
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getMinutes())
                                          : "nie uzupełniono"}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.status === "DELIVERED"
                                          ? "DORĘCZONO"
                                          : "NIE DORĘCZONO"}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.recipientName}
                                      </td>

                                      <td style={{ width: "5%" }}>
                                        {doc.attachmentsNumber}
                                      </td>
                                      <td>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            justifyContent: "center",
                                            flexWrap: "wrap",
                                            padding: "5px",
                                          }}
                                        >
                                          <button
                                            className="refreshButton"
                                            value={doc.id}
                                            onClick={(e) => {
                                              if (
                                                +lawsuitsDeliveriesExt ===
                                                +e.target.value
                                              ) {
                                                setLawsuitsDeliveriesExt("");
                                              } else {
                                                setLawsuitsDeliveriesExt(
                                                  e.target.value
                                                );
                                              }
                                            }}
                                          >
                                            {+lawsuitsDeliveriesExt === +doc.id
                                              ? "zwiń"
                                              : "rozwiń"}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                    {+lawsuitsDeliveriesExt === +doc.id ? (
                                      <>
                                        <div
                                          style={{
                                            marginTop: "20px",
                                            marginBottom: "20px",
                                            width: "30px",
                                          }}
                                        >
                                          <table
                                            id="detailClientTable"
                                            className="clients_table"
                                            style={{
                                              fontSize: ".8vw",
                                            }}
                                          >
                                            <tr>
                                              <th>Nazwa</th>
                                              <th>Akcja</th>
                                            </tr>

                                            {lawsuitsDeliveriesFiles
                                              .filter(
                                                (w) => +w.devId === +doc.id
                                              )
                                              .map((el) => (
                                                <>
                                                  <tr>
                                                    <td
                                                      style={{ padding: "5px" }}
                                                    >
                                                      {
                                                        filesForClientOri.filter(
                                                          (ex) =>
                                                            ex.link === el.link
                                                        )[0].name
                                                      }
                                                    </td>
                                                    <td>
                                                      <button
                                                        className="refreshButton"
                                                        value={el.docId}
                                                        onClick={
                                                          downloadFilePiDev
                                                        }
                                                      >
                                                        pokaż
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </>
                                              ))}
                                          </table>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ))
                            : ""}
                        </table>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      )}
    </>
  );

  const portal4Mobile = (
    <>
      <div style={{ width: "80%", marginBottom: "20px" }}>
        <label>Sygnatura akt</label>
        <select
          value={lawsuitsExt}
          onChange={(e) => {
            setLawsuitsExt(e.target.value);
            setLawsuitsDeliveriesExt("");
          }}
        >
          {lawsuitsDetails.map((ls) => (
            <option key={ls.data.id} value={ls.data.signature}>
              {ls.data.signature}
            </option>
          ))}
        </select>
      </div>
      {lawsuitsLoading ? (
        "ŁADUJE DANE..."
      ) : (
        <>
          {lawsuitsDetails.map((ls) => (
            <>
              {ls.data.signature === lawsuitsExt ? (
                <>
                  {!lawsuitsDeliveries.filter(
                    (ep) => +ep.lawsuitId === +ls.data.id
                  )[0] ? (
                    <p>brak doręczeń w MS</p>
                  ) : (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <table
                          id="detailClientTable"
                          className="clients_table"
                          style={{ fontSize: "2vw" }}
                        >
                          <tr>
                            <th>Identyfikator</th>
                            <th>Data doręczenia</th>
                            <th>Status</th>
                            <th>Adresat</th>
                            <th>Ilość załączników</th>
                            <th>Załączniki</th>
                          </tr>
                          {lawsuitsDeliveries.filter(
                            (ep) => +ep.lawsuitId === +ls.data.id
                          )[0]
                            ? lawsuitsDeliveries
                                .filter(
                                  (ep) => +ep.lawsuitId === +ls.data.id
                                )[0]
                                .value.sort(function (a, b) {
                                  return (
                                    new Date(b.deliveryDate) -
                                    new Date(a.deliveryDate)
                                  );
                                })
                                .map((doc) => (
                                  <>
                                    <tr>
                                      <td style={{ width: "10%" }}>
                                        {doc.identifier}
                                      </td>

                                      <td>
                                        {doc.deliveryDate
                                          ? new Date(
                                              doc.deliveryDate
                                            ).getFullYear() +
                                            "-" +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getMonth() +
                                              1 <
                                            10
                                              ? "0" +
                                                (new Date(
                                                  doc.deliveryDate
                                                ).getMonth() +
                                                  1)
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getMonth() + 1) +
                                            "-" +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getDate() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.deliveryDate
                                                ).getDate()
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getDate()) +
                                            " " +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getHours() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.deliveryDate
                                                ).getHours()
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getHours()) +
                                            ":" +
                                            (new Date(
                                              doc.deliveryDate
                                            ).getMinutes() < 10
                                              ? "0" +
                                                new Date(
                                                  doc.deliveryDate
                                                ).getMinutes()
                                              : new Date(
                                                  doc.deliveryDate
                                                ).getMinutes())
                                          : "nie uzupełniono"}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.status === "DELIVERED"
                                          ? "DORĘCZONO"
                                          : "NIE DORĘCZONO"}
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        {doc.recipientName}
                                      </td>

                                      <td style={{ width: "5%" }}>
                                        {doc.attachmentsNumber}
                                      </td>
                                      <td>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            justifyContent: "center",
                                            flexWrap: "wrap",
                                            padding: "5px",
                                          }}
                                        >
                                          <button
                                            className="refreshButton"
                                            value={doc.id}
                                            onClick={(e) => {
                                              if (
                                                +lawsuitsDeliveriesExt ===
                                                +e.target.value
                                              ) {
                                                setLawsuitsDeliveriesExt("");
                                              } else {
                                                setLawsuitsDeliveriesExt(
                                                  e.target.value
                                                );
                                              }
                                            }}
                                          >
                                            {+lawsuitsDeliveriesExt === +doc.id
                                              ? "zwiń"
                                              : "rozwiń"}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                    {+lawsuitsDeliveriesExt === +doc.id ? (
                                      <>
                                        <div
                                          style={{
                                            marginTop: "20px",
                                            marginBottom: "20px",
                                            width: "30px",
                                          }}
                                        >
                                          <table
                                            id="detailClientTable"
                                            className="clients_table"
                                            style={{
                                              fontSize: ".8vw",
                                            }}
                                          >
                                            <tr>
                                              <th>Nazwa</th>
                                              <th>Akcja</th>
                                            </tr>

                                            {lawsuitsDeliveriesFiles
                                              .filter(
                                                (w) => +w.devId === +doc.id
                                              )
                                              .map((el) => (
                                                <>
                                                  <tr>
                                                    <td
                                                      style={{ padding: "5px" }}
                                                    >
                                                      {
                                                        filesForClientOri.filter(
                                                          (ex) =>
                                                            ex.link === el.link
                                                        )[0].name
                                                      }
                                                    </td>
                                                    <td>
                                                      <button
                                                        className="refreshButton"
                                                        value={el.docId}
                                                        onClick={
                                                          downloadFilePiDev
                                                        }
                                                      >
                                                        pokaż
                                                      </button>
                                                    </td>
                                                  </tr>
                                                </>
                                              ))}
                                          </table>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ))
                            : ""}
                        </table>
                      </div>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ))}
        </>
      )}
    </>
  );

  const tabsDesktop = (
    <>
      <div className="clientTabsContent">
        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
          id="clientsTabPanel"
        >
          <TabList
            id="clientsTabPanel_tablist"
            style={{ width: "90vw", overflowX: "scroll", overflowY: "hidden" }}
          >
            <Tab>
              <span className="tabTitle">INFORMACJE O KLIENCIE</span>
            </Tab>
            <Tab>
              <span className="tabTitle">INFORMACJE O SPRAWIE</span>
            </Tab>
            <Tab>
              <span className="tabTitle">
                {clientsData.type === "antywindykacja"
                  ? "INFORMACJE O UMOWIE"
                  : "INFORMACJE DO POZWU"}
              </span>
            </Tab>
            <Tab>
              <span className="tabTitle">ZADANIA</span>
            </Tab>
            <Tab>
              <span className="tabTitle">ROZPRAWY</span>
            </Tab>
            <Tab>
              <span className="tabTitle">KONTAKTY Z KLIENTEM</span>
            </Tab>

            {props.uData.allowedClients === "all" ? (
              <Tab>
                <span className="tabTitle">PŁATNOŚCI</span>
              </Tab>
            ) : (
              ""
            )}
            <Tab>
              <span className="tabTitle">HISTORIA</span>
            </Tab>

            {props.uData.sprPrzych === "1" ? (
              <>
                <Tab>
                  <span className="tabTitle">PROGNOZOWANY PRZYCHóD</span>
                </Tab>
              </>
            ) : (
              ""
            )}
            <Tab>
              <span className="tabTitle">DOKUMENTY</span>
            </Tab>
            {true ? (
              <>
                {false ? (
                  <Tab>
                    <span className="tabTitle">INFORMACJE Z MS</span>
                  </Tab>
                ) : (
                  ""
                )}
                {false ? (
                  <Tab>
                    <span className="tabTitle">DOKUMENTY Z MS</span>
                  </Tab>
                ) : (
                  ""
                )}
                <Tab>
                  <span className="tabTitle">CZYNNOŚCI Z PI</span>
                </Tab>
                <Tab>
                  <span className="tabTitle">DORĘCZENIA Z PI</span>
                </Tab>
              </>
            ) : (
              ""
            )}
          </TabList>

          <TabPanel>
            <div className="tabContent">{basicData}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{caseData}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{lawsuitData}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{tasksData}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{hearingsData}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{clientsContactData}</div>
          </TabPanel>
          {props.uData.allowedClients === "all" ? (
            <TabPanel>
              <div className="tabContent">{paymentsData}</div>
            </TabPanel>
          ) : (
            ""
          )}
          <TabPanel>
            <div className="tabContent">{logData}</div>
          </TabPanel>
          {props.uData.sprPrzych === "1" ? (
            <>
              <TabPanel>
                <div className="tabContent">
                  <>{income}</>
                </div>
              </TabPanel>
            </>
          ) : (
            ""
          )}
          <TabPanel>
            <div className="tabContent">
              <>{docMode === "cat" ? documentsView : documentsView2}</>
            </div>
          </TabPanel>
          {true ? (
            <>
              {false ? (
                <TabPanel>
                  <div className="tabContent">
                    <>{portal}</>
                  </div>
                </TabPanel>
              ) : (
                ""
              )}
              {false ? (
                <TabPanel>
                  <div className="tabContent">
                    <>{portal2}</>
                  </div>
                </TabPanel>
              ) : (
                ""
              )}
              <TabPanel>
                <div className="tabContent">
                  <>{portal3}</>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="tabContent">
                  <>{portal4}</>
                </div>
              </TabPanel>
            </>
          ) : (
            ""
          )}
        </Tabs>
      </div>
    </>
  );

  const tabsMobile = (
    <>
      <div className="clientTabsContent">
        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
          id="clientsTabPanel"
        >
          <TabList id="clientsTabPanel_tablist">
            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                I. KLIENT
              </span>
            </Tab>
            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                I. SPRAWA
              </span>
            </Tab>
            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                I. POZEW
              </span>
            </Tab>
            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                ZADANIA
              </span>
            </Tab>
            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                ROZPRAWY
              </span>
            </Tab>

            {props.uData.allowedClients === "all" ? (
              <Tab>
                <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                  PŁATNOŚCI
                </span>
              </Tab>
            ) : (
              ""
            )}

            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                DOKUMENTY
              </span>
            </Tab>
            {true ? (
              <>
                {false ? (
                  <Tab>
                    <span className="tabTitle">INFORMACJE Z MS</span>
                  </Tab>
                ) : (
                  ""
                )}
                {false ? (
                  <Tab>
                    <span className="tabTitle">DOKUMENTY Z MS</span>
                  </Tab>
                ) : (
                  ""
                )}
                <Tab>
                  <span className="tabTitle">CZYNNOŚCI Z PI</span>
                </Tab>
                <Tab>
                  <span className="tabTitle">DORĘCZENIA Z PI</span>
                </Tab>
              </>
            ) : (
              ""
            )}
            <Tab>
              <span className="tabTitle" style={{ fontSize: "1.7vw" }}>
                HISTORIA
              </span>
            </Tab>
            <Tab>
              <span className="tabTitle">KONTAKTY Z KLIENTEM</span>
            </Tab>
          </TabList>
          <TabPanel>
            <div className="tabContent">{basicDataMobile}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{caseDataMobile}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{lawsuitDataMobile}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{tasksDataMobile}</div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">{hearingsDataMobile}</div>
          </TabPanel>

          {props.uData.allowedClients === "all" ? (
            <TabPanel>
              <div className="tabContent">{paymentsDataMobile}</div>
            </TabPanel>
          ) : (
            ""
          )}

          <TabPanel>
            <div className="tabContent">
              <>
                {docMode === "cat" ? documentsViewMobile : documentsViewMobile2}
              </>
            </div>
          </TabPanel>
          {true ? (
            <>
              {false ? (
                <TabPanel>
                  <div className="tabContent">
                    <>{portal}</>
                  </div>
                </TabPanel>
              ) : (
                ""
              )}
              {false ? (
                <TabPanel>
                  <div className="tabContent">
                    <>{portal2}</>
                  </div>
                </TabPanel>
              ) : (
                ""
              )}
              <TabPanel>
                <div className="tabContent">
                  <>{portal3Mobile}</>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="tabContent">
                  <>{portal4Mobile}</>
                </div>
              </TabPanel>
            </>
          ) : (
            ""
          )}
          <TabPanel>
            <div className="tabContent">
              <>{logDataMobile}</>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="tabContent">
              <>{clientsContactDataMobile}</>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );

  const buttons = (
    <>
      {props.checkPermissions("usunSprawe") && !loading ? (
        <>
          <button
            style={{
              backgroundColor: "red",
              color: "white",
              borderColor: "white",
            }}
            id="clientsButton"
            className="paymentMenuButton"
            onClick={deleteClient}
          >
            Usuń sprawę
          </button>
        </>
      ) : (
        ""
      )}
      {props.checkPermissions("archSpraw") && !loading ? (
        <>
          <button
            style={{
              backgroundColor: "yellow",
              color: "black",
              borderColor: "white",
              marginLeft: "20px",
            }}
            id="clientsButton"
            className="paymentMenuButton"
            onClick={archivizeClient}
          >
            {clientsData.arch === "0" ? "Archiwizuj sprawę" : "Przywróć sprawę"}
          </button>
        </>
      ) : (
        ""
      )}
      {props.checkPermissions("switchSpraw") && !loading ? (
        <>
          <button
            style={{
              backgroundColor: "blue",
              color: "white",
              borderColor: "white",
              marginLeft: "20px",
            }}
            id="clientsButton"
            className="paymentMenuButton"
            onClick={switchClient}
          >
            ZMIEŃ ZESPÓŁ
          </button>
        </>
      ) : (
        ""
      )}
    </>
  );

  const buttonsMobile = (
    <>
      {props.checkPermissions("usunSprawe") && !loading ? (
        <>
          <button
            style={{
              backgroundColor: "red",
              color: "white",
              borderColor: "white",
              width: "45%",
            }}
            id="clientsButton"
            className="paymentMenuButton"
            onClick={deleteClient}
          >
            Usuń sprawę
          </button>
        </>
      ) : (
        ""
      )}
      {props.checkPermissions("archSpraw") && !loading ? (
        <>
          <button
            style={{
              backgroundColor: "yellow",
              color: "black",
              borderColor: "white",
              width: "45%",
            }}
            id="clientsButton"
            className="paymentMenuButton"
            onClick={archivizeClient}
          >
            {clientsData.arch === "0" ? "Archiwizuj sprawę" : "Przywróć sprawę"}
          </button>
        </>
      ) : (
        ""
      )}
      {props.checkPermissions("switchSpraw") && !loading ? (
        <>
          <button
            style={{
              backgroundColor: "blue",
              color: "white",
              borderColor: "white",
              width: "45%",
            }}
            id="clientsButton"
            className="paymentMenuButton"
            onClick={switchClient}
          >
            ZMIEŃ ZESPÓŁ
          </button>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      {showNotePopUp ? (
        <>
          <NotePopUp
            content={noteContent}
            closePopUp={handleCloseNote}
            type={"note"}
          />
        </>
      ) : (
        ""
      )}
      {showAddClientQuestionnaire ? (
        <AddClientQuestionnaire
          clientsSheetData={props.clientsSheetData}
          lawyersData={props.lawyersData}
          courtsData={props.courtsData}
          banksData={props.banksData}
          close={closeAddClientQuestionnaire}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          mode={"edit"}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          lawyerName={getLawyerName(clientsData.client_owner)}
          clientsQuestData={props.clientsQuestData}
          clientsQuestSheetData={props.clientsQuestSheetData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showAddClient ? (
        <AddClient
          clientsSheetData={props.clientsSheetData}
          lawyersData={props.lawyersData}
          courtsData={props.courtsData}
          banksData={props.banksData}
          close={closeAddClient}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          mode={"edit"}
          editOption={editOption}
          client={clientsData}
          users={props.users}
          userD={props.uData}
          userRole={props.userRole}
          userMail={props.user.mail}
          userPhone={props.user.phone}
          lawyerName={getLawyerName(clientsData.client_owner)}
          checkEditOption={checkEditOption}
          tabIndex={tabIndex}
          actualSygn={
            getActualSygnForClient() === "brak danych"
              ? ""
              : getActualSygnForClient()
          }
          team={props.team}
          payments={paymentsForClient.filter((el) => el.arch === "0")}
        />
      ) : (
        ""
      )}
      {showAddClientRecommendation ? (
        <AddClientRecommendation
          clientsData={clientsData}
          close={closeAddClientRecommendation}
          logClientAction={props.logClientAction}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showPaymentReport ? (
        <PaymentReport
          close={closePaymentReport}
          paymentsData={props.paymentsData}
          paymentsSheetData={props.paymentsSheetData}
          transactionsSheetData={props.transactionsSheetData}
          transactionsASheetData={props.transactionsNaSheetData}
          transactionsData={transactionsData}
          paymentsArchiveSheetData={props.paymentsArchiveSheetData}
          id={paymentReportId}
          refreshData={props.refreshData}
          place="payments"
          user={props.uData}
          userRole={props.uData.role}
          tasksTypesData={props.tasksTypesData}
          courtsData={props.courtsData}
          tabIndex={tabIndex}
          client={clientsData}
          team={props.team}
          users={props.users}
          logClientAction={props.logClientAction}
          checkPermissions={props.checkPermissions}
          place="client"
          upData={props.uData}
        />
      ) : (
        ""
      )}
      {showClientContact ? (
        <>
          <ClientContactPopUp
            contactId={contactId}
            close={closeClientContactPopUp}
            contactsData={contactsForClient}
            clientName={clientsData.petitioner}
            logClientAction={props.logClientAction}
            tabIndex={tabIndex}
          />
        </>
      ) : (
        ""
      )}
      {showSpecialContent ? (
        <>
          <AddSpecialContent
            specialContent={specialContent}
            handleSetSpecialContent={handleSetSpecialContent}
            close={closeSpecialContent}
            clientsSheetData={props.clientsSheetData}
            clientsData={clientsData}
            logClientAction={props.logClientAction}
            refreshData={props.refreshData}
            tabIndex={tabIndex}
          />
        </>
      ) : (
        ""
      )}
      {showDate ? (
        <>
          <DatePopUp
            dateID={dateId}
            hearingsData={props.hearingsData}
            hearingsSheetData={props.hearingsSheetData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            closeDatePopUp={closeDatePopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.uData}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={true}
            checkPermissions={props.checkPermissions}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archDateTeam2={props.archDateTeam2}
            archDate={props.archDate}
            logClientAction={props.logClientAction}
            close={closeDatePopUp}
            tabIndex={tabIndex}
            clientsData={props.clientsFullData}
            filesData={props.filesData}
            user={props.uData}
            usersData={props.users}
            substitutesData={props.substitutesData}
          />
        </>
      ) : (
        ""
      )}
      {showTask ? (
        <>
          <TaskPopUp
            taskID={taskId}
            hearingsData={props.hearingsData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            closeTaskPopUp={closeTaskPopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.uData}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.users}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={false}
            checkPermissions={props.checkPermissions}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archTasksTeam2={props.tasksArchTeam2SheetData}
            archTasks={props.archTasks}
            logClientAction={props.logClientAction}
            close={closeTaskPopUp}
            tabIndex={tabIndex}
            clientsData={props.clientsFullData}
            filesData={props.filesData}
            user={props.uData}
          />
        </>
      ) : (
        ""
      )}
      {showSygnPopUp ? (
        <ClientSygnPopup
          close={closeSygnPopUp}
          refreshData={props.refreshData}
          clientsSygnData={sygnForClient}
          clientsSygnSheetData={props.clientsSygnSheetData}
          user={props.user}
          clientId={props.id}
          logClientAction={props.logClientAction}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showEditLawsuitDate ? (
        <EditLawsuitDate
          clientsSheetData={props.clientsSheetData}
          close={closeEditLawsuitDate}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditWPS ? (
        <EditWPS
          clientsSheetData={props.clientsSheetData}
          close={closeEditWPS}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditNadPLN ? (
        <EditNadPLN
          clientsSheetData={props.clientsSheetData}
          close={closeEditNadPLN}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditNadCHF ? (
        <EditNadCHF
          clientsSheetData={props.clientsSheetData}
          close={closeEditNadCHF}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditRep ? (
        <EditRep
          clientsSheetData={props.clientsSheetData}
          close={closeEditRep}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditPU ? (
        <EditPU
          clientsSheetData={props.clientsSheetData}
          close={closeEditPU}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
          user={props.user}
        />
      ) : (
        ""
      )}
      {showEditZZ ? (
        <EditZZ
          clientsSheetData={props.clientsSheetData}
          close={closeEditZZ}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditZP ? (
        <EditZP
          clientsSheetData={props.clientsSheetData}
          close={closeEditZP}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditDG ? (
        <EditDG
          clientsSheetData={props.clientsSheetData}
          close={closeEditDG}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditDZ ? (
        <EditDZ
          clientsSheetData={props.clientsSheetData}
          close={closeEditDZ}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          tabIndex={tabIndex}
          team={props.team}
          sygnForClient={sygnForClient}
          tasks={tasksForClient}
          lawyersData={props.lawyersData}
        />
      ) : (
        ""
      )}
      {showEditPW ? (
        <EditPW
          clientsSheetData={props.clientsSheetData}
          close={closeEditPW}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditDW ? (
        <EditDW
          clientsSheetData={props.clientsSheetData}
          close={closeEditDW}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showAddFile ? (
        <AddFile
          close={closeSendFile}
          logClientAction={props.logClientAction}
          id={clientsData.id}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={tabIndex}
          team={props.team}
          user={props.uData.name}
          place={"main"}
        />
      ) : (
        ""
      )}
      {showEditPP ? (
        <EditPP
          clientsSheetData={props.clientsSheetData}
          close={closeEditPP}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditPSP ? (
        <EditPSP
          clientsSheetData={props.clientsSheetData}
          close={closeEditPSP}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditBO ? (
        <EditBO
          clientsSheetData={props.clientsSheetData}
          close={closeEditBO}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          client={clientsData}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showEditWezwData ? (
        <EditWezwData
          close={closeEditWezwData}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
          district={clientsData.aSygn.split(" ")[0].replaceAll(" ", "")}
        />
      ) : (
        ""
      )}
      {showLawsuitData ? (
        <EditLawsuitData
          close={closeLawsuitData}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
          district={clientsData.aSygn.split(" ")[0].replaceAll(" ", "")}
        />
      ) : (
        ""
      )}
      {showAddPrintDate ? (
        <AddPrintDate
          close={closeAddPrintDate}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddLawZaswDate ? (
        <AddLawZaswDate
          close={closeAddLawZasw}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddPozN ? (
        <AddPozN
          close={closeAddPozN}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showEditPou ? (
        <AddPou
          close={closeAddPou}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddPotrCl ? (
        <AddPotrCl
          close={closeAddPotrCl}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddCofCzP ? (
        <AddCofCzP
          close={closeAddCofCzP}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddLawZaswDate2 ? (
        <AddLawZaswDate2
          close={closeAddLawZasw2}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddLawZaswDate3 ? (
        <AddLawZaswDate3
          close={closeAddLawZasw3}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showBinderData ? (
        <AddBinderData
          close={closeBinderData}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showNakZap ? (
        <AddNakZap
          close={closeNakZap}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showSTS ? (
        <AddSTS
          close={() => {
            setShowSTS(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showSTSK ? (
        <AddSTSK
          close={() => {
            setShowSTSK(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showSUP ? (
        <AddSUP
          close={() => {
            setShowSUP(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showGetinSusp ? (
        <AddGetinSusp
          close={closeGetinSusp}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showOpSP ? (
        <AddOpSP
          close={closeOpSP}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showCounterclaim ? (
        <AddCounterClaim
          close={closeCounterClaim}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userName={props.user}
          userPhone={props.userPhone}
          tabIndex={tabIndex}
          team={props.team}
        />
      ) : (
        ""
      )}

      {showAddDate ? (
        <AddDate
          hearingsSheetData={props.hearingsSheetData}
          hearingsData={props.hearingsData}
          courtsData={props.courtsData}
          banksData={props.banksData}
          usersData={props.usersData}
          refreshData={props.refreshData}
          user={props.uData}
          mode={"add"}
          handleOptionChangeClose={closeAddDatePopUp}
          checkPermissions={props.checkPermissions}
          team={props.team}
          tasksTeam2Data={props.tasksTeam2Data}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archDateTeam2={props.hearingsArchTeam2SheetData}
          archTasksTeam2={props.tasksArchTeam2SheetData}
          archTasks={props.tasksArchSheetData}
          place={"client"}
          client={clientsData}
          clients={clientsData}
          clientsSygnData={sygnForClient}
          close={closeAddDatePopUp}
          tabIndex={tabIndex}
          actualSygn={
            getActualSygnForClient() === "brak danych"
              ? ""
              : getActualSygnForClient()
          }
          substitutes={props.substitutesData}
        />
      ) : (
        ""
      )}
      {showAddTask ? (
        <AddTask
          tasksSheetData={props.tasksSheetData}
          usersData={props.users}
          refreshData={props.refreshData}
          user={props.uData}
          tasksTypesData={props.tasksTypesData}
          banksData={props.banksData}
          handleOptionChangeClose={closeAddTaskPopUp}
          checkPermissions={props.checkPermissions}
          courtsData={props.courtsData}
          team={props.team}
          clientsSygnData={sygnForClient}
          tasksTeam2Data={props.tasksTeam2Data}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archDateTeam2={props.hearingsArchTeam2SheetData}
          archTasksTeam2={props.tasksArchTeam2SheetData}
          archTasks={props.tasksArchSheetData}
          place={"client"}
          client={clientsData}
          close={closeAddTaskPopUp}
          tabIndex={tabIndex}
          logClientAction={props.logClientAction}
        />
      ) : (
        ""
      )}
      {showAssignLawyerPopUp ? (
        <ClientAssignLawyerPopup
          close={closeAssignLawyerPopUp}
          clientsSheetData={props.clientsSheetData}
          clientsData={clientsData}
          lawyersData={props.users}
          lawyer={clientsData.client_owner}
          refreshData={props.refreshData}
          user={props.user}
          clientId={props.id}
          logClientAction={props.logClientAction}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showAddPayment ? (
        <AddPayment
          close={closeAddPayment}
          modeAdd={"main"}
          modePlace={"client"}
          clientData={clientsData}
          team={props.team}
        />
      ) : (
        ""
      )}
      {showAddSygnPopUp ? (
        <AddClientSygnPopup
          close={closeAddSygnPopUp}
          refreshData={props.refreshData}
          clientsSygnData={sygnForClient}
          clientsSygnSheetData={props.clientsSygnSheetData}
          user={props.user}
          clientId={props.id}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
          courtsData={props.courtsData}
        />
      ) : (
        ""
      )}
      {showAddClientContact ? (
        <AddClientContactPopUp
          close={closeAddClientContactPopUp}
          refreshData={props.refreshData}
          clientsContactData={props.clientsContactData}
          clientsContactSheetData={props.clientsContactSheetData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          clients={[]}
          mode={"detail"}
          user={props.uData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showSendClientMail ? (
        <SendClientMail
          close={closeSendClientMail}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
        />
      ) : showSendCourtMail ? (
        <SendCourtMail
          close={closeSendCourtMail}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          courtMailAddresses={getCourtMailAddress()}
        />
      ) : showAddLetter ? (
        <AddLetter
          close={closeAddLetter}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          user={props.uData}
          tabIndex={tabIndex}
          team={props.team}
          courtAddress={getCourtAddress()}
          district={clientsData.aSygn.split(" ")[0].replaceAll(" ", "")}
          bankLawOfficeAddress={bankLawOfficeAddress}
        />
      ) : showAddLawsuit ? (
        <AddLawsuit
          close={closeAddLawsuit}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
          district={clientsData.aSygn.split(" ")[0].replaceAll(" ", "")}
          tasksList={tasksForClient}
          bankLawOfficeAddress={bankLawOfficeAddress}
        />
      ) : showAddLetterBank ? (
        <AddLetterBank
          close={closeAddLetterBank}
          refreshData={props.refreshData}
          clientsData={clientsData}
          logClientAction={props.logClientAction}
          userMail={props.userMail}
          userPhone={props.userPhone}
          userName={props.user}
          tabIndex={tabIndex}
          team={props.team}
          district={clientsData.aSygn.split(" ")[0].replaceAll(" ", "")}
          tasksList={tasksForClient}
          bankLawOfficeAddress={bankLawOfficeAddress}
        />
      ) : (
        ""
      )}
      {showAddClientNote ? (
        <AddClientNote
          close={closeAddClientNote}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showEditBankLawyer ? (
        <EditBankLawyer
          close={closeEditBankLawyer}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showEditPelnSub ? (
        <EditPelnSub
          close={closeEditPelnSub}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
          userName={props.user}
        />
      ) : (
        ""
      )}
      {showEditBankLawOffice ? (
        <EditBankLawOffice
          close={closeEditBankLawOffice}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showAmmountA ? (
        <AddAmmountA
          close={() => {
            setShowAmmountA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showTitleA ? (
        <AddTitleA
          close={() => {
            setShowTitleA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showKomorA ? (
        <AddKomorA
          close={() => {
            setShowKomorA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showNakDateA ? (
        <AddNakDateA
          close={() => {
            setShowNakDateA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showRodzPostA ? (
        <AddRodzPostA
          close={() => {
            setShowRodzPostA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showConEpuA ? (
        <AddConEpu
          close={() => {
            setShowConEpuA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showLogEpuA ? (
        <AddLogEpu
          close={() => {
            setShowLogEpuA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showWnpwuA ? (
        <AddWnpwuA
          close={() => {
            setShowWnpwuA(false);
            getData();
          }}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showEditOdpPozw ? (
        <EditOdpPozw
          close={closeEditOdpPozw}
          refreshData={props.refreshData}
          clientsData={clientsData}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showEditClientAdditionalData ? (
        <EditClientAdditionalData
          close={closeEditAdditionalData}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}

      {showEditRozCase ? (
        <EditClientRozCase
          close={closeEditRozCase}
          logClientAction={props.logClientAction}
          client={clientsData}
          user={props.user}
          users={props.users}
          tabIndex={tabIndex}
        />
      ) : (
        ""
      )}
      {showLawsuitChecklist ? (
        <LawsuitCheckList
          close={() => {
            setShowLawsuitChecklist(false);
            getData();
          }}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
          user={props.uData}
          users={props.users}
          finalChecker={
            tasksForClient.filter(
              (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
            ).length > 0
              ? tasksForClient.filter(
                  (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
                )[0].responsible
              : "Aleksandra Płudowska"
          }
        />
      ) : (
        ""
      )}
      {showLawsuitChecklistView ? (
        <LawsuitCheckListView
          close={() => {
            setShowLawsuitChecklistView(false);
            getData();
          }}
          logClientAction={props.logClientAction}
          client={clientsData}
          tabIndex={tabIndex}
          user={props.uData}
          users={props.users}
          finalChecker={
            tasksForClient.filter(
              (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
            ).length > 0
              ? tasksForClient.filter(
                  (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
                )[0].responsible
              : "a.pludowska@kppp.pl"
          }
        />
      ) : (
        ""
      )}
      {showLeadPopUp ? (
        <>
          <LeadPopUp
            close={closeLeadPopUp}
            lead={leadC[0]}
            logLeadAction={props.logLeadAction}
            user={props.uData}
            generateAnalysis={props.generateAnalysis}
            view="client"
          />
        </>
      ) : (
        ""
      )}
      {!showLeadPopUp &&
      !showEditPW &&
      !showEditDW &&
      !showEditPP &&
      !showEditPSP &&
      !showEditBO &&
      !showEditDZ &&
      !showEditDG &&
      !showEditZP &&
      !showEditZZ &&
      !showEditPU &&
      !showEditRep &&
      !showEditWPS &&
      !showEditNadPLN &&
      !showEditNadCHF &&
      !showEditLawsuitDate &&
      !showSygnPopUp &&
      !showPaymentReport &&
      !showAddClient &&
      !showAddClientQuestionnaire &&
      !showDate &&
      !showTask &&
      !showAddDate &&
      !showAddTask &&
      !showEditBankLawyer &&
      !showEditBankLawOffice &&
      !showEditOdpPozw &&
      !showLawsuitChecklist &&
      !showLawsuitChecklistView ? (
        <>
          <div className="mainContainerDatePopUp">
            {loading ? (
              <Loading id="popUpLoading" />
            ) : (
              <>
                <div className="closeBox">
                  <button className="closeClientButton" onClick={props.close}>
                    X
                  </button>
                </div>

                <div className="paymentMenuContainer">
                  <span className="client_popup_title">
                    {clientsData.petitioner}{" "}
                    {props.team === 0 ? <> - zespół {clientsData.team} </> : ""}
                  </span>
                </div>
                <div className="paymentMenuContainer">
                  {false ? (
                    <button
                      style={{
                        backgroundColor: "#006d00",
                        color: "white",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowAddClientContactPopUp}
                    >
                      Dodaj informacje do pozwu
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    style={{
                      backgroundColor: "#be8c3d",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={showAddTaskPopUp}
                  >
                    Dodaj zadanie
                  </button>
                  <button
                    style={{
                      backgroundColor: "#8c6d34",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={showAddDatePopUp}
                  >
                    Dodaj rozprawę
                  </button>
                  <button
                    style={{
                      backgroundColor: "#876487",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddClientContactPopUp}
                  >
                    Dodaj kontakt z klientem
                  </button>
                  <button
                    style={{
                      backgroundColor: "#3d533d",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSendFile}
                  >
                    Dodaj plik
                  </button>
                  <button
                    style={{
                      backgroundColor: "rgb(221, 195, 54)",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddPayment}
                  >
                    Dodaj płatność
                  </button>
                  <button
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSendClientMail}
                  >
                    Wysyłka maila
                  </button>
                  <button
                    style={{
                      backgroundColor: "lightblue",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowSendCourtMail}
                  >
                    Wysyłka maila do sądu
                  </button>
                  <button
                    style={{
                      backgroundColor: "blue",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddLetter}
                  >
                    Wygeneruj pismo
                  </button>
                  <button
                    style={{
                      backgroundColor: "navy",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    onClick={handleShowAddLetterBank}
                  >
                    Wygeneruj wezwanie do banku
                  </button>
                  {true ? (
                    <button
                      style={{
                        backgroundColor: "gray",
                        color: "white",
                        borderColor: "white",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      onClick={handleShowAddLawsuit}
                    >
                      Wygeneruj pozew
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="paymentMenuContainer">
                  {props.checkPermissions("akceptacjaSprawy") &&
                  clientsData.accepted === "no" ? (
                    <>
                      <button
                        style={{
                          backgroundColor: "#00bdce",
                          color: "white",
                          borderColor: "white",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        onClick={acceptCase}
                      >
                        Akceptuj sprawę
                      </button>
                    </>
                  ) : (
                    <>
                      <span className="highlight_green">
                        SPRAWA ZOSTAŁA ZAAKCEPTOWANA
                      </span>
                    </>
                  )}
                </div>

                <div className="desktopFilters">{tabsDesktop}</div>
                <div className="mobileFilters">{tabsMobile}</div>

                <div className="desktopFilters">{buttons}</div>
                <div className="mobileFilters">
                  <div className="buttLead">{buttonsMobile}</div>
                </div>

                <div className="idSystem">
                  ID SPRAWY W SYSTEMIE: {clientsData.id}
                </div>
                {false ? (
                  <button
                    style={{
                      backgroundColor: "rgb(0, 189, 206)",
                      color: "white",
                      borderColor: "white",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="all"
                    onClick={handleShowAddClient}
                  >
                    EDYTUJ
                  </button>
                ) : (
                  ""
                )}
              </>
            )}
          </div>

          <>
            <div style={{ display: "none" }}>
              {expandFilters ? (
                <div id="deatilClientsBox" className="detailFilters">
                  <div className="titleBox" id="tbClients">
                    <button
                      id="closeHideTbClients"
                      className="collapseButton"
                      onClick={handleExpandFiltersClick}
                    >
                      X
                    </button>
                  </div>
                  <div className="filtersBox">
                    <div id="hideFunClients" className="paymentMenuContainer">
                      <button
                        id="specialClients"
                        className="paymentMenuButton"
                        onClick={handleShowAddClientContactPopUp}
                      >
                        Zadania
                      </button>
                      <button
                        id="specialClients"
                        className="paymentMenuButton"
                        onClick={handleShowAddClientContactPopUp}
                      >
                        Rozprawy
                      </button>
                      <button
                        id="specialClients"
                        className="paymentMenuButton"
                        onClick={handleShowAddClientContactPopUp}
                      >
                        Kontakty z klientem{" "}
                      </button>
                      <button
                        id="specialClients"
                        className="paymentMenuButton"
                        onClick={handleShowAddClientContactPopUp}
                      >
                        Płatności
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <button
                    id="eBClients"
                    className="expandButton"
                    onClick={handleExpandFiltersClick}
                  >
                    FUNKCJE DODATKOWE
                  </button>
                </>
              )}
            </div>
          </>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default ClientPopUp;
